import { ref } from 'vue'
import router from '../router/index'

const detailDataList = ref(
    [
        {
            pageName: "SKY机型",
            dataId: "1-2-1",
            data: {
                routerList: ["产品", "无人机", "SKY机型"],
                topImg: require("../assets/img/drone/ScenarioCard-1.png"),
                topFont: [
                    { fontSize: 'normal', value: "SKY机型" },
                ],
                content: [
                    { type: 'title', value: 'SKY机型 无人机' },
                    { type: 'text', value: 'SKY机型是一款高性能无人机，专为专业航拍和工业应用设计。搭载先进的飞控系统和高清摄像头，支持多种智能飞行模式，为用户提供稳定、精准的飞行体验。' },
                    { type: 'bigTitle', value: '产品特点' },
                    { type: 'text', value: '(1)高清航拍：配备4K超高清摄像头，支持120fps慢动作拍摄' },
                    { type: 'text', value: '(2)智能避障：采用多传感器融合技术，实现全方位智能避障' },
                    { type: 'text', value: '(3)长续航：采用高密度锂电池，续航时间可达45分钟' },
                    { type: 'text', value: '(4)精准定位：支持GPS+北斗双模定位，定位精度可达厘米级' },
                    { type: 'text', value: '(5)智能跟拍：支持目标识别和自动跟拍功能' },
                    { type: 'text', value: '(6)防水设计：IP43级防水，适应复杂天气环境' },
                    { type: 'bigTitle', value: '应用场景' },
                    { type: 'text', value: '专业航拍、影视制作、测绘勘探、电力巡检、农业植保、应急救援' },
                ]
            }
        }, {
            pageName: "FLY机型",
            dataId: "1-2-2",
            data: {
                routerList: ["产品", "无人机", "FLY机型"],
                topImg: require("../assets/img/drone/flydrone.png"),
                topFont: [
                    { fontSize: 'normal', value: "FLY机型" },
                ],
                content: {
                    sections: [
                        {
                            title: "核心优势",
                            description: "面向巡检作业、室内巡查、安防巡逻与行业定制场景，FLY以全包围防护结构、轻量化机身和稳定飞控能力，帮助用户在复杂空间中更安全、更灵活地完成近距离飞行任务。",
                            image: require("../assets/img/product/flydrone1.webp"),
                            features: [
                                {
                                    title: "紧凑机身",
                                    description: "适合空间相对受限、障碍物较多或人员设备密集的巡查环境。机身采用紧凑一体化设计，整体占用空间小，便于在通道、机房、仓储、园区等复杂场景中灵活部署，有助于提升近距离巡查和狭窄区域作业的适应能力。"
                                },
                                {
                                    title: "轻量化结构",
                                    description: "通过结构减重与部件集成，降低携带、转运和现场部署门槛。轻量化设计便于现场人员快速完成任务准备，减少临时巡查、应急排查和移动巡逻中的设备负担，提高多场景连续作业的便利性。"
                                },
                                {
                                    title: "稳定飞行",
                                    description: "围绕飞控算法、动力匹配、姿态控制和传感器标定进行综合优化，提升低速巡查、悬停观察、路径飞行和近距离任务中的稳定表现。可在复杂空间中保持平稳姿态，为图像采集、目标观察和巡检判断提供更可靠的飞行基础。"
                                },
                                {
                                    title: "便捷维护",
                                    description: "面向行业客户长期使用需求，强调易拆装、易检查、易更换的结构思路。关键部件便于日常巡检和快速维护，有助于降低备件管理和现场维修难度，提升设备在连续巡查任务中的恢复效率和使用可靠性。"
                                }
                            ]
                        },
                        {
                            title: "行业定制",
                            description: "八比特科技深耕算法端侧轻量化落地，专注各类边缘芯片的算法深度移植与极致剪裁优化，依托本地化算力完成全链路数据运算，无需依托云端算力支撑，在嵌入式边缘部署优化领域具备核心技术优势。",
                            image: require("../assets/img/product/flydrone2.webp"),
                            features: [
                                {
                                    title: "硬件平台",
                                    description: "围绕飞控板、PCB、接口资源、传感器接入、BMS、电源保护、EMC与抗干扰等核心环节构建稳定硬件基础，支持多类型任务载荷与外设扩展，提升整机运行可靠性和行业场景适配能力。"
                                },
                                {
                                    title: "智能软件",
                                    description: "支持 RTOS / Linux 系统适配，覆盖姿态控制、航点任务、返航保护、目标识别和日志诊断等关键功能。通过软件算法与任务逻辑协同优化，提升飞行控制精度、任务执行效率和异常处理能力。"
                                },
                                {
                                    title: "整机集成",
                                    description: "提供从样机开发、软硬件联调、场景验证到可靠性测试的整机集成服务，并配套交付文档和维护说明。帮助客户缩短研发验证周期，实现从方案设计到产品落地的高效衔接。"
                                },
                                {
                                    title: "场景定制",
                                    description: "面向不同行业任务需求，支持任务流程设计、数据采集配置、算法处理优化、地面站展示和平台系统对接。可根据巡检、安防、仓储、应急等应用场景进行定制化开发，提升实际部署价值。"
                                }
                            ]
                        }
                    ]
                }
            }
        }, {
            pageName: "LARK机型",
            dataId: "old1-2-3",
            data: {
                routerList: ["产品", "无人机", "LARK机型"],
                topImg: require("../assets/img/drone/ScenarioCard-1.png"),
                topFont: [
                    { fontSize: 'normal', value: "LARK机型" },
                ],
                content: [
                    { type: 'title', value: 'LARK机型 无人机' },
                    { type: 'text', value: 'LARK机型是一款超小型口袋无人机，专为日常记录和社交分享设计。小巧精致，功能强大，让随时随地记录精彩瞬间成为可能。' },
                    { type: 'bigTitle', value: '产品特点' },
                    { type: 'text', value: '(1)超小体积：折叠后仅手掌大小，轻松放入口袋' },
                    { type: 'text', value: '(2)智能拍摄：支持AI场景识别和智能构图' },
                    { type: 'text', value: '(3)一键分享：支持实时分享到社交平台' },
                    { type: 'text', value: '(4)高清画质：配备高清摄像头，支持HDR拍摄' },
                    { type: 'text', value: '(5)智能防抖：采用三轴机械云台，拍摄更稳定' },
                    { type: 'text', value: '(6)快速充电：支持快充技术，充电时间短即可飞行' },
                    { type: 'bigTitle', value: '应用场景' },
                    { type: 'text', value: '日常记录、社交分享、美食拍摄、宠物记录、旅行Vlog' },
                ]
            }
        },{
            pageName: "智能飞控系统",
            dataId: "1-2-3",
            data: {
                routerList: ["产品", "无人机", "智能飞控系统"],
                topImg: require("../assets/img/drone/IFControlSystem.png"),
                topFont: [
                    { fontSize: 'normal', value: "智能飞控系统" },
                ],
                content: [
                    { type: 'title', value: '智能飞控系统 无人机' },
                    { type: 'text', value: '八比特科技智能飞控系统面向无人机平台的飞行控制与任务执行需求，支持飞行姿态控制、导航定位融合、航线与任务管理、通信与数据交互、安全保护机制以及任务载荷扩展等核心能力。系统通过对飞行状态、环境信息、任务指令和设备状态的统一感知与协同管理，可实现无人机从起飞、巡航、作业执行到返航降落的全过程智能化控制，保障飞行过程稳定、安全、高效。' },
                    { type: 'text', value: '在任务应用层面，智能飞控系统可与地面站、云平台、智能识别算法以及行业业务系统深度协同，构建“飞行控制—任务执行—数据采集—智能分析—结果回传”的完整闭环。系统不仅能够满足无人机基础飞行控制需求，还可根据不同作业场景进行功能拓展和业务适配，帮助客户快速构建面向行业应用的无人机智能化解决方案。' },
                    
                    { type: 'bigTitle', value: '产品特点' },
                    { type: 'image', src: require("../assets/img/drone/IFControlSystem-2.png") },
                    { type: 'midTitle', value: '| 稳定可靠' },
                    { type: 'text', value: '系统围绕无人机飞行控制的核心环节进行设计，重点关注姿态稳定、航迹保持、定位精度、异常响应和飞行安全等关键能力。通过对飞行状态的实时监测与控制策略优化，系统能够在复杂环境和多任务场景下保持良好的飞行稳定性，有效提升无人机作业过程中的安全性、连续性和可靠性，满足巡检、测绘、安防、应急等多类场景对稳定飞行的要求。' },
                    { type: 'midTitle', value: '| 模块化设计' },
                    { type: 'text', value: '系统采用模块化架构设计，飞行控制、任务管理、通信交互、载荷控制、安全保护等功能模块边界清晰，可根据不同机型平台、任务载荷配置和行业应用需求进行灵活组合。该设计方式便于客户进行功能裁剪、平台扩展和后续维护升级，同时也有利于缩短研发周期，提升系统适配效率，为无人机产品的系列化开发和规模化应用提供支撑。' },
                    { type: 'midTitle', value: '| 多场景适配' },
                    { type: 'text', value: '智能飞控系统可面向电力巡检、能源巡查、城市安防、应急救援、测绘建模、农业监测、生态巡护、科研验证等多种应用场景进行功能配置。系统可根据不同作业流程、飞行环境和任务目标，支持航线规划、定点巡航、区域覆盖、载荷联动、数据回传等能力扩展，帮助客户构建具有行业特色的差异化无人机应用方案。' },
                    { type: 'midTitle', value: '| 易于集成' },
                    { type: 'text', value: '系统具备良好的开放性和兼容性，可与地面站、云平台、智能识别算法、行业业务系统及多类型任务载荷进行对接。通过标准化接口和灵活的数据交互机制，系统能够实现飞行控制、任务执行、数据采集、结果分析和业务平台联动，形成从前端飞行作业到后端数据应用的完整闭环能力，提升无人机系统在实际项目中的集成效率和应用价值。' },
                    { type: 'midTitle', value: '| 支持二次开发' },
                    { type: 'text', value: '面向无人机整机厂商、行业集成商、科研院所及应用开发团队，系统支持接口适配、功能裁剪、算法集成、载荷联调和系统级开发服务。客户可基于实际项目需求进行二次开发和定制化扩展，降低无人机平台从研发验证到行业落地的技术门槛和实施成本，提升产品迭代效率和项目交付能力。' },
                    
                    { type: 'bigTitle', value: '应用场景' },
                    { type: 'image', src: require("../assets/img/drone/IFControlSystem-3.png") },
                    { type: 'midTitle', value: '| 场景覆盖' },
                    { type: 'text', value: '八比特科技智能飞控系统可广泛应用于电力线路巡检、油气管线巡查、城市公共安全、应急救援指挥、地形测绘建模、农业植保与长势监测、生态环境巡护、科研教学验证等场景。依托稳定可靠的飞行控制能力和灵活开放的任务扩展能力，系统能够帮助客户提升无人机作业效率，降低人工巡检和现场作业成本，增强复杂环境下的数据获取能力和任务执行能力。' },
                    { type: 'midTitle', value: '| 任务覆盖' },
                    { type: 'text', value: '在行业应用中，系统可根据不同业务目标配置飞行策略、任务流程和载荷联动方式，使无人机从单一飞行平台升级为具备任务感知、数据采集、智能协同和业务联动能力的空中作业单元，为客户实现智能化、数字化、无人化作业提供可靠支撑。' },
                    
                    { type: 'bigTitle', value: '技术优势' },
                    { type: 'image', src: require("../assets/img/drone/IFControlSystem-4.png") },
                    { type: 'midTitle', value: '| 产品交付' },
                    { type: 'text', value: '八比特科技长期专注于智能技术研发和行业智能化解决方案建设，在无人机智能飞控系统方向具备嵌入式软件开发、系统架构设计、智能算法融合、通信链路对接、平台适配调试和工程化交付等综合能力。' },
                    { type: 'midTitle', value: '| 需求化定制' },
                    { type: 'text', value: '公司可围绕客户实际应用需求，提供从方案论证、系统设计、软件开发、硬件适配、算法集成到飞行测试验证的完整技术支持。通过成熟的工程实施经验和灵活的定制化能力，八比特科技能够帮助客户提升无人机系统研发效率，增强产品稳定性与可扩展性，加快无人机智能化应用在行业场景中的落地。' },
                    
                    { type: 'bigTitle', value: '服务内容' },
                    { type: 'image', src: require("../assets/img/drone/IFControlSystem-5.png") },
                    { type: 'midTitle', value: '| 服务范围' },
                    { type: 'text', value: '八比特科技可围绕客户项目需求，提供智能飞控系统方案设计、飞控软件开发、无人机平台适配、任务载荷集成、通信链路对接、地面站与云平台联调、智能算法接入、飞行测试验证以及后续维护升级等服务。' },
                    { type: 'midTitle', value: '| 定制服务' },
                    { type: 'text', value: '在项目实施过程中，八比特科技可根据客户的机型平台、载荷类型、任务流程和行业应用目标，提供定制化技术支持与系统联调服务，帮助客户构建稳定、安全、可靠、可扩展的无人机智能飞控系统。通过从研发到交付的全流程服务能力，助力客户降低平台开发难度，提升项目落地效率，打造面向多场景应用的无人机智能化解决方案。' },
                ]
            }
        }, {
            pageName: "飞控电调",
            dataId: "1-2-4",
            data: {
                routerList: ["产品", "无人机", "飞控电调"],
                topImg: require("../assets/img/drone/ScenarioCard-1.png"),
                topFont: [
                    { fontSize: 'normal', value: "飞控电调" },
                ],
                content: [
                    { type: 'title', value: '飞控电调系统' },
                    { type: 'text', value: '飞控电调是无人机的核心控制系统，负责飞行姿态控制、电机驱动和动力分配。采用先进的控制算法和高效功率器件，为无人机提供稳定、精准的飞行控制。' },
                    { type: 'bigTitle', value: '产品特点' },
                    { type: 'text', value: '(1)高精度控制：采用高性能处理器，控制频率极高' },
                    { type: 'text', value: '(2)智能算法：支持PID控制、模糊控制等多种控制算法' },
                    { type: 'text', value: '(3)高效驱动：采用高效MOSFET，效率极高' },
                    { type: 'text', value: '(4)多重保护：支持过流、过压、过温、堵转等多重保护' },
                    { type: 'text', value: '(5)快速响应：响应时间极短，飞行更敏捷' },
                    { type: 'text', value: '(6)可编程：支持固件升级和参数调节' },
                    { type: 'bigTitle', value: '技术参数' },
                    { type: 'text', value: '输入电压：支持多档锂电池\n输出电流：持续电流大/峰值电流更高\n控制频率：极高\n重量：轻量化设计\n尺寸：紧凑型设计' },
                ]
            }
        }, {
            pageName: "接收机",
            dataId: "1-2-5",
            data: {
                routerList: ["产品", "无人机", "接收机"],
                topImg: require("../assets/img/drone/ScenarioCard-1.png"),
                topFont: [
                    { fontSize: 'normal', value: "接收机" },
                ],
                content: [
                    { type: 'title', value: '无线接收机' },
                    { type: 'text', value: '无线接收机是无人机遥控系统的核心部件，负责接收遥控器的控制信号并传输给飞控系统。采用先进的无线通信技术，确保控制信号的稳定传输。' },
                    { type: 'bigTitle', value: '产品特点' },
                    { type: 'text', value: '(1)长距离传输：传输距离远' },
                    { type: 'text', value: '(2)低延迟：延迟时间极短，响应更及时' },
                    { type: 'text', value: '(3)抗干扰：采用跳频技术，抗干扰能力强' },
                    { type: 'text', value: '(4)多通道：支持多通道控制' },
                    { type: 'text', value: '(5)双天线：支持双天线接收，信号更稳定' },
                    { type: 'text', value: '(6)兼容性强：支持多种遥控器协议' },
                    { type: 'bigTitle', value: '技术参数' },
                    { type: 'text', value: '工作频率：2.4GHz\n传输距离：远距离传输\n通道数：多通道\n延迟：极低延迟\n重量：轻量化设计\n尺寸：紧凑型设计' },
                ]
            }
        }, {
            pageName: "数字图传",
            dataId: "1-2-6",
            data: {
                routerList: ["产品", "无人机", "数字图传"],
                topImg: require("../assets/img/drone/ScenarioCard-1.png"),
                topFont: [
                    { fontSize: 'normal', value: "数字图传" },
                ],
                content: [
                    { type: 'title', value: '数字图传系统' },
                    { type: 'text', value: '数字图传系统是无人机的视频传输核心，负责将摄像头拍摄的高清视频实时传输到地面设备。采用先进的数字压缩和无线传输技术，确保视频的高质量传输。' },
                    { type: 'bigTitle', value: '产品特点' },
                    { type: 'text', value: '(1)高清传输：支持高清视频传输' },
                    { type: 'text', value: '(2)低延迟：视频延迟极低' },
                    { type: 'text', value: '(3)长距离：传输距离远' },
                    { type: 'text', value: '(4)抗干扰：采用自适应跳频技术，抗干扰能力强' },
                    { type: 'text', value: '(5)多设备：支持多设备同时观看' },
                    { type: 'text', value: '(6)低功耗：功耗低，续航更持久' },
                    { type: 'bigTitle', value: '技术参数' },
                    { type: 'text', value: '分辨率：高清\n传输距离：远距离\n延迟：极低\n工作频率：5.8GHz\n重量：轻量化设计\n尺寸：紧凑型设计' },
                ]
            }
        },
        // ========== 新增产品-技术方案页面 ==========
        {
            pageName: "企业智能数字化方案",
            dataId: "old1-3-1",
            data: {
                // 复制自原来的“智慧俱乐部”（enterprise-1）
                routerList: ["产品", "技术方案", "企业智能数字化方案"],
                topImg: require("../assets/img/banner2.jpg"),
                topFont: [
                    { fontSize: 'normal', value: "企业智能数字化方案" },
                ],
                content: [
                    { type: 'title', value: '智慧俱乐部解决方案' },
                    { type: 'text', value: '智慧俱乐部解决方案利用物联网、大数据、人工智能等先进技术，将俱乐部的会员管理、场地预订、设备管理、活动组织等各个方面进行智能化升级，打造便捷、高效、智能的现代化俱乐部管理平台。' },
                    { type: 'bigTitle', value: '核心功能' },
                    { type: 'text', value: '(1)会员管理：会员注册、会员等级、积分管理、会员权益，提升会员粘性。' },
                    { type: 'text', value: '(2)场地预订：在线预订、实时查看、智能排期、自动结算，提升场地利用率。' },
                    { type: 'text', value: '(3)设备管理：设备预约、设备维护、设备监控、设备统计，延长设备寿命。' },
                    { type: 'text', value: '(4)活动组织：活动发布、活动报名、活动签到、活动评价，提升活动效果。' },
                    { type: 'text', value: '(5)数据分析：会员分析、场地分析、活动分析、收入分析，辅助决策。' },
                    { type: 'text', value: '(6)智能支付：在线支付、会员卡支付、二维码支付，便捷支付体验。' },
                    { type: 'bigTitle', value: '应用场景' },
                    { type: 'text', value: '健身俱乐部、羽毛球俱乐部、网球俱乐部、游泳俱乐部、高尔夫俱乐部、乒乓球俱乐部' },
                ]
            }
        },
        {
            pageName: "智能视觉技术方案",
            dataId: "old1-3-3",
            data: {
                routerList: ["产品", "技术方案", "智能视觉技术方案"],
                topImg: require("../assets/img/banner3.webp"),
                topFont: [
                    { fontSize: 'normal', value: "智能视觉技术方案" },
                ],
                content: [
                    { type: 'title', value: '智能视觉技术方案' },
                    { type: 'text', value: '我们提供专业的图形图像技术解决方案，涵盖2D/3D渲染、图像处理、计算机视觉等领域，帮助客户构建高性能、高画质的图形图像应用。' },
                    { type: 'bigTitle', value: '核心服务' },
                    { type: 'text', value: '(1)实时渲染引擎开发：基于OpenGL/Vulkan/DirectX的跨平台渲染引擎定制。' },
                    { type: 'text', value: '(2)图像处理算法：图像增强、去噪、超分辨率、风格迁移等。' },
                    { type: 'text', value: '(3)三维重建：基于多视图或深度相机的三维重建技术。' },
                    { type: 'text', value: '(4)AR/VR应用开发：增强现实、虚拟现实交互系统开发。' },
                    { type: 'bigTitle', value: '应用场景' },
                    { type: 'text', value: '车载仪表可视化、医疗影像处理、工业检测、游戏开发、虚拟仿真' },
                ]
            }
        },
        {
            pageName: "智能医疗与智慧医院",
            dataId: "old1-3-2",
            data: {
                routerList: ["产品", "技术方案", "智能医疗与智慧医院"],
                topImg: require("../assets/img/banner3.webp"),
                topFont: [
                    { fontSize: 'normal', value: "智能医疗与智慧医院" },
                ],
                content: [
                    { type: 'title', value: '智能医疗与智慧医院（HIS）' },
                    { type: 'text', value: '智能医疗与智慧医院是现代化医院运营的核心支撑平台，覆盖挂号、收费、药房、住院、病历、检验、影像等全业务流程，实现医疗数据的互联互通和医院资源的优化配置。' },
                    { type: 'bigTitle', value: '核心功能' },
                    { type: 'text', value: '(1)门诊管理：挂号、分诊、医生工作站、收费、药房发药。' },
                    { type: 'text', value: '(2)住院管理：入院登记、床位管理、医嘱处理、费用结算。' },
                    { type: 'text', value: '(3)电子病历：结构化病历模板、病历质控、病程记录、医嘱录入。' },
                    { type: 'text', value: '(4)检验系统（LIS）：检验申请、样本采集、报告审核、结果查询。' },
                    { type: 'text', value: '(5)影像系统（PACS）：影像存储、调阅、三维重建、远程会诊。' },
                    { type: 'bigTitle', value: '应用场景' },
                    { type: 'text', value: '综合医院、专科医院、社区医院、诊所、体检中心' },
                ]
            }
        },
        {
            pageName: "智能座舱",
            dataId: "1-1-1",
            data: {
                routerList: ["产品", "智能汽车", "智能座舱"],
                topImg: require("../assets/img/smart_cockpit.webp"),   // 可保留原图
                topFont: [{ fontSize: 'normal', value: "智能座舱" }],
                content: {
                    sections: [
                        {
                            title: "全场景多屏交互",
                            description: "智能座舱的交互中心正从一块屏幕扩展为一套高度协同的智能生态系统。八比特科技基于多年经验积累，实现了从硬件底层到上层应用的完整覆盖，让每个座位都拥有便捷的人机交互。",
                            image: require("../assets/img/product/cockpit1.webp"),
                            features: [
                                {
                                    title: "多屏融合与独立交互",
                                    description: "我们研发的智能座舱方案融合了全液晶数字仪表、中控信息娱乐系统、副驾及后排娱乐屏等在内的全套屏幕系统。其中，数字仪表搭载高度定制化操作系统，支持专业化图形引擎，具备快速开机、图像精细、界面可灵活配置等特点。为了满足不同车型的定制需求，我们的方案广泛适配多款主流芯片平台。"
                                },
                                {
                                    title: "智能中控交互平台",
                                    description: "作为座舱的核心交互枢纽，智能车机采用全触控设计，已在各尺寸、各车型屏幕上积累了丰富的前装量产经验。系统搭载多核处理器，算力强劲，支持百余款第三方应用下载和OTA远程升级，确保功能持续进化。结合我们定制优化的Android、Linux、QNX、HarmonyOS各操作系统，用户可以通过极为流畅的触控、语音或方向盘控制，轻松实现3D导航、实时路况查询、移动办公、在线音乐等一系列丰富服务。"
                                },
                                {
                                    title: "后排影音娱乐",
                                    description: "针对后排乘客，我们提供后座娱乐系统，支持与前排屏幕的内容无缝流转和独立控制。后排成员可以自主点播视频、音乐，或调节独立的空调温区与座椅功能，让长途旅行不再枯燥。通过我们的手机互联技术，乘客甚至可以将手机内容便捷地投射到后座屏幕上，分享旅途精彩。"
                                },
                                {
                                    title: "手机互联与投影",
                                    description: "我们深度适配了Apple CarPlay、Android Auto等主流手机互联方案，实现了手机与车机的双向无缝操控。与此同时，驾驶员无需低头，通过抬头显示系统就能在前挡风玻璃上清晰获取时速、导航指引、剩余电量等关键行车信息，大大提升了驾驶安全性与科技感。"
                                }
                            ]
                        },
                        {
                            title: "AI智能体交互",
                            description: "智能座舱的魅力在于它能提供有温度的交互。八比特科技将集成的智能语音引擎与多模态感知技术融入座舱，使车辆不再是一个冰冷的工具。",
                            image: require("../assets/img/product/cockpit2.webp"),
                            features: [
                                {
                                    title: "全场景语音助手",
                                    description: "座舱语音助手支持免唤醒词与唤醒词两种交互方式。在日常驾驶中，你可以直接用自然语言让它完成导航设定、音乐切换、拨打电话等操作；在复杂场景下，唤醒词指令通过云端处理，响应更精准。语音系统支持多国语言输入和随时打断或唤醒，并且可根据不同车厂的品牌调性快速定制语音风格与技能。"
                                },
                                {
                                    title: "多模态交互的协同",
                                    description: "除了语音，我们的系统还支持手势识别和方向盘物理按键控制。例如通过左右滑动或悬浮手势完成歌曲切换、音量调节；通过方向盘按键盲操作，在便利的同时减少了视线转移带来的分心风险，全面提升驾驶安全。"
                                }
                            ]
                        },
                        {
                            title: "场景智能与情感关怀",
                            description: "人们对座舱的期待已超越了基础的代步通勤，更希望车辆成为一个能感知并服务自己情绪与场景的“智慧伙伴”。八比特科技致力于帮助整车厂打造这种有温度的产品。",
                            image: require("../assets/img/product/cockpit3.webp"),
                            features: [
                                {
                                    title: "场景智能引擎",
                                    description: "基于强大的软硬件集成能力，我们能够为用户定制丰富的一键场景模式。例如开启小憩模式后，主驾座椅将自动调整至最舒适的角度，空调切换为外循环并保持微风，同时中控屏播放舒缓的自然白噪音；启动亲子模式则可一键锁定后排车窗、开启后排屏幕的儿童内容专区。这些场景可高度自定义，联动座椅、空调、灯光、香氛与多媒体，打造沉浸式氛围。"
                                },
                                {
                                    title: "主动式关怀",
                                    description: "通过组合驾驶员监测系统等感知技术，座舱能够精准捕捉驾乘者的状态。当识别到用户有打哈欠、频繁眨眼等疲劳迹象时，系统会主动调大空调风量、播放提神音乐，并通过语音适时发出休息区建议或咖啡店推荐。这种无微不至的主动关怀，让每一次出行都更加安心。"
                                }
                            ]
                        },
                        {
                            title: "舱驾融合与无缝流转",
                            description: "真正的智能不是功能的堆砌，而是基于强大底层架构的有机融合。",
                            image: require("../assets/img/product/cockpit4.webp"),
                            features: [
                                {
                                    title: "一芯多屏与跨屏联动",
                                    description: "八比特科技提供基于SOA架构的智能座舱解决方案，通过高性能芯片的算力共享，打破传统仪表、中控、副驾屏之间的信息孤岛。用户可以将导航地图、视频播放等内容，通过简单流畅的拖拽手势，在仪表屏、中控大屏、副驾屏之间自由流转，实现无缝的泛娱乐化体验。"
                                },
                                {
                                    title: "软硬协同与极速响应",
                                    description: "我们的智能座舱方案深度覆盖了从系统底层（Android、Linux、QNX、HarmonyOS、Hypervisor虚拟化）到上层应用的完整软件栈，有效减少了客户在开发、调试和验证阶段的周期。这使得系统启动更快、交互响应更及时，在保障功能安全的同时，为用户带来顺滑不卡顿的极致操作体验。配合5G车载通信模块，更可实现高清视频的秒开与低延迟投屏，让车内空间实时在线。"
                                }
                            ]
                        }
                    ]
                }
            }
        }, {
            pageName: "智能交互产品",
            dataId: "old-1-1-2",
            data: {
                routerList: ["产品", "智能座舱系统", "智能交互产品"],
                topImg: require("../assets/img/banner3.webp"),
                topFont: [
                    // { fontSize: 'small', value: "智能交互产品" },
                    { fontSize: 'normal', value: "智能交互产品" },
                ],
                content: [
                    { type: 'title', value: '智能数字仪表' },
                    { type: 'text', value: '搭载 Renesas RH850 高性能车规级处理器，以 160MHz 至 240MHz 多核架构，为智能座舱注入强劲动力。5MB 超大 Flash 与 512KB RAM 组合，通过KanZi工具，支持复杂 UI 渲染、多任务并行处理及实时数据交互，从容应对智能驾驶辅助、导航娱乐等多元场景。' },
                    { type: 'image', src: require("../assets/img/product/product2.png") },
                    { type: 'title', value: '智能IVI中控娱乐系统解决方案' },
                    { type: 'text', value: '基于高通 SA8155P QNX+AndroidHypervisor 平台，为客户提供了基于 Kanzi 的中控及车模车控设计开发的解决方案。通过适配Android 12操作系统，包括文字、视觉、声觉、触觉和动作等交互方式的集成，涵盖多媒体、收音、蓝牙、互联等多个功能模块的 HMI、APP 以及中间件开发。支持安卓或自有应用，打造车企专属服务，实现数字共享。使功能满足日渐提高的用户需求。' },
                    { type: 'image', src: require("../assets/img/product/product3.png") },
                    { type: 'title', value: '有线/无线Carplay和Android Auto解决方案' },
                    { type: 'text', value: '通过 USB 或 Wi-Fi 与车机系统建立通信，支持语音控制、地图导航、音乐播放、短信、电话等功能。适配蓝牙5.0+和WiFi，满足Apple和Google产品认证。' },
                    {
                        type: 'twoImage', count: 2,
                        srcList: [
                            { name: null, src: require("../assets/img/product/product4.png") },
                            { name: null, src: require("../assets/img/product/product5.png") },]
                    },
                ]
            }
        }, {
            pageName: "智慧健康汽车",
            dataId: "old-1-1-3",
            data: {
                routerList: ["产品", "智能座舱系统", "智慧健康汽车"],
                topImg: require("../assets/img/banner3.webp"),
                topFont: [
                    // { fontSize: 'small', value: "智慧健康汽车" },
                    // { fontSize: 'normal', value: "智慧健康汽车" },
                    { fontSize: 'normal', value: "智慧健康汽车" },
                ],
                content: [
                    { type: 'title', value: '智慧健康汽车' },
                    { type: 'text', value: '(1)智能穿戴联动，驾驶员健康体征监测提醒；DMS疲劳监测：驾驶员健康状态与车辆控制策略联动。' },
                    { type: 'text', value: '(2)空气质量管理：针对空气污染实时检测，联动空调主动净化；可配置香氛系统，支持香氛种类、浓度智能切换。' },
                    { type: 'text', value: '(3)声学健康管理：ANC主动降噪：多麦克风阵列+反向声波抵消技术，车内噪音降低；个性化声场：基于驾驶员耳廓特征的3D音效补偿算法，降低驾驶疲劳指数。' },
                    { type: 'image', src: require("../assets/img/product/product6.png") },
                ]
            }
        }, {
            pageName: "智能驾驶",
            dataId: "1-1-2",
            data: {
                routerList: ["产品", "智能汽车", "智能驾驶"],
                topImg: require("../assets/img/banner3.webp"),
                topFont: [
                    { fontSize: 'normal', value: "智能驾驶" },
                ],
                content: {
                    sections: [
                        {
                            title: "DMS｜驾驶员监测系统",
                            description: "DMS 驾驶员监测系统面向智能座舱与主动安全场景，通过车内摄像头、红外补光、AI视觉识别算法以及车身状态信号融合，实现对驾驶员状态的实时感知、精准判断与主动预警。系统可持续监测驾驶员面部特征、眼部状态、头部姿态、视线方向、驾驶行为与异常动作，及时识别疲劳驾驶、分心驾驶、闭眼、打哈欠、低头、打电话、吸烟、长时间视线偏离、双手脱离方向盘等高风险行为。相比传统被动安全配置，DMS 更强调“事前预防”。当系统检测到驾驶员存在安全风险时，可通过仪表提示、中控弹窗、语音提醒、蜂鸣报警、方向盘震动等多种方式进行分级预警，帮助驾驶员及时恢复注意力，降低交通事故发生概率。同时，DMS 还可与 ADAS 辅助驾驶系统、座舱域控制器、车联网平台、车队管理平台联动，实现更完整的智能安全闭环。",
                            image: require("../assets/img/product/product9.png"),
                            features: [
                                {
                                    title: "疲劳驾驶识别",
                                    description: "系统可通过眼睛闭合频率、眨眼持续时间、打哈欠动作、头部点头、面部状态变化等特征，判断驾驶员是否处于疲劳状态。一旦发现驾驶员长时间闭眼、频繁打哈欠或注意力下降，系统会及时发出提醒，减少因疲劳导致的追尾、偏航和碰撞风险。"
                                },
                                {
                                    title: "分心驾驶监测",
                                    description: "DMS 可识别驾驶员低头看手机、视线长时间离开前方、扭头交谈、操作中控过久等分心行为。系统结合车速、行驶状态和驾驶员视线方向进行综合判断，在关键时刻提醒驾驶员关注道路环境。"
                                },
                                {
                                    title: "危险行为检测",
                                    description: "系统支持识别打电话、吸烟、喝水、异常姿态、遮挡面部、离岗等行为，适用于乘用车、商用车、物流车、公交车、出租车、网约车等多种场景。对于运营车辆，系统还可将异常事件上传至后台，便于企业进行安全管理和风险追溯。"
                                },
                                {
                                    title: "驾驶员身份识别",
                                    description: "通过人脸识别能力，DMS 可识别不同驾驶员身份，实现车辆权限管理、个性化座椅/后视镜/空调/娱乐系统设置加载，也可用于车队驾驶员考勤、授权驾驶、防止非授权人员用车等场景。"
                                },
                                {
                                    title: "智能座舱交互",
                                    description: "DMS 不仅用于安全预警，还可作为智能座舱感知入口。系统可结合驾驶员视线、表情、状态与行为，实现更自然的人机交互，例如视线唤醒、疲劳关怀、情绪感知、个性化推荐等，提升车辆智能化体验。"
                                }
                            ]
                        },
                        {
                            title: "AVM｜全景环视系统",
                            description: "AVM 全景环视系统面向泊车辅助、低速行驶、窄路通行、复杂路况感知等场景，通过安装在车辆前、后、左、右的多路广角摄像头，实时采集车辆周边图像，并经过图像畸变矫正、视角转换、图像拼接、标定融合和3D建模处理，在车机屏幕上生成车辆周围 360° 鸟瞰视图或三维环视画面。系统能够帮助驾驶员直观看清车辆四周盲区，准确判断车身与障碍物、行人、非机动车、车位线、路沿、墙体和其他车辆之间的距离关系，有效解决传统后视镜和倒车影像存在的视野盲区问题。尤其在倒车入库、侧方停车、狭窄道路会车、地下车库通行、复杂城市道路低速行驶等场景中，AVM 可显著提升驾驶安全性和操作便利性。",
                            image: require("../assets/img/product/product10.png"),
                            features: [
                                {
                                    title: "360°全景鸟瞰显示",
                                    description: "系统将车身四周摄像头画面进行拼接融合，形成车辆周边的俯视视角，让驾驶员像从空中俯瞰车辆一样掌握周围环境，减少盲区带来的误判。"
                                },
                                {
                                    title: "3D环视显示",
                                    description: "AVM 可支持三维车辆模型与环境画面融合展示，驾驶员可切换不同视角查看车辆周边情况，例如前视、后视、左视、右视、自由旋转视角等，提升视觉体验和空间感知能力。"
                                },
                                {
                                    title:"泊车辅助",
                                    description:"在倒车、入库、侧方停车等场景中，系统可辅助显示车位线、轨迹线、障碍物位置和车辆行驶路径，帮助驾驶员更轻松完成泊车操作，降低剐蹭风险。"
                                },
                                {
                                    title:"低速行驶辅助",
                                    description:"在狭窄道路、拥堵路段、地下车库、坡道、急弯、施工区域等环境中，AVM 可实时显示车辆四周动态画面，帮助驾驶员判断车辆边界和周边障碍物，提升低速通行安全。"
                                },
                                {
                                    title:"盲区监测与障碍物提示",
                                    description:"系统可结合视觉算法识别周围行人、车辆、路沿、锥桶、墙体等目标，并可与超声波雷达、毫米波雷达等传感器融合，实现障碍物距离提示和风险预警。"
                                },
                                {
                                    title:"透明底盘与行车记录扩展",
                                    description:"AVM 可扩展透明底盘功能，通过历史图像融合显示车辆下方路面信息，帮助驾驶员通过坑洼、石块、台阶、复杂路面等区域。同时，系统还可结合行车记录、哨兵模式、远程查看等功能，提升车辆安全防护能力。"
                                }
                            ]
                        }
                    ]
                }
            }
        }, {
            pageName: "智能驾驶",
            dataId: "old1-1-2",
            data: {
                routerList: ["产品", "智能汽车", "智能驾驶"],
                topImg: require("../assets/img/banner3.webp"),
                topFont: [
                    // { fontSize: 'small', value: "AUTOSAR解决方案" },
                    // { fontSize: 'normal', value: "AUTOSAR解决方案" },
                    { fontSize: 'normal', value: "智能驾驶" },
                ],
                content: [
                    { type: 'title', value: 'AUTOSAR解决方案' },
                    { type: 'text', value: '全栈开发服务：双平台覆盖&模块化工具链。' },
                    { type: 'text', value: '国产化方案：适配普华ORIENTAIS AUTOSAR工具链，联合紫光国微、智芯科技打造RISC-V架构MCU解决方案，关键模块自主可控率100%，适配国产芯片生态需求。' },
                    { type: 'text', value: '国际化方案：适配Davinci AUTOSAR工具，为客户提供标准的 AUTOSAR CP/AP设计，降低开发与维护成本。' },
                    { type: 'image', src: require("../assets/img/product/product7.png") },
                ]
            }
        },
        {
            pageName: "行业智能数字化解决方案",
            dataId: "1-3-1",
            data: {
                routerList: ["产品", "技术方案", "行业智能数字化解决方案"],
                topImg: require("../assets/img//product/resolution.webp"),
                topFont: [{ fontSize: 'normal', value: "行业智能数字化解决方案" }],
                content: {
                    sections: [
                        {
                            title: "政务数字化平台",
                            description: "积极响应“放管服”改革与“互联网+政务”政策要求，八比特科技为社保、医保、公积金等公共服务领域搭建一体化、智能化的政务数字化平台。",
                            image: require("../assets/img//product/resolution2.webp"),
                            features: [
                                {
                                    title: "社保信息管理系统",
                                    description: "系统覆盖参保登记、缴费核算、待遇发放、异地结算、资格认证、基金监管等全业务流程，基于微服务架构与数据中台，将养老、医疗、失业、工伤、生育五大险种的公共能力抽取为统一服务，实现“一次登录、全险种办理”。运用AI图像识别与自然语言处理技术，实现业务智能审核、风险预警与异常监测，构建防重复参保、防骗保的规则引擎。打通公安、民政、税务等多部门数据链路，形成经办、管理、风控、决策的完整闭环。同时通过“掌上社保”App、微信小程序及社区自助服务终端，支持参保查询、待遇资格人脸识别认证、关系转移申请等高频业务全程网办，切实提升经办效率与群众办事体验。"
                                },
                                {
                                    title: "一网通办与数据共享",
                                    description: "支持电子证照库建设、跨部门数据共享交换与一网通办平台搭建，采用国产分布式数据库与等保三级安全部署，确保系统在高并发场景下的稳定运行与数据安全。"
                                }
                            ]
                        },
                        {
                            title: "智慧金融",
                            description: "聚焦金融机构数字化转型需求，依托大数据、智能算法、云计算等技术，提供全价值链智慧金融解决方案，覆盖信贷风控、反欺诈、智能客服、数据中台与监管报送等核心场景。",
                            image: require("../assets/img//product/resolution3.webp"),
                            features: [
                                {
                                    title: "零售信贷智能风控平台",
                                    description: "整合行内数据（征信、流水、公积金）及第三方数据（税务、社保、运营商），构建超过2000个特征变量，基于XGBoost与逻辑回归融合模型输出信用评分、欺诈评分与额度建议，审批决策时间缩短至秒级。构建关系网络图谱，实时识别团伙欺诈与多头借贷行为，贷后通过行为评分卡滚动监控与智能催收策略分群，提前发现逾期风险并推荐最佳催收方式。"
                                },
                                {
                                    title: "智慧证券与智慧保险",
                                    description: "智慧证券方面，提供策略研究、量化交易、实时行情分析与智慧风控的全流程赋能。智慧保险方面，以专属平台为载体，为从业者提供客户管理、保单整理、需求挖掘、智能展业等一站式工具，同时搭建统一风控与数据平台，助力金融机构实现产品、服务、风控的全面智能化升级。"
                                },
                                {
                                    title: "模型全生命周期管理与监管报送",
                                    description: "实现模型版本管理、线上监控、自动重训练与A/B测试，确保风控模型持续有效。自动化生成银保监会要求的1104报表、EAST报表等，内置校验逻辑，大幅提升报送效率与准确率。"
                                }
                            ]
                        },
                        {
                            title: "智慧场馆",
                            description: "以SaaS云端架构为核心，融合数字孪生、物联网与AI视觉技术，打造场馆及教培机构一站式智慧运营解决方案。",
                            image: require("../assets/img//product/resolution4.webp"),
                            features: [
                                {
                                    title: "智能运营管理",
                                    description: "覆盖招生报名、课程管理、排课考勤、订单合同、学员服务等全场景，采用模块化设计与可视化操作界面，实现多端协同管理，支持数据批量处理与智能分析，直观呈现运营核心指标。具备精细化权限管控、数据加密备份、云端自动迭代等优势，有效降低运营成本。"
                                },
                                {
                                    title: "数字孪生与智慧运维",
                                    description: "对场馆群进行毫米级3D建模，实时映射设备状态、人流密度与环境参数。为空调、照明、大屏等设备加装IoT传感器，基于人流预测与活动日程自动优化供能策略，建立设备故障预测模型实现主动预警。部署AI摄像头实时统计区域人数与密度，当局部密度超过阈值时自动推送预警并推荐疏导路线。"
                                },
                                {
                                    title: "智能票务与数据运营",
                                    description: "支持实名电子票与人脸识别闸机联动，大幅提升入场通行效率。分析观众入场、消费与停留热区数据，为商铺招商、广告位定价提供数据支撑，提升场馆商业价值。"
                                }
                            ]
                        },
                        {
                            title: "企业智能化数字化建设与转型",
                            description: "为制造业、能源、物流等各类企业提供从顶层设计到落地交付的全流程数字化转型服务。",
                            image: require("../assets/img//product/resolution5.webp"),
                            features: [
                                {
                                    title: "工业物联网平台",
                                    description: "支持百种工业协议，实现设备数据毫秒级采集、边缘处理与云端汇聚，打通OT与IT的数据链路。"
                                },
                                {
                                    title: "生产执行系统",
                                    description: "从工单排程、工序报工、质量检验到设备管理，构建闭环车间数字化体系，实现生产透明化与管理精细化。"
                                },
                                {
                                    title: "数据中台与智能分析",
                                    description: "提供元数据管理、数据治理、可视化ETL，以及基于时序数据和关系数据的预测模型，支持故障预警、质量预测、能耗优化等应用场景。"
                                },
                                {
                                    title: "数字孪生与3D可视化",
                                    description: "将物理世界映射为虚拟场景，叠加实时数据与模拟仿真，支持远程运维与应急演练。整体方案涵盖信息化基础建设与智能化升级两大核心，协助企业搭建统一数据平台、实现业务流程线上化与系统集成，同时通过AI赋能、数据驱动决策与自动化运营优化业务模式，提供转型咨询、技术选型、落地实施与运维保障全流程支撑。"
                                }
                            ]
                        },
                        {
                            title: "典型案例",
                            description: "",
                            features: [
                                {
                                    title: "某城市社保信息管理系统升级",
                                    description: "为覆盖800万参保人员的地市人社局建设新一代社保系统，基于微服务架构与数据中台实现五大险种统一办理，打通8个部门数据链路。上线后关系转移接续从15个工作日缩短至即时办结，线上可办率达85%，月均线上办理超30万笔。"
                                },
                                {
                                    title: "某大型体育中心智慧场馆改造",
                                    description: "为35万平方米的体育中心打造“数字孪生+智慧票务+智慧运维”一体化平台。大型活动入场排队从55分钟降至12分钟，场馆能耗下降23%，设备故障响应时间从30分钟降至5分钟。"
                                },
                                {
                                    title: "某城商行零售信贷智能风控平台",
                                    description: "为2000亿资产规模的城商行搭建覆盖贷前、贷中、贷后的智能风控平台。审批时效从2-3天压缩至平均45秒，欺诈识别准确率提升至92%，首年拦截欺诈申请约1.2万笔，贷后逾期率相对下降28%。"
                                }
                            ]
                        }
                    ]
                }
            }
        },{
        pageName: "智能医疗与智慧医院",
        dataId: "1-3-2",
        data: {
            routerList: ["产品", "技术方案", "智能医疗与智慧医院"],
            topImg: require("../assets/img//product/hospital1.webp"),
            topFont: [{ fontSize: 'normal', value: "智能医疗与智慧医院" }],
            content: {
                sections: [
                    {
                        title: "医疗器械智能化",
                        description: "",
                        image: require("../assets/img//product/hospital2.webp"),
                        features: [
                            {
                                title: "磁共振成像技术方案",
                                description: "八比特科技深耕磁共振成像系统的智能化改造，将AI、深度学习与电子信息技术深度融合，打造高效、精准的磁共振成像技术方案。方案兼容高场、超高场磁共振设备，优化梯度功率放大与射频技术，结合智能深度重建算法，大幅提升图像信噪比与分辨率，清晰呈现人体解剖细节与病变特征，同时实现扫描速度提升与静音优化，改善患者检查体验。方案可适配神经、心脏、盆腔等多部位扫描需求，为疾病早期筛查、精准诊断及疗效随访提供强有力的技术支撑，助力国产高端磁共振装备产业化发展。"
                            },
                            {
                                title: "彩超图形图像处理与算法",
                                description: "聚焦彩超设备智能化升级，八比特科技研发高性能彩超图形图像处理与算法解决方案，将大数据与人工智能技术融入彩超成像全流程。通过希尔伯特变换、对数压缩等信号处理技术，提取超声回波中的有效信息，结合图像增强算法优化画面对比度与清晰度，精准呈现组织结构与血流状态；依托自相关技术实现血流方向、速度的精准识别与彩色编码，助力医护人员快速捕捉病变信号。方案支持多类型彩超设备适配，可根据临床需求定制算法模型，提升彩超诊断的精准度与效率。"
                            },
                            {
                                title: "血液分析仪",
                                description: "针对体外诊断领域需求，八比特科技打造智能化血液分析仪解决方案，融合微流控、图像识别、AI算法等前沿技术，实现血液样本的快速、精准检测。方案优化样本处理流程，采用高精度成像与计数算法，可精准量化白细胞、红细胞等血液成分浓度，有效抵抗黄疸、脂血等干扰因素，保障检测结果的可靠性；支持样本自动加载、试剂冷藏保鲜等功能，简化操作流程，适配临床常规检测与现场检测等多场景需求。"
                            }
                        ]
                    },
                    {
                        title: "智慧医院信息化",
                        description: "",
                        image: require("../assets/img//product/hospital3.webp"),
                        features: [
                            {
                                title: "医院信息管理系统",
                                description: "八比特科技搭建一体化医院信息管理系统，以患者为中心、以诊疗流程为主线，实现医院管理与临床诊疗的全流程信息化覆盖。系统整合门诊、住院、检验、药房等核心模块，打通院内各科室信息壁垒，实现患者信息、诊疗数据、药品信息的集中管理与实时共享；联动区域公共卫生、医保、药品监管等外部系统，实现院内外信息高效交互，支持医保异地结算、基金审计、药品追溯等功能。通过智能化数据抓取与分析，为医院管理决策提供数据支撑，优化就医流程、减少人工失误，提升医院管理效率与医疗服务质量。"
                            },
                            {
                                title: "移动护理与床旁交互",
                                description: "以“让护士少跑腿，让医生更专注，让患者更安全”为设计理念，为临床一线提供移动护理系统与床旁交互终端。护士通过PDA完成腕带扫描“三查七对”、护理措施即时记录与检验报告实时查询；患者通过床旁平板即可查询费用明细、观看健康宣教、在线点餐与视频呼叫护士。护理任务智能排程根据患者风险评估等级自动生成个性化任务列表，按优先级推送到护士终端，确保护理工作精准高效。"
                            }
                        ]
                    },
                    {
                        title: "医疗物联网",
                        description: "八比特科技构建覆盖感知层、平台层、应用层的完整医疗物联网体系，以软硬一体的自研能力为智慧病房提供端到端解决方案。",
                        image: require("../assets/img//product/hospital4.webp"),
                        features: [
                            {
                                title: "生命体征自动采集",
                                description: "为病床配备医用级智能腕带，连续监测心率、血氧、血压、体温等生命体征，数据自动上传至护理看板和电子病历。异常值触发三级报警机制——腕带震动提示患者、护士站弹窗提醒、护士长手机通知——确保突发情况第一时间得到响应。"
                            },
                            {
                                title: "智能输液监护",
                                description: "每张病床加装非接触式输液传感器，实时监测剩余液量与滴速。液量低于阈值时，护士站大屏自动显示床号与预计剩余时间，同时通过护士手环振动提醒，从根本上解决“换液不及时导致回血”的临床痛点。"
                            },
                            {
                                title: "患者安全管理",
                                description: "在老年病科、骨科等高跌倒风险区域部署毫米波雷达设备，识别离床超时、姿态异常、长时间滞留卫生间等场景并推送报警。同时提供患者防走失系统，为认知障碍患者提供实时定位与电子围栏保护。"
                            },
                            {
                                title: "资产定位与管理",
                                description: "为全院移动医疗设备粘贴蓝牙定位标签，护士通过App即可查看监护仪、输液泵、轮椅等设备的实时位置并一键导航，大幅缩短设备寻回时间。"
                            }
                        ]
                    },
                    {
                        title: "典型案例",
                        description: "",
                        features: [
                            {
                                title: "某三甲医院智慧病房全覆盖项目",
                                description: "为1800张开放床位的大型三甲医院部署涵盖生命体征自动采集、智能输液监护、防跌倒毫米波雷达、设备蓝牙定位的完整智慧病房方案。上线后护士非护理工作时长降低42%，住院跌倒发生率下降65%，输液相关不良事件降至零，床旁呼叫响应时间从3.2分钟缩短至48秒，患者满意度从76%提升至93.5%。"
                            }
                        ]
                    }
                ],
            }
        }
    },{
        pageName: "智能视觉技术方案",
        dataId: "1-3-3",
        data: {
            routerList: ["产品", "技术方案", "智能视觉技术方案"],
            topImg: require("../assets/img//product/view.webp"),
            topFont: [{ fontSize: 'normal', value: "智能视觉技术方案" }],
            content: {
                sections: [
                    {
                        title: "全栈算法模型库",
                        description: "八比特科技自研了覆盖主流视觉任务的算法模型库，所有模型均支持客户自有数据快速微调。",
                        features: [
                            {
                                title: "目标检测与跟踪",
                                description: "基于YOLOv5/v8/v10、RT-DETR等先进架构，适配工业缺陷检测、安全穿戴识别、车辆结构化等场景。针对小目标检测增加专用检测头，引入注意力机制增强弱对比特征表达，配合数据增强与难例挖掘，模型验证mAP可达97%以上。"
                            },
                            {
                                title: "图像分类与语义分割",
                                description: "支持产品分类、场景识别、缺陷区域分割等任务，为工业质检和安防监控提供精细化的像素级分析能力。"
                            },
                            {
                                title: "OCR与异常检测",
                                description: "覆盖文本识别、条码读取、表面异常检测等场景，适配制造、金融、政务等领域的标准化需求。"
                            },
                            {
                                title: "姿态估计",
                                description: "支持人体关键点检测与行为分析，适用于安全生产、体育训练等场景。"
                            }
                        ]
                    },
                    {
                        title: "多平台嵌入式适配",
                        description: "八比特科技擅长将算法模型深度优化至各类边缘芯片平台，不依赖云端，以端侧极致优化见长。",
                        features: [
                            {
                                title: "已适配平台",
                                description: "瑞芯微RK3588/RK3568/RV1126、全志V系列、晶晨Amlogic、NVIDIA Jetson（TX2/NX/Orin）、海思Hi35xx、地平线旭日、寒武纪等主流AI芯片。"
                            },
                            {
                                title: "推理框架深度优化",
                                description: "精通TensorRT、Tengine、MNN、RKNN等边缘推理框架，擅长模型量化至int8、算子融合、面向NPU微架构的内存复用优化。以RK3588平台为例，YOLOv8模型单帧推理延迟可优化至15ms以内，满足产线实时检测需求。"
                            }
                        ]
                    },
                    {
                        title: "软硬一体视觉产品",
                        description: "八比特科技提供从硬件到软件的一体化交付，支持客户按需定制。",
                        image: require("../assets/img//product/view2.webp"),
                        features: [
                            {
                                title: "标准智能摄像头",
                                description: "覆盖200万至800万像素，支持定制光学镜头与补光设计，适配不同场景的环境光照条件。"
                            },
                            {
                                title: "AI边缘计算盒",
                                description: "自研边缘计算设备，算力覆盖4至32TOPS，支持-20℃至70℃宽温与无风扇设计，已在多家工厂的粉尘、振动环境下稳定运行。"
                            },
                            {
                                title: "双目深度相机",
                                description: "支持三维感知与测量，适用于机器人导航、体积测量等场景。"
                            },
                            {
                                title: "训练与部署平台",
                                description: "提供一站式数据标注工具（支持主动学习）、模型训练流水线（基于TensorFlow/PyTorch/PaddlePaddle），以及完整的边缘端推理框架支持，支持远程OTA更新模型。"
                            }
                        ]
                    },
                    {
                        title: "典型案例",
                        description: "",
                        features: [
                            {
                                title: "锂电池极片表面缺陷检测系统",
                                description: "为国内头部动力电池企业开发基于边缘AI的在线视觉检测系统，采用双8K线扫相机+组合光源方案，在RK3588边缘计算盒上部署改进型YOLOv8模型，完全替代人工目检。上线后检测速度匹配产线60m/min，缺陷检出率从92%提升至99.8%，因缺陷导致的电池报废率降低67%。"
                            }
                        ]
                    }
                ]
            }
        }
    },{
            pageName: "智能驾驶视觉系统",
            dataId: "old-1-2-2",
            data: {
                routerList: ["产品", "智能驾驶系统", "智能驾驶视觉系统"],
                topImg: require("../assets/img/banner3.webp"),
                topFont: [
                    // { fontSize: 'small', value: "AUTOSAR解决方案" },
                    // { fontSize: 'normal', value: "AUTOSAR解决方案" },
                    { fontSize: 'normal', value: "智能驾驶视觉系统" },
                ],
                content: [
                    { type: 'title', value: '智能驾驶视觉系统' },
                    { type: 'bigTitle', value: 'AVM全景环视纯视觉感知系统' },
                    { type: 'text', value: '利用车身四周摄像头，拼接出以车身为中心的360°环视画面，直接鸟瞰车身周边情况。支持多种车型，采用4路（前后左右）摄像头方案。\nAVM算法消除畸变与色偏，支持曲面场景智能修正算法，确保画面精准还原。采用双核运算架构实现画质与效能的动态优化，智能适应复杂环境需求。方案成本较传统方案降低40%以上，特别适合经济型及主流中端车型规模化搭载。' },
                    { type: 'smallTitle', value: '产品优势' },
                    { type: 'text', value: '（1）成熟高效的视觉与影像处理技术，能平衡不同光线下的图像、无视摄像头倾角，提供更清晰真实的全景图像。\n（2）灵活适配多种车型。算法能够稳定运行，提供流畅的实时拼接效果视频。\n（3）算法识别精度表现出色，经大量场景数据训练，覆盖用例全面，运行稳定、健壮性强。' },
                    { type: 'bigTitle', value: 'CMS电子后视镜系统' },
                    { type: 'text', value: '通过安全可定制的软件方案与高性能硬件深度协同，实现全场景全天候可靠视觉感知，以软硬一体化创新重塑智能驾驶视觉体验。' },
                    { type: 'smallTitle', value: '产品优势' },
                    { type: 'text', value: '（1）高清流媒体后视镜是运用先进的实景显示技术，通过安装在车辆后部的全高清无畸变微光夜视广角全玻璃摄像头，将车身后方影像显示在后视镜显示大屏上，大广角摄像头可视角度达到传统后视镜的3倍以上，可视范围更远。\n（2）附加高清行车记录功能，远离碰瓷，清晰记录每一个行车瞬间。不仅可以遏止交通违章、约束驾驶员不良驾驶习惯,而且可以有效地预防道路交通事故的发生,并为执法人员进行事故的分析、处理提供科学、忠实的原始数据。\n（3）可以避免传统后视镜的视野和不同环境造成的盲区，例如雨雾天气、雪地等环境。' },
                    { type: 'smallTitle', value: '产品参数' },
                    { type: 'image', src: require("../assets/img/product/product8.png") },
                    { type: 'bigTitle', value: 'DMS驾驶员监测系统' },
                    { type: 'text', value: '通过自主研发的多模态感知技术，实时监测驾驶员疲劳、分心及情绪波动等风险状态。同步分析面部微表情、眼球轨迹、方向盘操作等数据维度，当检测到潜在危险时，可智能触发分级预警机制（声光提示/语音交互）或联动车辆主动安全系统，有效预防事故发生。方案通过国际ADDW认证标准，助力厂商快速构建符合海外市场准入要求的智能驾驶能力。' },
                    { type: 'bigTitle', value: '疲劳驾驶检测' },
                    { type: 'text', value: '对驾驶员脸部、眼部、体态等细节特征进行智能分析，帮助准确识别是否存在疲劳驾驶。可结合车速（一般默认车速＞20KM/h）、连续驾驶时长（交通法规定驾驶时长超过4小时要停车休息）、驾驶时间段（午后、夜间和凌晨是疲惫高发期）等维度，定义出疲劳监测等级报警策略，如：轻度疲劳、中度疲劳、高度疲劳，便于在不同的商用车使用场景下应用。' },
                    { type: 'bigTitle', value: '分心检测' },
                    { type: 'text', value: '行车过程中（一般默认车速＞20KM/h），当驾驶员出现分心的情况，诸如玩手机、找东西、回头聊天等行为，会触发系统报警提示。' },
                    { type: 'bigTitle', value: '危险驾驶检测' },
                    { type: 'text', value: '当行车过程中当驾驶员出现吸烟、接打电话等危险行为情况，会触发系统报警。' },
                    { type: 'bigTitle', value: '摄像头遮挡检测' },
                    { type: 'text', value: '对摄像头画面进行实时检测，当出现一定范围内的视频遮挡、黑屏等镜头异常情况时，触发摄像头遮挡预警。' },
                ]
            }
        }, {
            pageName: "行泊一体解决方案",
            dataId: "old-1-2-3",
            data: {
                routerList: ["产品", "智能驾驶系统", "行泊一体解决方案"],
                topImg: require("../assets/img/banner3.webp"),
                topFont: [
                    // { fontSize: 'small', value: "AUTOSAR解决方案" },
                    // { fontSize: 'normal', value: "AUTOSAR解决方案" },
                    { fontSize: 'normal', value: "行泊一体解决方案" },
                ],
                content: [
                    { type: 'title', value: '行泊一体解决方案' },
                    { type: 'text', value: "行泊一体解决方案以 “智行慧停” 为核心理念，通过融合感知、决策与控制技术，将行车辅助与泊车功能深度整合。系统搭载多模态传感器（激光雷达、高清摄像头、毫米波雷达），构建全域环境感知网络，实时捕捉道路动态与车位信息，实现从高速巡航、城市跟车到自动泊入 / 驶出的全场景覆盖。\n\n算法层面，基于 AI 大模型优化路径规划，兼顾行车安全与泊车效率，支持跨楼层记忆泊车、异型车位识别等复杂场景。硬件端采用域控制器集成方案，减少线束冗余，降低能耗与故障率。云端平台提供数据闭环服务，通过 OTA 持续迭代策略，适配多样化用车需求。\n\n该方案可显著提升驾驶体验，缩短停车耗时 30% 以上，降低剐蹭风险，同时为车企节省 20%+ 研发成本，加速智能座舱向 “零操作” 目标迈进。" },
                    { type: 'text', value: '(1)高速领航：自动变道超车、匝道通行（支持高精地图/无图模式）。\n(2)记忆泊车：通过低速自动驾驶技术，实现在限定区域（园区、地上停车场及地下停车场等场景）的自主代客泊车功能。' },
                ]
            }
        }, {
            pageName: "车路云协同控制",
            dataId: "old-1-2-4",
            data: {
                routerList: ["产品", "智能驾驶系统", "车路云协同控制"],
                topImg: require("../assets/img/banner3.webp"),
                topFont: [
                    { fontSize: 'normal', value: "车路云协同控制" },
                ],
                content: [
                    { type: 'title', value: '车路云协同控制' },
                    { type: 'text', value: '车路云协同控制通过 “车端感知 + 路侧基建 + 云端算力” 三位一体架构，构建智能交通生态闭环。车端搭载高算力芯片与多传感器融合系统，实时采集车辆状态与周边环境数据；路侧部署毫米波雷达、边缘计算单元等设备，补全车端感知盲区，精准捕捉道路事件（如事故、施工）；云端依托 AI 算法与数字孪生技术，整合全域交通流信息，生成最优决策指令。\n\n三者通过 5G-V2X 低时延通信协议实时交互，实现超视距预警、协同式红绿灯优化、编队自动驾驶等场景应用。例如，路侧设备提前感知拥堵并上传云端，系统动态调整车端行驶路径；或在极端天气下，云端下发高精度地图辅助车辆避险。该方案有效提升通行效率 30% 以上，降低交通事故率，推动交通系统从 “单车智能” 迈向 “全局智控”，为智慧城市建设夯实底层架构。' },
                    { type: 'text', value: '(1)边缘计算单元（RSU）：支持C-V2X直连通信，红绿灯状态推送精度99%。\n(2)云端仿真平台：每日百万公里级场景测试，ODD场景库覆盖中国特有工况。' },
                ]
            }
        }, {
            pageName: "特种车辆解决方案",
            dataId: "old-1-2-5",
            data: {
                routerList: ["产品", "智能驾驶系统", "特种车辆解决方案"],
                topImg: require("../assets/img/banner3.webp"),
                topFont: [
                    { fontSize: 'normal', value: "特种车辆解决方案" },
                ],
                content: [
                    { type: 'title', value: '特种车辆解决方案' },
                    { type: 'text', value: '特种车辆解决方案以专业化、定制化为核心，针对工程抢险、医疗救护、警用消防等场景需求，构建 “硬件适配 + 智能管控 + 安全防护” 三位一体体系。硬件端集成模块化设备，如工程车搭载液压破拆系统、救护车配备负压隔离舱，满足特殊作业功能需求；智能管控层通过车载终端与指挥中心实时联动，支持任务调度、路径规划及远程监控；安全防护方案融合主动避障雷达、盲区监测与紧急制动系统，保障作业安全。\n\n系统兼容多通信协议，实现跨部门数据互通，配合 AI 算法优化资源调配效率。例如消防场景下，车辆可自动规划火情路线，同步传输现场影像至指挥中心；医疗转运中，车载生命体征监测数据实时上传医院。该方案显著提升特种作业响应速度与执行精度，助力行业高效履职与应急处置。' },
                    { type: 'text', value: 'DMS驾驶员监测系统、BSD商用车盲区监测、工程机械高精度作业辅助。' },
                ]
            }
        }, {
            pageName: "智能网联",
            dataId: "1-1-3",
            data: {
                routerList: ["产品", "智能汽车", "智能网联"],
                topImg: require("../assets/img/banner5.png"),
                topFont: [
                    { fontSize: 'normal', value: "智能网联" },
                ],
                content: {
                    sections: [
                        {
                            title: "V2X | 核心能力",
                            description: "V2X是车辆与外部交通参与要素进行信息交互的关键技术，通常包括 V2V、V2I、V2P、V2N 等通信类型。通过车端、路侧、网络和云平台之间的实时协同，V2X能够突破单车感知边界，为智能驾驶、交通安全预警、车路云协同和智慧交通应用提供关键通信支撑。",
                            image: require("../assets/img/product/product11.png"),
                            features: [
                                {
                                    title: "V2V 车车协同",
                                    description: "车辆之间实时共享速度、位置、行驶方向、制动状态等关键数据，帮助车辆提前识别周边交通风险，支持碰撞预警、紧急制动提醒、协同变道等智能驾驶场景。"
                                },
                                {
                                    title: "V2I 车路协同",
                                    description: "车辆与路侧单元、信号灯、摄像头、雷达等基础设施互联互通，获取道路状态、交通事件和信号信息，补充单车感知盲区，提升通行安全与效率。"
                                },
                                {
                                    title: "V2P 车人协同",
                                    description: "车辆与行人、骑行者及移动终端进行信息交互，及时识别弱势交通参与者的位置与运动趋势，在复杂路口、盲区和低速场景中增强主动安全能力。"
                                },
                                {
                                    title: "V2N 车网协同",
                                    description: "车辆通过蜂窝网络与云平台、业务系统和运营平台保持连接，支持远程诊断、OTA升级、车队管理、数据服务及云端智能应用的持续运行。"
                                },
                                {
                                    title: "C-V2X适配与联调",
                                    description: "面向车载终端、路侧设备和平台系统提供协议适配、接口联调与场景验证服务，支撑车路云协同项目、车联网平台及V2X应用快速落地。"
                                }
                            ]
                        },
                        {
                            title: "车联网的价值",
                            description: "车联网的价值不只是“连接车辆”，更重要的是通过实时数据交互构建覆盖车端、路端、云端和应用端的协同闭环。它能够提升驾驶安全、优化道路通行效率、改善用户出行体验，并为车辆运营、交通治理和智慧城市建设提供持续的数据支撑。",
                            image: require("../assets/img/product/product12.png"),
                            features: [
                                {
                                    title: "安全价值",
                                    description: "通过车辆、道路、云端等多源信息共享，提前发现超视距风险、盲区风险和突发交通事件，支持碰撞预警、道路危险提醒、行人提醒及异常车辆提醒。"
                                },
                                {
                                    title: "效率价值",
                                    description: "依托车路协同和交通数据分析，优化车辆通行路径与道路资源分配，支持信号灯协同、拥堵提示、路径优化和车队调度，提升整体通行效率。"
                                },
                                {
                                    title: "体验价值",
                                    description: "通过车端与云端服务联动，提升用户在座舱、出行和用车过程中的智能化体验，支持远程控制、车辆状态查询、服务推荐及地图路况联动。"
                                },
                                {
                                    title: "运营价值",
                                    description: "面向车队、平台和运营方构建车辆数据管理能力，实现车辆监控、远程诊断、故障预警、OTA升级和运维管理，降低运营成本并提升管理效率。"
                                },
                                {
                                    title: "治理价值",
                                    description: "为智慧交通和城市管理提供连续、可分析的数据基础，支持交通事件识别、路网运行分析、应急联动和城市级车路云协同治理。"
                                }
                            ]
                        },
                        {
                            title: "车联网生态",
                            description: "车联网生态可概括为“车、路、网、云、应用”的协同体系。车端负责感知、执行与数据采集，路侧负责道路环境补充感知，网络负责低时延可靠传输，云端负责数据、算法和服务管理，应用层则围绕安全、效率、运营和治理形成场景化价值。",
                            image: require("../assets/img/product/product13.png"),
                            features: [
                                {
                                    title: "车端",
                                    description: "覆盖T-BOX、OBU、车机、域控、传感器和车载网关等设备，承担通信接入、数据采集、协议适配和终端软件开发任务，是车联网数据产生与执行的核心入口。"
                                },
                                {
                                    title: "路侧",
                                    description: "包括RSU、摄像头、雷达、信号灯和边缘计算单元等基础设施，负责道路感知、交通信息采集和车路协同应用接入，增强车辆对外部环境的理解能力。"
                                },
                                {
                                    title: "网络",
                                    description: "依托5G、C-V2X直连通信、专网及安全认证体系，构建低时延、高可靠的数据传输链路，支撑车端、路侧设备与平台系统之间稳定协同。"
                                },
                                {
                                    title: "云端",
                                    description: "通过车联网平台、数据中台、业务系统和运维平台，实现设备管理、数据治理、远程诊断、可视化监控和业务服务调度，形成统一云端管理能力。"
                                },
                                {
                                    title: "应用",
                                    description: "围绕安全预警、交通治理、车队运营和智慧出行服务等场景，提供功能开发、系统集成、数据应用和持续迭代能力，将车联网能力转化为业务价值。"
                                }
                            ]
                        },
                        {
                            title: "服务内容与交付能力",
                            description: "八比特科技可根据客户项目阶段，提供从需求分析、方案设计、软件开发、接口适配、系统联调到测试交付的完整服务。通过软件研发能力、汽车电子理解和系统集成交付经验，帮助客户高效推进车联网及智能网联项目落地。",
                            image: require("../assets/img/product/product14.png"),
                            features: [
                                {
                                    title: "方案咨询与需求分析",
                                    description: "围绕车联网业务场景、通信链路、设备接入方式和平台功能边界进行系统梳理，输出需求说明、技术方案和接口清单，为项目实施明确方向。"
                                },
                                {
                                    title: "车端软件与协议适配",
                                    description: "针对T-BOX、OBU、车机、网关等车载设备，完成数据采集、通信接口和协议适配开发，输出车端软件模块、适配说明及接口文档。"
                                },
                                {
                                    title: "平台软件开发",
                                    description: "建设设备管理、车辆数据、远程诊断、OTA升级、告警管理和可视化看板等平台能力，形成稳定可扩展的后台管理系统与业务支撑平台。"
                                },
                                {
                                    title: "V2X与车路云联调",
                                    description: "对接RSU、路侧设备、云平台和交通应用系统，完成端到端接口联调、场景验证和问题闭环，确保车路云协同链路稳定可用。"
                                },
                                {
                                    title: "测试验证与持续支持",
                                    description: "开展功能、性能、稳定性和安全性测试，提供测试报告、用户文档、部署文档及运维支持，保障系统上线后的持续迭代和稳定运行。"
                                }
                            ]
                        },
                        {
                            title: "OTA技术方案 | 产品优势",
                            description: "车载OTA技术方案实现车辆软件远程升级与功能持续迭代，无需到店即可更新ECU、信息娱乐系统及智能驾驶模块。方案支持差分传输、高效校验、安全加密和回滚保护，帮助车企降低维护成本，提升车辆全生命周期的软件管理能力。",
                            image: require("../assets/img/product/product15.png"),
                            features: [
                                {
                                    title: "高并发云平台",
                                    description: "基于自主研发的大数据云计算平台，构建安全稳定的OTA升级架构，支持高并发任务处理和弹性扩展，为大规模车辆在线升级提供可靠支撑。"
                                },
                                {
                                    title: "海量车辆接入",
                                    description: "支持千万级车载设备远程接入，可同时处理1万+车辆并行下载任务，适应不同区域和网络环境下的大规模升级需求，保障升级效率。"
                                },
                                {
                                    title: "整车ECU升级",
                                    description: "覆盖动力、底盘、车身、信息娱乐及智能驾驶等多类ECU模块，实现整车软件统一管理、远程升级和功能持续优化，提升车辆智能化水平。"
                                },
                                {
                                    title: "安全加密防护",
                                    description: "采用国家商用密码算法SM2、SM3、SM4对升级数据进行加密、签名和完整性校验，防止升级包被篡改、伪造或非法访问。"
                                },
                                {
                                    title: "可靠升级机制",
                                    description: "具备断点续传、差分升级、程序回滚和安全校验等机制，在网络中断或升级异常情况下保障任务可恢复，降低升级失败率和车辆使用风险。"
                                },
                                {
                                    title: "优化差分算法",
                                    description: "采用自研差分升级算法并持续迭代优化，生成更小差分包，减少传输流量和升级时间，提升升级效率与用户无感化体验。"
                                },
                                {
                                    title: "双向身份认证",
                                    description: "基于PKI/CA体系实现车辆与服务器之间的双向身份认证，确保通信双方可信，构建覆盖升级全流程的信息安全防护体系。"
                                }
                            ]
                        }
                    ]
                }
            }
        }, {
            pageName: "信息安全体系",
            dataId: "old1-3-2",
            data: {
                routerList: ["产品", "智能网联平台", "信息安全体系"],
                topImg: require("../assets/img/banner3.webp"),
                topFont: [
                    { fontSize: 'normal', value: "信息安全体系" },
                ],
                content: [
                    { type: 'title', value: '信息安全体系' },
                    { type: 'bigTitle', value: '产品优势' },
                    { type: "text", value: "(1)纵深防御架构：云、管、端三重防护体系" },
                    { type: "text", value: "(2)数据安全：采用SM9国密算法加密传输，支持欧盟GDPR/中国个保法合规要求" },
                    { type: "text", value: "(3)终端防护：T-box内置HSM安全芯片，实现安全启动+固件签名校验" },
                    { type: "text", value: "(4)攻击防御：部署AI驱动的入侵检测系统（IDS），日均拦截2,300万次异常访问" },
                    { type: "text", value: "(5)隐私保护：差分隐私技术实现用户轨迹数据匿名化处理，满足CCPA等隐私法规" },
                    { type: "text", value: "(6)应急响应：建立车联网安全实验室，具备0day漏洞24小时快速响应能力" },
                ]
            }
        }, {
            pageName: "全球化服务能力",
            dataId: "old1-3-3",
            data: {
                routerList: ["产品", "智能网联平台", "全球化服务能力"],
                topImg: require("../assets/img/banner3.webp"),
                topFont: [
                    // { fontSize: 'small', value: "AUTOSAR解决方案" },
                    // { fontSize: 'normal', value: "AUTOSAR解决方案" },
                    { fontSize: 'normal', value: "全球化服务能力" },
                ],
                content: [
                    { type: 'title', value: '全球化服务能力' },
                    { type: 'bigTitle', value: '产品优势' },
                    { type: "text", value: "(1)海外合规平台：适配数据隐私法规，支持50+国家TSP接入。" },
                    { type: "text", value: "(2)本地化运营：东南亚右舵车型适配、中东高温环境可靠性方案。" },
                ]
            }
        }, // 在 src/utils/utils.js 的 detailDataList 数组中添加以下内容：
        {
            pageName: "OTA",
            dataId: "tech-1",
            data: {
                routerList: ["产品", "智能技术方案", "OTA"],
                topImg: require("../assets/img/banner3.webp"),
                topFont: [
                    { fontSize: 'normal', value: "OTA 远程升级方案" },
                ],
                content: [
                    { type: 'title', value: 'OTA 远程升级技术' },
                    { type: 'text', value: 'OTA（Over-the-Air Technology）即空中下载技术，是通过移动通信技术实现终端设备固件或软件远程升级的关键方案。八比特提供从云端管理平台到终端执行环境的全栈 OTA 解决方案。' },
                    { type: 'bigTitle', value: '产品优势' },
                    { type: 'text', value: '(1) 高效差分算法：采用自研差分技术，仅传输变更部分，大幅减少升级包体积，节省流量并缩短升级时长。' },
                    { type: 'text', value: '(2) 安全防护体系：基于 PKI/CA 体系实现双向身份认证，支持国密算法（SM2/SM3/SM4），确保升级包不被篡改。' },
                    { type: 'text', value: '(3) 高并发接入：支持千万级设备同时在线管理，具备万级并发下载处理能力。' },
                    { type: 'text', value: '(4) 完善的容错机制：支持断点续传、程序自动回滚及多分区备份，确保升级失败时设备仍能正常运行。' },
                    { type: 'bigTitle', value: '应用场景' },
                    { type: 'text', value: '智能座舱系统更新、整车 ECU 固件升级、智能穿戴设备维护、工业物联网终端远程管理。' },
                ]
            }
        },{
        pageName: "嵌入式工程研发服务",
        dataId: "2-2-1",
        data: {
            routerList: ["服务", "软件开发服务", "嵌入式工程研发服务"],
            topImg: require("../assets/img/product/embedd1.webp"),
            topFont: [{ fontSize: 'normal', value: "嵌入式工程研发服务" }],
            content: {
                intro: {
                    text: "随着智能设备和物联网的快速发展，嵌入式软件已成为产品核心竞争力之一。我们提供专业的嵌入式软件开发服务，帮助企业高效构建稳定、安全且高性能的系统解决方案。八比特科技拥有一支经验丰富的嵌入式软件研发团队，专注于各类MCU/MPU平台下的底层驱动、操作系统、中间件及上层应用开发。\n\n我们不只是写代码，更是为客户提供从原型验证到批量生产的全生命周期技术支撑。支持从底层驱动开发到系统集成的全流程服务，覆盖汽车电子、工业控制、消费电子等多个行业。",
                    images: [
                        require("../assets/img/product/embedd2.webp"),
                    ]
                },
                serviceContent: {
                    title: "服务内容",
                    items: [
                        {
                            title: "硬件工程：",
                            desc: "1. 原理图与PCB Layout：资深工程师团队，支持高速信号设计与EMC优化\n2. 元器件选型与BOM优化：平衡成本、性能、交期，提升物料复用率\n3. 结构ID/MD设计：工业级可靠性，从概念设计到开模量产"
                        },
                        {
                            title: "嵌入式软件定制：",
                            desc: "1. 底层驱动与BSP开发：精通Linux/RTOS/裸机环境下各类外设驱动\n2. 系统移植与优化：U-Boot/Kernel裁剪、Yocto/Buildroot环境搭建\n3. 中间件与应用开发：通信协议集成、GUI图形界面、OTA远程升级"
                        },
                        {
                            title: "制造与量产支持：",
                            desc: "1. ODM/OEM交钥匙方案：从设计到量产的全链条交付，支持技术转让\n2. 生产测试与工装：提供烧录、校准、自动化测试脚本等量产工具\n3. 供应链与质量保障：核心物料战略备货，工厂实施IATF/ISO标准可靠性测试"
                        }
                    ],
                    bottomImage: require("../assets/img/product/embedd3.webp")
                },
                serviceCategory: {
                    title: "服务类别清单：",
                    headers: ["服务类别", "具体服务内容"],
                    rows: [
                        ["底层驱动与BSP开发", "外设驱动设计与调试（UART、SPI、I2C、USB、CAN、Ethernet、Wi-Fi/BT等）、板级支持包（BSP）构建与优化、设备树配置与裁剪"],
                        ["实时操作系统（RTOS/嵌入式Linux）", "FreeRTOS/uCOS/VxWorks等RTOS移植与优化；Linux Kernel裁剪、定制文件系统构建、Yocto/Buildroot环境搭建、PREEMPT_RT实时性优化"],
                        ["中间件与应用软件开发", "通信协议栈（MQTT/CoAP/Modbus/CANopen/SAE J1939）集成；IoT平台对接（AWS IoT/Azure IoT/华为云）；GUI人机交互界面开发（LVGL/TouchGFX/emWin）"],
                        ["硬件设计与工程", "硬件方案评估与SoC选型、核心板/底板原理图设计、PCB Layout（高速信号与EMC优化）、元器件选型与BOM编制、结构ID/MD工业设计"],
                        ["测试验证与认证", "软硬件协同验证、自动化测试框架搭建（CI/CD流水线）、固件/BIOS功能与性能验证、电磁兼容EMC整改与测试；产品合规认证支持（FCC/CE/UKCA/KC/CCC/RoHS等）"],
                        ["固件开发与OTA升级", "Bootloader设计（支持加密与安全启动）、固件架构设计与实现、OTA远程升级方案（差分更新/回滚保护）、安全固件签名与加密"],
                        ["系统联调与性能优化", "全系统集成联调、内存与功耗优化、实时性调优、代码精简与尺寸优化"],
                        ["ODM/OEM与量产支持", "产品交钥匙开发、工装/烧录夹具设计、生产测试程序开发、小批量试产到大规模量产支持"]
                    ]
                },
                serviceProcess: {
                    title: "服务流程清单：",
                    headers: ["项目阶段", "关键动作", "交付物"],
                    rows: [
                        ["需求评估与立项", "技术可行性分析（[X]日出具评估报告）、定制方案建议、成本与周期预估", "产品需求规格书、开发计划"],
                        ["方案设计", "核心SoC选型、原理图评审、BOM评审、软件架构设计", "硬件设计方案、软件架构文档"],
                        ["研发与验证", "硬件打样（最快[X-Y]周）、固件开发、软硬件联调、功能测试与EMC认证", "功能样机、测试报告"],
                        ["试产与量产", "小批量试产（[N]台）、生产测试优化、工装夹具开发、SMT贴片生产（产能可达[K]套/月）", "试产报告、量产BOM、量产测试程序"],
                        ["维护与迭代", "量产发货支持、售后技术支持", "技术支持服务、软件OTA更新"]
                    ],
                    bottomImage: require("../assets/img/product/embedd4.webp")
                },
                engineerStack: {
                    title: "工程师技术栈展示",
                    desc: "1. 全平台覆盖：从ARM Cortex-M0到Cortex-A，从RISC-V到DSP，支持STM32、NXP、瑞萨、赛昉等主流芯片。\n2. 操作系统深度定制：FreeRTOS / Zephyr / RT-Thread / 嵌入式Linux（Yocto/Buildroot）全栈移植与优化。\n3. 驱动开发硬实力：100+外设驱动经验（含USB主机、以太网、CAN-FD、MIPI DSI/CSI），无线模组(BLE/Wi-Fi/LoRa/4G)快速集成。\n4. 工业与物联网协议栈：Modbus/CANopen/EtherCAT + MQTT/CoAP/LwIP，且已对接AWS IoT、阿里云等多朵云。\n5. 工程化交付：CMake + Jenkins + 硬件在环自动化回归，代码静态分析，确保固件高可靠。",
                    image: require("../assets/img/product/embedd5.webp")
                }
            }
        }
    },{
        pageName: "应用程序开发服务",
        dataId: "2-2-2",
        data: {
            routerList: ["服务", "软件开发服务", "应用程序开发服务"],
            topImg: require("../assets/img/product/program1.webp"),
            topFont: [{ fontSize: 'normal', value: "应用程序开发服务" }],
            content: {
                // 简介区域（文本 + 两张图片）
                intro: {
                    text: "在数字化转型的时代，优质的应用程序是企业连接用户的重要桥梁。我们提供覆盖Web、移动端及企业级系统的应用开发服务，帮助客户实现业务创新与效率提升。八比特科技拥有一支经验丰富的全栈应用开发团队，覆盖Web、移动App、小程序、桌面应用及后端系统。我们不只是写代码，更是为客户提供从产品设计、技术选型、架构设计到上线运维的全生命周期开发服务。\n\n无论是企业内部系统还是面向用户的应用产品，我们都能够提供从需求分析到上线运维的一站式服务，覆盖金融、医疗、互联网、教育等多个行业。",
                    images: [
                        require("../assets/img/product/program2.webp"),
                    ]
                },
                // 服务内容（三个卡片，每个卡片有标题和带数字序号的描述）
                serviceContent: {
                    title: "服务内容",
                    items: [
                        {
                            title: "定制化应用开发",
                            desc: "1. 全平台覆盖：Web / 移动App / 小程序 / 桌面应用\n2. 主流技术栈：React/Vue、Spring Boot/Go、Flutter/React Native\n3. 高扩展性架构：微服务 + 容器化部署\n4. 云原生后端 · 开放API"
                        },
                        {
                            title: "UI/UX 设计",
                            desc: "1. 数据驱动的用户研究，产出高保真可交互原型\n2. 统一设计语言，保证多端体验一致性\n3. 交付开发标注与设计资产，缩短前端还原周期"
                        },
                        {
                            title: "质量与运维",
                            desc: "1. 自动化测试流水线，代码覆盖率强制门禁\n2. 云端压测与安全扫描，上线前规避性能瓶颈\n3. 7x24h 监控告警，故障平均恢复时间（MTTR）≤30分钟"
                        }
                    ],
                    bottomImage: require("../assets/img/product/program3.webp"),
                },
                // 服务类别清单（表格）
                serviceCategory: {
                    title: "服务类别清单",
                    headers: ["服务大类", "具体服务内容"],
                    rows: [
                        ["咨询与规划", "业务需求分析、技术选型评估、系统架构设计、MVP（最小可行产品）规划、技术债务评估与重构方案"],
                        ["UI/UX 设计", "用户研究、交互设计、高保真原型、视觉设计（Design System）、响应式/自适应设计、无障碍（A11y）设计"],
                        ["前端开发", "响应式Web（Vue/React/Angular）、移动端Web（PWA）、跨平台桌面（Electron/Tauri）、小程序（微信/支付宝）"],
                        ["后端开发", "RESTful/gRPC/GraphQL API、微服务架构（Spring Cloud/Go-micro/K8s）、Serverless（函数计算）、数据库设计（SQL/NoSQL/时序/图数据库）"],
                        ["移动端开发", "原生iOS（Swift）、原生Android（Kotlin）、跨平台（Flutter/React Native/Uni-app）"],
                        ["测试与质量保障", "单元测试、集成测试、UI自动化测试（Selenium/Appium）、性能测试（JMeter/Locust）、安全测试（渗透/代码扫描）、真机云测"],
                        ["部署与运维", "CI/CD流水线（GitHub Actions/Jenkins/GitLab CI）、容器化（Docker/K8s）、云托管（AWS/Azure/阿里云/腾讯云）、日志监控（Prometheus+Grafana/ELK）、故障自愈"],
                        ["升级与维护", "功能迭代、性能优化、安全补丁、技术栈升级、第三方服务迁移、7x24h技术支持"]
                    ],
                    bottomImage: require("../assets/img/product/program3.webp"),
                },
                // 服务流程清单（表格）
                serviceProcess: {
                    title: "服务流程清单",
                    headers: ["阶段", "关键活动", "客户可见交付物"],
                    rows: [
                        ["需求与策略", "业务场景梳理、技术选型评估、架构推演", "产品需求文档、技术方案建议书、项目甘特图"],
                        ["设计与原型", "用户旅程图、交互流程、视觉稿评审", "可点击高保真原型、Design System组件库"],
                        ["迭代开发", "按敏捷双周冲刺、代码审查、持续集成", "可演示的增量版本、每日构建报告"],
                        ["测试与验收", "自动化回归、安全渗透、用户验收测试", "测试报告（含性能、兼容性、安全性结论）"],
                        ["上线与运维", "灰度发布、监控仪表盘、备份与灾备演练", "上线checklist、SLA服务等级协议、运维手册"]
                    ],
                    bottomImage: require("../assets/img/product/program4.webp"),
                },
                // 工程师技术栈展示（带数字序号的列表 + 底部图片）
                engineerStack: {
                    title: "工程师技术栈展示",
                    desc: "1. 前端：React、Vue、Angular、TypeScript、Next.js、Nuxt.js\n2. 后端：Spring Boot、Go、Node.js、Python（Django/Flask）、.NET Core\n3. 移动端：Swift、Kotlin、Flutter、React Native、Uni-app\n4. 数据库：MySQL、PostgreSQL、MongoDB、Redis、Elasticsearch\n5. 云与运维：AWS、Azure、阿里云、Docker、Kubernetes、Terraform\n6. 测试工具：Jest、Cypress、Appium、JMeter、SonarQube",
                    image: require("../assets/img/product/program5.webp"),
                }
            }
        }
    },{
        pageName: "产品功能测试服务",
        dataId: "2-3-1",
        data: {
            routerList: ["服务", "软件测试服务", "产品功能测试服务"],
            topImg: require("../assets/img/product/test1.webp"),
            topFont: [{ fontSize: 'normal', value: "产品功能测试服务" }],
            content: {
                // 简介区域（文本 + 两张图片）
                intro: {
                    text: "产品功能的稳定性直接影响用户体验和品牌形象。我们提供系统化的产品功能测试服务，帮助企业在产品发布前发现潜在问题，降低上线风险。\n\n通过标准化测试流程与自动化测试工具，我们可以全面覆盖产品功能场景，确保系统按预期运行。八比特科技拥有一支专注于功能测试的工程师团队，服务对象涵盖嵌入式硬件产品、物联网设备、工业控制器、医疗仪器以及各类软件应用。我们不仅验证\"功能是否实现\"，更关注\"功能是否稳定、边界是否安全、用户场景是否覆盖\"。",
                    images: [
                        require("../assets/img/product/test2.webp"),
                    ]
                },
                // 服务内容（三个卡片）
                serviceContent: {
                    title: "服务内容",
                    items: [
                        {
                            title: "全场景功能测试",
                            desc: "1. 手动与自动化结合，覆盖正向/逆向/边界场景\n2. 支持Web、移动App、小程序、嵌入式设备\n3. 测试用例100%双向追溯需求，确保无遗漏"
                        },
                        {
                            title: "自动化测试流水线",
                            desc: "1. CI/CD无缝集成，每次提交自动触发回归\n2. 框架灵活：Selenium/Cypress/Appium/Postman\n3. 提供可维护的自动化资产，不绑人"
                        },
                        {
                            title: "兼容与专项测试",
                            desc: "1. 100+真机机型，主流浏览器版本矩阵\n2. 性能压测：从负载到稳定性全仿真\n3. 基础安全扫描：OWASP Top10覆盖"
                        }
                    ],
                    bottomImage: require("../assets/img/product/test3.webp"),
                },
                // 服务类别清单（表格）
                serviceCategory: {
                    title: "服务类别清单",
                    headers: ["服务大类", "具体服务内容"],
                    rows: [
                        ["测试咨询与规划", "测试策略制定、测试范围界定、测试用例设计方法（等价类/边界值/场景法）、测试环境规划、风险分析"],
                        ["功能测试（手动）", "新功能验证、回归测试、集成测试、系统测试、用户验收测试（UAT）"],
                        ["自动化测试", "接口自动化（Postman/REST Assured/Go）、UI自动化（Selenium/Cypress/Appium/Puppeteer）、API契约测试、自动化回归流水线集成"],
                        ["性能与压力测试", "负载测试、稳定性测试、并发压力测试、限流与降级演练、性能瓶颈分析（结合APM）"],
                        ["兼容性测试", "Web浏览器兼容（Chrome/Firefox/Safari/Edge多版本）、移动设备碎片化适配（iOS/Android主流版本及分辨率）、小程序/鸿蒙平台验证"],
                        ["安全测试（基础）", "身份认证、权限绕过测试、SQL注入/XSS检测、敏感信息泄露检查、依赖库漏洞扫描"],
                        ["硬件产品功能测试", "嵌入式功能验证（按键、显示、通信接口）、固件升级测试、边界条件（高低温/电压波动模拟）、长时间稳定性（老化测试）"],
                        ["测试交付与质量度量", "测试报告（含缺陷分布/修复率/遗留风险）、验收标准签核、自动化测试资产移交"]
                    ],
                    bottomImage: require("../assets/img/product/test4.webp"),
                },
                // 服务流程清单（表格）
                serviceProcess: {
                    title: "服务流程清单",
                    headers: ["阶段", "关键活动", "客户可见交付物"],
                    rows: [
                        ["需求与策略", "评审需求/原型，确定测试范围与优先级，风险评估", "测试计划、测试策略文档、工作量评估"],
                        ["用例设计", "编写测试用例（正向/异常/边界），准备测试数据", "测试用例库（支持XMind/Excel/TestLink）"],
                        ["环境与执行", "搭建测试环境，执行手动测试+自动化回归", "缺陷报告、测试执行日志、实时看板"],
                        ["回归与验收", "缺陷修复验证，全量回归，用户验收测试支持", "回归测试报告、UAT签核单"],
                        ["交付与度量", "质量报告（缺陷分布/通过率/遗留风险），测试资产移交", "测试总结报告、自动化工程包"]
                    ],
                    bottomImage: null   // 文档中此部分无额外配图
                },
                // 工程师技术栈展示（列表 + 底部图片）
                engineerStack: {
                    title: "工程师技术栈展示",
                    desc: "1. 测试管理：Jira/Xray、TestRail、禅道\n2. 自动化框架：Selenium、Cypress、Appium、Pytest、REST Assured、Gauge\n3. 性能压测：JMeter、Locust、k6\n4. 兼容性/真机：BrowserStack、Sauce Labs、Testin云测、自建真机实验室（列出具体型号数量）\n5. 安全扫描：SonarQube、OWASP ZAP、Snyk",
                    image: require("../assets/img/product/test5.webp"),
                }
            }
        }
    },{
        pageName: "应用程序测试服务",
        dataId: "2-3-2",
        data: {
            routerList: ["服务", "软件测试服务", "应用程序测试服务"],
            topImg: require("../assets/img/product/test1.webp"),
            topFont: [{ fontSize: 'normal', value: "应用程序测试服务" }],
            content: {
                // 简介区域（文本 + 一张图片）
                intro: {
                    text: "我们深知：在应用驱动的商业时代，一次线上故障可能意味着用户流失、品牌受损，甚至合规风险。因此，我们不满足于\"找Bug\"，而是致力于帮助客户建立可持续的质量体系。\n\n作为专业的应用测试服务提供商，我们致力于为企业提供高质量的软件测试解决方案，保障系统在复杂环境下的稳定运行，八比特科技专注于软件质量与工程效率的技术服务商。我们结合自动化测试与人工测试，覆盖从性能、安全到用户体验的各个维度，为客户提供全方位质量保障。",
                    images: null

                },
                // 服务内容（四个卡片）
                serviceContent: {
                    title: "服务内容",
                    bottomImage: require("../assets/img/product/test6.webp"),
                    items: [
                        {
                            title: "自动化测试",
                            desc: "1. Web 自动化：基于 Selenium / Cypress / Playwright，支持 Chrome、Firefox、Edge、Safari 多浏览器并行执行。\n2. 移动端自动化：使用 Appium + 真云实验室，覆盖 iOS / Android / 鸿蒙，支持原生、混合、Flutter 应用。\n3. 接口自动化：Postman + Newman / REST Assured / Pytest，实现 RESTful、GraphQL、gRPC 协议的自动校验。\n4. 小程序自动化：基于微信/支付宝官方工具链 + Minium，实现业务场景的自动回归。"
                        },
                        {
                            title: "性能测试",
                            desc: "1. 负载测试：模拟预期用户数（如 1000 并发），验证响应时间、吞吐量、资源利用率是否满足 SLA。\n2. 压力测试：逐步加压直到系统崩溃，找到极限阈值和薄弱环节（数据库连接池、缓存、中间件等）。\n3. 稳定性测试：长时间（8-24小时）维持中高负载，检测内存泄漏、连接泄漏、日志堆积等问题。\n4. 峰值与弹性测试：模拟突增流量（如秒杀），验证限流、熔断、自动扩容策略有效性。"
                        },
                        {
                            title: "安全测试",
                            desc: "1. 身份认证与授权测试：验证登录绕过、越权访问（横向/纵向）、Session/Cookie 安全。\n2. 注入类漏洞检测：SQL 注入、NoSQL 注入、LDAP 注入、表达式注入。\n3. 跨站脚本（XSS）与跨站请求伪造（CSRF）：反射型、存储型、DOM 型 XSS 检测。\n4. 敏感信息泄露：硬编码密钥、响应头泄露、错误堆栈暴露、目录遍历。\n5. 依赖库漏洞扫描：使用 Snyk / OWASP Dependency-Check 扫描第三方组件已知 CVE。\n6. 业务逻辑安全：支付篡改、优惠券无限刷、短信轰炸、验证码绕过等。"
                        },
                        {
                            title: "用户体验测试",
                            desc: "1. 可用性走查：基于尼尔森十大原则，评估导航一致性、反馈及时性、容错性等。\n2. 任务场景测试：招募目标用户（或内部模拟），完成代表性任务（如\"购买一件商品\"），记录时间、错误率、主观满意度（SUS 评分）。\n3. 竞品对比测试：与 2-3 款主流竞品对比核心任务完成效率，输出改进建议。\n4. 用户行为埋点验证：检查埋点代码是否准确触发（如点击、页面停留、转化漏斗），确保数据采集可靠。\n5. A/B 测试支持：辅助设计实验方案，并验证不同版本的实际效果。"
                        }
                    ],

                },
                // 服务类别清单（表格）
                serviceCategory: {
                    title: "服务类别清单",
                    headers: ["服务大类", "核心能力"],
                    rows: [
                        ["功能测试（手动+自动化）", "需求追溯、场景用例设计、精准回归、探索性测试"],
                        ["接口自动化测试", "RESTful/GraphQL/gRPC 全协议支持；Postman/Newman + Jenkins 流水线"],
                        ["UI自动化测试", "Cypress/Playwright/Selenium/Appium；可视化报告与失败自动截图"],
                        ["性能与压力测试", "JMeter/k6/Locust；全链路压测、瓶颈定位（APM集成）"],
                        ["兼容性测试", "真机云测 + BrowserStack + 自研碎片化覆盖矩阵"],
                        ["安全测试（基础）", "OWASP Top 10检测、身份认证与授权、SQL注入/XSS、依赖库漏洞扫描"],
                        ["用户体验（UX）测试", "可用性走查、竞品对比、用户行为埋点验证"],
                        ["测试咨询与流程改进", "测试策略制定、质量门禁设计、DevOps测试集成、测试团队赋能培训"]
                    ],
                    bottomImage: null   // 文档中无对应配图
                },
                // 服务流程清单（表格）
                serviceProcess: {
                    title: "服务流程清单",
                    headers: ["阶段", "关键活动", "交付物（客户可见）"],
                    rows: [
                        ["策略与计划", "需求评审、风险分析、测试范围定义、环境规划、工具选型", "《测试计划》《测试策略》《工作量评估》"],
                        ["用例设计与评审", "编写正向/逆向/边界用例；设计测试数据；与开发同步评审", "《测试用例库》（TestLink/XMind/Excel）"],
                        ["环境搭建与执行", "搭建测试环境（含mock服务）；执行手动+自动化测试；缺陷全生命周期跟踪", "缺陷报告、测试执行日志、实时质量看板"],
                        ["回归与验收", "缺陷修复验证；全量回归；用户验收测试（UAT）支持", "《回归测试报告》《UAT签核单》"],
                        ["度量与交付", "质量报告（缺陷趋势、模块风险、遗留项评估）；自动化资产打包；知识转移", "《测试总结报告》、自动化工程包（可直接集成CI）、培训视频"]
                    ],
                    bottomImage: require("../assets/img/product/test7.webp"),
                },
                // 工程师技术栈展示
                engineerStack: {
                    title: "工程师技术栈展示",
                    desc: "1. 编程语言：Python, Java, JavaScript/TypeScript, Go, Shell\n2. 接口自动化：Postman, REST Assured, Pytest, Karate, SoapUI\n3. UI自动化：Selenium, Cypress, Playwright, Appium, Puppeteer\n4. 性能压测：JMeter, k6, Locust, Gatling (支持分布式压测)\n5. 测试管理：Jira + Xray, TestRail, 禅道, TestLink\n6. CI/CD集成：Jenkins, GitLab CI, GitHub Actions, Git hooks\n7. 容器与虚拟化：Docker, Kubernetes (用于测试环境隔离)\n8. 安全测试：OWASP ZAP, Burp Suite, SonarQube, Snyk, Nuclei\n9. 移动端专项：Android Studio, Xcode, Charles Proxy, Wireshark, 弱网模拟\n10. 数据库：MySQL, PostgreSQL, MongoDB, Redis (数据验证与初始化)",
                    image: require("../assets/img/product/test8.webp"),
                }
            }
        }
    },{
            pageName: "软件定制化服务",
            dataId: "old2-1-1",
            data: {
                routerList: ["服务", "定制服务", "软件定制化服务"],
                topImg: require("../assets/img/service1/service1.jpg"),
                topFont: [
                    // { fontSize: 'normal', value: "软件定制化服务" },
                ],
                content: [
                    {
                        type: 'spaceBetweenMore', value: '',
                        children1: [
                            { type: 'allImage', src: require("../assets/img/service1/定制服务.jpg") }
                        ],
                        children2: [
                            { type: 'title', value: '十年专注，只为一事——让软件精准匹配您的野心' },
                            { type: 'bigTitle', value: '从代码工匠到战略伙伴，我们重新定义软件定制的价值' },
                            { type: 'smallTitle', value: '【4000天深耕，让技术回归本质】' },
                            { type: 'text', value: '自2014年起，我们始终聚焦一件事：用代码解构商业逻辑。\n10年+技术沉淀，300+企业验证，拒绝“通用解决方案”的妥协，\n以外科手术式精准开发，为金融、医疗、智能制造等领域构建生长型数字系统。' },
                            { type: 'title', value: '为何选择“深度定制”？' },
                            { type: 'smallTitle', value: '• 您是否面临这些问题？' },
                            { type: 'text', value: '→ 通用软件功能冗余，核心需求却无法满足\n→ 现有系统迭代困难，拖慢业务创新速度\n→ 数据孤岛导致决策滞后，错失市场机会' },
                            { type: 'smallTitle', value: '——这不是技术问题，是战略问题。' },
                            { type: 'title', value: '我们的解决之道' },
                            { type: 'bigTitle', value: '10年淬炼的“3D开发体系”' },
                            { type: 'smallTitle', value: 'Define | 需求深挖' },
                            { type: 'text', value: '√ 15天深度调研：业务诊断+痛点地图+ROI推演\n√ 独创“双轨确认制”：技术可行性验证与商业价值验证同步' },
                            { type: 'smallTitle', value: 'Develop | 精准构建' },
                            { type: 'text', value: '√ 模块化开发：像拼装乐高一样自由组合功能\n√ 云原生架构：系统可随业务规模自动伸缩\n√ 安全双保险：等保三级基础+动态渗透测试' },
                            { type: 'smallTitle', value: 'Deliver | 长效共生' },
                            { type: 'text', value: '√ 交付不是终点：每月迭代建议报告+紧急BUG 15分钟响应\n√ “技术移植计划”：为您的团队配备定制系统操作DNA' },
                            { type: 'title', value: ' 客户选择我们的4个理由' },
                            { type: 'text', value: '✓ 更懂行业：医疗HIPAA合规/金融级加密/工业物联网协议预封装\n✓ 更快响应：30人专属技术中台，需求变更3工作日反馈方案\n✓ 更可持续：预留50个扩展接口，支持未来十年技术升级\n✓ 更省成本：比自建团队节省60%费用，比外包开发缩短40%工期' },
                        ],
                    },
                ]
            }
        },{
            pageName: "智能硬件设计",
            dataId: "2-1-1",
            data: {
                routerList: ["服务", "智能技术服务", "智能硬件设计"],
                topImg: require("../assets/img/service/SHDesign.png"),
                topFont: [
                     { fontSize: 'normal', value: "智能硬件设计" },
                ],
                 content: [
                    { type: 'title', value: '智能硬件设计 智能技术服务' },
                    { type: 'text', value: '智能硬件设计是智能技术服务的重要组成部分，面向客户在智能终端、行业设备、感知控制、数据采集与边缘计算等方向的开发需求，提供从硬件方案规划、电子电路设计、嵌入式系统开发到样机调试验证的一体化技术支持。' },
                    { type: 'bigTitle', value: '核心设计能力' },
                    { type: 'image', src: require("../assets/img/service/SHDesign-2.png") },
                    { type: 'text', value: '智能硬件设计服务围绕产品定义、硬件架构、核心器件选型、接口设计、嵌入式软件适配和系统可靠性展开，支持客户从概念方案走向可验证样机，并为后续小批量试制、产品优化和系统集成打下基础。' },
                    { type: 'midTitle', value: '| 硬件方案设计' },
                    { type: 'text', value: '根据产品功能、应用环境、成本目标和扩展需求，完成主控平台、传感器、通信、电源、接口和结构协同设计。' },
                    { type: 'midTitle', value: '| 电路与接口设计' },
                    { type: 'text', value: '支持核心板、控制板、采集板、通信板等硬件单元设计，覆盖数字电路、模拟采集、电源管理、I/O 接口和外设连接。' },
                    { type: 'midTitle', value: '| 嵌入式系统适配' },
                    { type: 'text', value: '围绕 MCU、SoC、ARM 平台等进行底层驱动、通信协议、任务调度、数据采集和设备控制开发。' },
                    { type: 'midTitle', value: '| 通信与联网能力' },
                    { type: 'text', value: '支持蓝牙、Wi-Fi、4G/5G、以太网、CAN、串口等通信方式接入，实现设备联网、远程控制和数据传输。' },
                    { type: 'midTitle', value: '| 可靠性与可维护性设计' },
                    { type: 'text', value: '关注功耗、散热、抗干扰、稳定运行、接口保护和后续维护扩展，提升硬件系统工程化质量。' },
                    { type: 'bigTitle', value: '智能化功能集成' },
                    { type: 'image', src: require("../assets/img/service/SHDesign-3.png") },
                    { type: 'text', value: '为保障智能硬件项目从需求到落地的可控性，服务过程可按照“需求分析—方案设计—硬件开发—软件适配—联调验证—交付支持”的流程推进。每个阶段明确输入、输出和验证重点，便于客户掌握项目进度和交付边界。' },
                    { type: 'midTitle', value: '| 需求分析' },
                    { type: 'text', value: '梳理产品定位、功能清单、使用环境、性能指标、接口需求、成本约束和交付目标。' },
                    { type: 'midTitle', value: '| 方案设计' },
                    { type: 'text', value: '完成系统架构、硬件平台、器件选型、通信方式、软件框架和智能化功能方案设计。' },
                    { type: 'midTitle', value: '| 样机开发' },
                    { type: 'text', value: '开展原理图设计、PCB 设计、嵌入式驱动开发、基础功能实现和初版样机制作。' },
                    { type: 'midTitle', value: '| 系统联调' },
                    { type: 'text', value: '完成硬件、软件、算法、通信和外设之间的联调，验证设备运行状态和数据链路。' },
                    { type: 'midTitle', value: '| 测试优化' },
                    { type: 'text', value: '围绕稳定性、功耗、通信质量、采集精度、控制响应和异常保护进行测试与优化。' },
                    { type: 'midTitle', value: '| 交付支持' },
                    { type: 'text', value: '提供技术文档、接口说明、调试记录、测试结果和后续升级维护支持。' },
                    { type: 'bigTitle', value: '应用场景与服务价值' },
                    { type: 'image', src: require("../assets/img/service/SHDesign-4.png") },
                    { type: 'text', value: '智能硬件设计服务可面向智能汽车、智慧医疗、工业控制、教育实训、智能终端、无人系统、数据采集设备和行业专用设备等方向，为客户提供软硬件结合的产品研发支持。通过智能化能力注入，硬件设备不仅能够完成基础采集和控制，还能够进一步实现联网化、平台化和场景化应用。' },
                    { type: 'midTitle', value: '| 智能终端设备' },
                    { type: 'text', value: '面向行业终端、便携设备、边缘计算终端和人机交互设备，提供硬件平台与嵌入式系统设计。' },
                    { type: 'midTitle', value: '| 工业与数据采集设备' },
                    { type: 'text', value: '面向现场采集、设备监控、自动控制和远程运维场景，提供传感器接入和通信控制方案。' },
                    { type: 'midTitle', value: '| 车载及智能交通设备' },
                    { type: 'text', value: '面向车辆感知、状态采集、控制交互和车端数据处理场景，提供智能硬件设计支持。' },
                    { type: 'midTitle', value: '| 医疗与健康类设备' },
                    { type: 'text', value: '面向检测、监测、交互和数据管理类设备，提供稳定可靠的硬件与软件协同开发。' },
                    { type: 'midTitle', value: '| 教学与科研验证平台' },
                    { type: 'text', value: '面向高校、实验室和研发团队，支持定制化硬件平台、算法验证平台和实验设备开发。' },
                   ]    
                }
        },{
            pageName: "智能软件设计",
            dataId: "2-1-2",
            data: {
                routerList: ["服务", "智能技术服务", "智能软件设计"],
                topImg: require("../assets/img/service/SSDesign.png"),
                topFont: [
                     { fontSize: 'normal', value: "智能软件设计" },
                ],
                 content: [
                    { type: 'title', value: '智能软件设计 智能技术服务' },
                    { type: 'text', value: '八比特科技智能软件设计服务面向智能终端、行业平台与嵌入式设备，提供软件架构设计、嵌入式软件开发、智能算法集成、平台接口开发、系统联调测试及交付支持，帮助客户构建稳定、高效、可扩展的软件系统。' },
                    { type: 'bigTitle', value: '服务概述' },
                    { type: 'image', src: require("../assets/img/service/SSDesign-2.png") },
                    { type: 'text', value: '服务围绕“智能能力 + 软件工程 + 系统集成”展开，覆盖需求分析、架构设计、功能开发、数据交互、设备适配、算法融合、测试优化和持续维护等环节，适用于智能硬件、工业设备、智慧医疗、智慧教育、物联网平台等场景。' },
                    { type: 'bigTitle', value: '核心设计能力' },
                    { type: 'image', src: require("../assets/img/service/SSDesign-3.png") },
                    { type: 'text', value: '具备软件架构设计、算法模型集成、嵌入式软件开发、平台接口开发、数据管理与安全设计等能力，可根据客户项目需求进行定制开发和系统适配。' },
                    { type: 'bigTitle', value: '智能化功能集成' },
                    { type: 'image', src: require("../assets/img/service/SSDesign-4.png") },
                    { type: 'text', value: '通过感知数据接入、边缘计算处理、智能控制执行、数据交互联动和算法融合应用，将软件功能与实际业务场景结合，形成可运行、可管理、可持续优化的智能软件能力。' },
                    { type: 'midTitle', value: '| 感知数据接入' },
                    { type: 'text', value: '对接传感器、设备端数据、业务数据和外部系统数据，形成统一的数据采集与输入能力。' },
                    { type: 'midTitle', value: '| 边缘计算处理' },
                    { type: 'text', value: '在终端或边缘设备侧完成数据预处理、实时判断、轻量化推理和本地响应，提升系统实时性。' },
                    { type: 'midTitle', value: '| 智能控制执行' },
                    { type: 'text', value: '结合规则策略、算法结果和业务指令，实现对设备、流程或应用动作的自动控制与闭环执行。' },
                    { type: 'midTitle', value: '| 数据交互联动' },
                    { type: 'text', value: '通过接口协议、消息通信、云端同步和平台联动，实现设备与系统之间的高效协同。' },
                    { type: 'midTitle', value: '| 算法融合应用' },
                    { type: 'text', value: '将多源数据、业务规则和智能算法结合，提升软件系统的识别、分析、预测和决策辅助能力。' },
                    { type: 'bigTitle', value: '开发流程与交付内容' },
                    { type: 'image', src: require("../assets/img/service/SSDesign-5.png") },
                    { type: 'text', value: '流程包括需求分析、架构设计、软件开发、系统联调、测试优化和交付支持。交付内容包括需求规格说明、架构方案、软件代码、接口文档、部署文档、测试报告、使用说明及后续技术支持。' },
                    { type: 'bigTitle', value: '应用场景与服务价值' },
                    { type: 'image', src: require("../assets/img/service/SSDesign-6.png") },
                    { type: 'text', value: '服务可应用于智能硬件、工业控制、智慧医疗、智慧教育、物联网终端与数据平台等场景，帮助客户提升产品智能化水平、缩短研发周期、增强系统稳定性，并支持后续持续升级。' },
                    { type: 'midTitle', value: '| 智能硬件软件配套' },
                    { type: 'text', value: '为智能硬件产品提供嵌入式软件、设备管理、数据通信、控制逻辑和平台接口能力。' },
                    { type: 'midTitle', value: '| 工业设备与控制系统' },
                    { type: 'text', value: '支撑设备状态监测、数据采集、远程运维、控制策略和生产过程软件化管理。' },
                    { type: 'midTitle', value: '| 智慧医疗终端与平台' },
                    { type: 'text', value: '用于设备数据采集、监测界面、数据传输、权限管理、平台对接和辅助分析。' },
                    { type: 'midTitle', value: '| 智慧教育与业务平台' },
                    { type: 'text', value: '支持教学终端、考试设备、数据看板、业务流程管理和多端协同应用。' },
                    { type: 'midTitle', value: '| 物联网与数据平台' },
                    { type: 'text', value: '实现终端接入、协议适配、设备管理、数据上报、可视化分析和云端服务联动。' },
                   ]    
                }
        },{
            pageName: "PCB集成电路",
            dataId: "2-1-3",
            data: {
                routerList: ["服务", "智能技术服务", "PCB集成电路"],
                topImg: require("../assets/img/service/PCBDesign.png"),
                topFont: [
                     { fontSize: 'normal', value: "PCB集成电路" },
                ],
                 content: [
                    { type: 'title', value: 'PCB集成电路 智能技术服务' },
                    { type: 'text', value: '围绕智能终端、传感器设备、边缘计算模块、通信网关及行业硬件产品的研发需求，八比特科技提供从硬件方案设计、核心器件选型、原理图与 PCB 设计，到样机调试、系统联调和交付支持的一体化服务，帮助客户构建稳定可靠、易于扩展、适配智能化应用的硬件基础平台。' },
                    { type: 'bigTitle', value: '服务概述' },
                    { type: 'image', src: require("../assets/img/service/PCBDesign-2.png") },
                    { type: 'text', value: 'PCB 集成电路服务是智能硬件产品研发的底层支撑能力，承担着芯片、传感器、通信模块、接口电路、电源管理与嵌入式系统之间的连接与协同。通过合理的硬件架构设计和电路集成方案，可为设备的感知采集、边缘计算、智能控制、数据通信和长期稳定运行提供可靠基础。' },
                    { type: 'text', value: '八比特科技面向智能硬件项目的实际应用场景，提供从需求分析到硬件落地的设计支持。服务重点不局限于单一 PCB 绘制，而是结合产品功能、结构空间、功耗要求、通信方式、可靠性要求和后续量产需求，形成可验证、可迭代、可交付的硬件设计方案。' },
                    { type: 'bigTitle', value: '核心设计能力' },
                    { type: 'image', src: require("../assets/img/service/PCBDesign-3.png") },   
                    { type: 'midTitle', value: '| 硬件方案设计' },                 
                    { type: 'text', value: '根据产品定位、功能需求和应用场景，规划主控芯片、传感器、通信模块、电源系统和接口资源，形成整体硬件架构方案。' },
                    { type: 'midTitle', value: '| 原理图与 PCB 设计' },     
                    { type: 'text', value: '完成核心电路、外围电路、信号链路、接口连接和 PCB 布局布线设计，兼顾性能、空间、散热和可生产性。' },
                    { type: 'midTitle', value: '| 集成电路应用与器件选型' },     
                    { type: 'text', value: '围绕 MCU、MPU、AI 芯片、电源芯片、通信芯片、传感器芯片等关键器件，进行选型评估、应用电路设计和适配验证。' },
                    { type: 'midTitle', value: '| 电源与接口设计' },     
                    { type: 'text', value: '支持多路电源管理、保护电路、模拟/数字接口、通信接口、外设扩展接口设计，提升硬件平台的兼容性和扩展性。' },
                    { type: 'midTitle', value: '| 可靠性与可维护性设计' },     
                    { type: 'text', value: '关注 EMC、ESD、防护、散热、接口稳定性、调试接口预留和后期维护便利性，降低产品应用过程中的硬件风险。' },
                    { type: 'bigTitle', value: '智能硬件集成' },
                    { type: 'image', src: require("../assets/img/service/PCBDesign-4.png") },
                    { type: 'text', value: '在智能硬件产品中，PCB 与集成电路不仅承担电气连接作用，更是智能化能力的承载平台。通过将感知采集、边缘计算、通信联网和控制执行能力集成到硬件系统中，可使设备具备数据获取、实时处理、状态判断、远程交互和智能控制能力。' },
                    { type: 'midTitle', value: '| 感知采集集成' },     
                    { type: 'text', value: '支持摄像头、麦克风、温湿度、压力、姿态、红外、雷达、LiDAR 等传感器接入，为智能算法提供稳定数据来源。' },
                    { type: 'midTitle', value: '| 边缘计算承载 ' },     
                    { type: 'text', value: '结合 AI 芯片、主控处理器或边缘计算模块，实现本地数据处理、实时分析和低延迟响应。' },
                    { type: 'midTitle', value: '| 通信联网能力' },     
                    { type: 'text', value: '支持 Wi-Fi、Bluetooth、4G/5G、以太网、CAN、RS485、UART、SPI、I2C 等通信接口与协议适配。' },
                    { type: 'midTitle', value: '| 智能控制执行' },     
                    { type: 'text', value: '通过电机控制、继电器控制、IO 扩展、驱动电路和执行机构接口，实现硬件设备的自动化控制。' },
                    { type: 'midTitle', value: '| 算法与硬件协同' },     
                    { type: 'text', value: '根据算法运行、数据吞吐、功耗和接口资源要求优化硬件设计，使智能功能更好地落地到实际产品中。' },
                    { type: 'bigTitle', value: '开发流程与交付内容' },
                    { type: 'image', src: require("../assets/img/service/PCBDesign-5.png") },
                    { type: 'midTitle', value: '| 需求分析' },     
                    { type: 'text', value: '梳理产品场景、功能需求、接口需求、环境条件、成本目标和交付边界。' },
                    { type: 'midTitle', value: '| 方案设计' },     
                    { type: 'text', value: '形成硬件架构、芯片选型、电源方案、接口方案、通信方案和测试策略。' },
                    { type: 'midTitle', value: '| 原理图设计' },     
                    { type: 'text', value: '完成原理图设计、PCB布局布线、关键链路检查和生产文件输出。' },
                    { type: 'midTitle', value: '| 样机开发' },     
                    { type: 'text', value: '配合打样、焊接、硬件检查、上电验证和基础功能调试。' },
                    { type: 'midTitle', value: '| 系统联调与测试优化' },     
                    { type: 'text', value: '完成嵌入式软件适配、外设联调、通信测试、稳定性测试和问题闭环优化。' },
                    { type: 'midTitle', value: '| 交付支持' },     
                    { type: 'text', value: '输出设计文件、BOM、生产资料、测试记录、使用说明和后续技术支持。' },
                   ]    
                }
        },{
            pageName: "智能网联汽车",
            dataId: "d-1-1",
            data: {
                routerList: ["智能汽车", "智能网联汽车"],
                topImg: require("../assets/img/home1/banner1-1.jpg"),
                topFont: [
                    // { fontSize: 'small', value: "AUTOSAR解决方案" },
                    // { fontSize: 'normal', value: "AUTOSAR解决方案" },
                    { fontSize: 'normal', value: "智能网联汽车" },
                ],
                content: [
                    { type: 'title', value: '智能网联汽车' },
                    { type: 'text', value: '八比特基于积累多年的嵌入式操作系统优化   技术、人机交互、机器视觉、以及语音和音   频技术，为汽车提供从操作系统开发到应用  定制，包括汽车信息娱乐系统、智能仪表盘、 集成驾驶舱和音频产品在内的整体智能座舱   系统解决方案和技术服务，为驾乘者提供丰   富、先进的智能驾驶体验。' },
                    { type: 'text', value: '八比特与Qualcomm、Renesas、TI、NXP、ST、 QNX、Intel、Baidu、SONY等全球领先的汽车 电子上游供应商紧密合作，为汽车OEM厂商和 Tier1企业提供完整的解决方案。凭借在Android、Linux、QNX等操作系统上的丰富研 发经验和积累，有效减少客户开发、调试和  验证工期，并加速提升智能网联汽车的品质  及用户体验，同时大大缩短产品上市时间。' },
                    {
                        type: 'twoImage', count: 2,
                        srcList: [
                            { name: null, src: require("../assets/img/industry/intenetwork1.png") },
                            { name: null, src: require("../assets/img/industry/intenetwork2.png") },]
                    },
                    {
                        type: 'text_flex',
                        children: [
                            { type: 'bigTitle', value: '智能座舱系统平台' },
                            { type: 'bigTitle', value: '智能车联系统平台' },
                        ]
                    },
                    {
                        type: 'text_flex',
                        children: [
                            { type: 'text', value: '提供不同平台化产品\n支持多硬件平台及多屏互动\n支持云服务\n5G通信 V2X车路协同\n优秀的多交互模式' },
                            { type: 'text', value: '智能通讯 V2X车路协同\n软件工程服务\n车载导航\n车联网安全' },
                        ]
                    },
                    {
                        type: 'text_flex',
                        children: [
                            { type: 'bigTitle', value: '智能车机' },
                            { type: 'bigTitle', value: '数字仪表' },
                        ]
                    },
                    {
                        type: 'text_flex',
                        children: [
                            { type: 'text', value: '车机硬件平台涉及市面大多数主流芯片\n丰富的前装经验\n能够集AR数据、渲染、交互三大引擎于一身' },
                            { type: 'text', value: '开机速度远高于普遍标准\n支持三方应用双开\n车载导航\n通过系统调优降低硬件成本' },
                        ]
                    },
                    {
                        type: 'text_flex',
                        children: [
                            { type: 'bigTitle', value: 'T-BOX' },
                        ]
                    },
                    {
                        type: 'text_flex',
                        children: [
                            { type: 'text', value: '高水准更稳定\n研发集成C-V2X、ETC功能的5G、V2X、BOX产品\n针对新能源汽车推出电池使用情况与电池健康安全维护功能' },
                        ]
                    },

                ]
            }
        }, {
            pageName: "智能座舱系统平台",
            dataId: "d-1-2",
            data: {
                routerList: ["智能汽车", "智能座舱系统平台"],
                topImg: require("../assets/img/industry/car.jpg"),
                topFont: [
                    // { fontSize: 'small', value: "车载通信解决方案" },
                    // { fontSize: 'normal', value: "车载通信解决方案" },
                    { fontSize: 'normal', value: "智能座舱系统平台" },
                ],
                content: [
                    { type: 'title', value: '智能座舱系统平台' },
                    { type: 'text', value: '八比特智能座舱系统平台，融合IVI、T-BOX、PSE、HUD、Digital Cluster、RSE等智能网联终端，致力于改善下一代智能网联汽车驾驶舱的用户体验，为车主提供更智能、更安全、更简单的汽车生活。' },
                    { type: 'text', value: '智能座舱系统平台集成语音识别功能，用户可根据自己的喜好进行个性化设置, 播放偏好的音乐，调整合适的空调温度、座椅角度，以及切换车机的主题风格等。同时打通双路音源，中控与副驾屏可分别收听不同音乐，并可以进行两屏间的音乐分享，视频资源可以从副屏分享到主屏，两屏进行同步播放，并且双屏用户均可进行视频播放，暂停，进度条调节等。' },
                    { type: 'image', src: require("../assets/img/industry/carbin.png") },
                    { type: 'image', src: require("../assets/img/industry/carbin2.png") }
                ]
            }
        }, {
            pageName: "智能车联系统平台",
            dataId: "d-1-3",
            data: {
                routerList: ["智能汽车", "智能车联系统平台"],
                topImg: require("../assets/img/industry/car.jpg"),
                topFont: [
                    // { fontSize: 'small', value: "车载通信解决方案" },
                    // { fontSize: 'normal', value: "车载通信解决方案" },
                    { fontSize: 'normal', value: "智能车联系统平台" },
                ],
                content: [
                    { type: 'title', value: '智能车联系统平台' },
                    { type: 'text', value: '八比特基于积累多年的物联网云端技术，结合智能座舱系统平台，开发出智能车联系统平台。通过T-BOX车载通信产品，建立车联网基础服务云平台，从而在云、管、端搭建一体化的智能车联系统平台，可快速适配对接第三方应用、平台、TSP，以及车厂OEM私有云联系统、呼叫中心服务，也可根据用户需求，深度定制应用，结合大数据分析，进一步赋能客户价值。' },
                    {
                        type: 'twoImage', count: 2,
                        srcList: [
                            { name: null, src: require("../assets/img/industry/network.png") },
                            { name: null, src: require("../assets/img/industry/network2.png") }]
                    },
                ]
            }
        }, {
            pageName: "智能车机",
            dataId: "d-1-4",
            data: {
                routerList: ["智能汽车", "智能车机"],
                topImg: require("../assets/img/industry/car.jpg"),
                topFont: [
                    // { fontSize: 'small', value: "车载通信解决方案" },
                    // { fontSize: 'normal', value: "车载通信解决方案" },
                    { fontSize: 'normal', value: "智能车机" },
                ],
                content: [
                    { type: 'title', value: '智能车机' },
                    { type: 'text', value: "八比特智能车机的硬件平台涉及NXP、Intel、Qualcomm、Renesas、TI等主流芯片，覆盖高、中、低端全系平台产品，软件平台基于Android、Linux、QNX三大系统，产品定位各种车型，并在8寸、9寸、10.1寸、10.4寸、12.3寸、17寸屏幕上具有大量前装经验，并对横屏、竖屏交互与多应用交互有着深度研究与探索。" },
                    { type: 'text', value: '智能车机的信息娱乐系统，基本功能包括车载语音助手、USB多媒体播放、蓝牙音乐、蓝牙电话、收音机、地图导航、设置、诊断、空调、方控、用户手册等，并可集成第三方应用程序，可以为客户实现Linux、Android系统下对汽车导航、信息、娱乐综合系统的深度定制。' },
                    {
                        type: 'twoImage', count: 2,
                        srcList: [
                            { name: null, src: require("../assets/img/industry/car2.png") },
                            { name: null, src: require("../assets/img/industry/car1.png") }]
                    },
                ]
            }
        }, {
            pageName: "T-Box",
            dataId: "d-1-5",
            data: {
                routerList: ["智能汽车", "T-Box"],
                topImg: require("../assets/img/industry/car.jpg"),
                topFont: [
                    // { fontSize: 'small', value: "车载通信解决方案" },
                    // { fontSize: 'normal', value: "车载通信解决方案" },
                    { fontSize: 'normal', value: "T-Box" },
                ],
                content: [
                    { type: 'title', value: 'T-Box' },
                    { type: 'text', value: "T-BOX产品是车联网必要入口和唯一通道。八比特基于多年开发经验，通过T-BOX产品赋能客户，给整车提供X-CALL、远程监控、诊断、控制、无线升级、网络防护、数据安全、全球高精度定位等功能，为客户深度打造整合、丰富、安全的智能网联体验。" },
                    {
                        type: 'threeImage', count: 3,
                        srcList: [
                            { name: null, src: require("../assets/img/industry/tbox2.png") },
                            { name: null, src: require("../assets/img/industry/tbox3.png") },
                            { name: null, src: require("../assets/img/industry/tbox5.jpg") },
                        ]
                    },
                ]
            }
        }, {
            pageName: "数字仪表",
            dataId: "d-1-6",
            data: {
                routerList: ["智能汽车", "数字仪表"],
                topImg: require("../assets/img/industry/car.jpg"),
                topFont: [
                    // { fontSize: 'small', value: "车载通信解决方案" },
                    // { fontSize: 'normal', value: "车载通信解决方案" },
                    { fontSize: 'normal', value: "数字仪表" },
                ],
                content: [
                    { type: 'title', value: '数字仪表' },
                    { type: 'text', value: "数字仪表是指将传统机械仪表盘替换成一整块液晶屏幕向驾驶者展示车辆行驶信息的设备，取消了传统的物理指针，全部通过电子屏幕展示。它的优点是不仅能传达给驾驶者传统机械仪表盘展示的车辆行驶速度、发动机转速、剩余油量等基本信息，还能使显示效果更加绚丽、实现个性化设置、显示内容更丰富，还提升了整车的科技感。" },
                    { type: 'text', value: '八比特数字仪表搭载高度定制化的QNX操作系统，针对汽车仪表特性裁剪内核，高于业内普遍标准的开机速度。支持QT、KANZI专业化图形引擎及设计工具，适配NXP i.MX6，i.MX8，Ti J6，Renesas R-CAR多个芯片平台，具备强大的图像处理和显示效果，具有HMI可配置、分辨率可适配的特点，并能够为客户提供专业的UI/UX设计，提升用户体验和驾驶安全。' },
                    { type: 'image', src: require("../assets/img/industry/instrument.png") },
                    { type: 'image', src: require("../assets/img/industry/instrument2.png") },
                ]
            }
        }, {
            pageName: "车载通信解决方案",
            dataId: "d-2-1",
            data: {
                routerList: ["产品", "服务", "车载通信解决方案"],
                topImg: require("../assets/img/industry/car.jpg"),
                topFont: [
                    // { fontSize: 'small', value: "车载通信解决方案" },
                    // { fontSize: 'normal', value: "车载通信解决方案" },
                    { fontSize: 'normal', value: "车载通信解决方案" },
                ],
                content: [
                    { type: 'title', value: '车载通信解决方案' },
                    { type: 'textImg_left', src: require("../assets/img/industry/message2.png"), value: '数字仪表是指将传统机械仪表盘替换成一整块液晶屏幕向驾驶者展示车辆行驶信息的设备，取消了传统的物理指针，全部通过电子屏幕展示。它的优点是不仅能传达给驾驶者传统机械仪表盘展示的车辆行驶速度、发动机转速、剩余油量等基本信息，还能使显示效果更加绚丽、实现个性化设置、显示内容更丰富，还提升了整车的科技感。\n\n八比特数字仪表搭载高度定制化的QNX操作系统，针对汽车仪表特性裁剪内核，高于业内普遍标准的开机速度。支持QT、KANZI专业化图形引擎及设计工具，适配NXP i.MX6，i.MX8，Ti J6，Renesas R-CAR多个芯片平台，具备强大的图像处理和显示效果，具有HMI可配置、分辨率可适配的特点，并能够为客户提供专业的UI/UX设计，提升用户体验和驾驶安全。' },
                    {
                        type: 'twoImage', count: 2,
                        srcList: [
                            { name: null, src: require("../assets/img/industry/message3.png") },
                            { name: null, src: require("../assets/img/industry/message.png") }]
                    },
                ]
            }
        }, {
            pageName: "智慧互联解决方案",
            dataId: "d-2-2",
            data: {
                routerList: ["产品", "服务", "智慧互联解决方案"],
                topImg: require("../assets/img/industry/car.jpg"),
                topFont: [
                    // { fontSize: 'small', value: "智慧互联解决方案" },
                    // { fontSize: 'normal', value: "智慧互联解决方案" },
                    { fontSize: 'normal', value: "智慧互联解决方案" },
                ],
                content: [
                    { type: 'title', value: '智慧互联解决方案' },
                    { type: 'textImg_left', src: require("../assets/img/industry/link.png"), value: '智慧互联解决方案，从用户角度出发，结合手机移动端，可以适配搭载多款智能车机，并为主流车厂提供了手车互联的解决方案。它构建了人与车之间的生态互联，将手机与车机轻松快捷连接，车主在驾驶中便可安全体验到手机端的所有应用服务和智能推送，给车主带来更安全，更便捷的全新互联网驾驶体验。\n\n除传统手机互联投屏方案外，还可提供数据共享方案，重新定义了人车互联的新玩法，覆盖多种场景，为用户量身定制，提供了如车载微信、导航通讯、天气股票、新闻资讯、音乐视频、FM情景、笑话百科、车辆设置等丰富的内容。解决方案可以快速实现，提供高品质的出行体验，相对完善的应用生态体系，并提供车厂OEM定制的车机应用。' },
                ]
            }
        }, {
            pageName: "智能交互解决方案",
            dataId: "d-2-3",
            data: {
                routerList: ["产品", "服务", "智能交互解决方案"],
                topImg: require("../assets/img/industry/car.jpg"),
                topFont: [
                    // { fontSize: 'small', value: "智能交互解决方案" },
                    // { fontSize: 'normal', value: "智能交互解决方案" },
                    { fontSize: 'normal', value: "智能交互解决方案" },
                ],
                content: [
                    { type: 'title', value: '智能交互解决方案' },
                    { type: 'textImg_left', src: require("../assets/img/industry/interaction5.jpg"), value: '智能交互解决方案，实现了人与车之间的“对话”功能。车主可通过系统，轻松把握车辆状态信息（车速、里程、当前位置、车辆保养信息等）、路况信息、定速巡航设置、蓝牙免提设置、空调及音响的设置。交互目的是当驾驶员在操作各项功能时尽量不影响其对驾驶本身的注意力。而传统的点、按、旋钮式的操作过于复杂会使驾驶员的视线离开路面，这也是语音与手势存在的逻辑基础。\n\n智能交互解决方案主要包括语音识别和手势识别。理想中的交互方式，不是某一种交互方式，而是多种交互方式的融合，为用户多场景的使用提供最优化的便利服务。' },
                    {
                        type: 'twoImage', count: 2,
                        srcList: [
                            { name: null, src: require("../assets/img/industry/interaction2.jpg") },
                            { name: null, src: require("../assets/img/industry/interaction3.jpg") }]
                    },
                ]
            }
        }, {
            pageName: "智能升级解决方案",
            dataId: "d-2-4",
            data: {
                routerList: ["产品", "服务", "智能升级解决方案"],
                topImg: require("../assets/img/industry/car.jpg"),
                topFont: [
                    // { fontSize: 'small', value: "智能升级解决方案" },
                    // { fontSize: 'normal', value: "智能升级解决方案" },
                    { fontSize: 'normal', value: "智能升级解决方案" },
                ],
                content: [
                    { type: 'title', value: '智能升级解决方案' },
                    { type: 'textImg_left', src: require("../assets/img/industry/interaction5.jpg"), value: '基于主机厂在平台发布的更新包，车辆可实现随时进行固件、车身控制系统、车载系统等系统远程升级，快速修复系统缺陷，有效降低售后服务成本。\n\n智能升级解决方案支持汽车以及各种智能物联网终端，支持多种架构的智能移动终端，如手机、平板、智能网联设备，通过OMA-DM标准认证，支持差分算法，使升级更加高效可靠，同时支持多分区，在实车MCU、ECU模块进行升级认证。采用高效开发合作模式，缩短开发周期，丰富的平台化部署项目经验，完美接入车厂全流程IT系统，全方位的升级安全防护机制，基于标准的认证、身份验证和加密，支持硬件安全加密，安全守卫OTA升级。' },
                    {
                        type: 'twoImage', count: 2,
                        srcList: [
                            { name: null, src: require("../assets/img/industry/interaction2.jpg") },
                            { name: null, src: require("../assets/img/industry/interaction3.jpg") }]
                    },
                ]
            }
        }, {
            pageName: "车载关键技术",
            dataId: "d-2-5",
            data: {
                routerList: ["产品", "服务", "车载关键技术"],
                topImg: require("../assets/img/industry/car.jpg"),
                topFont: [
                    // { fontSize: 'small', value: "车载关键技术" },
                    // { fontSize: 'normal', value: "车载关键技术" },
                    { fontSize: 'normal', value: "车载关键技术" },
                ],
                content: [
                    { type: 'title', value: '车载关键技术' },
                    { type: 'bigTitle', value: '手机互联' },
                    { type: 'textImg_left', src: require("../assets/img/industry/phone_connect1.png"), value: '手机互联技术构建了人与车之间的生态互联，将手机与车机轻松快捷连接，车主在驾驶中便可安全体验到手机端的所有应用服务和智能推送，给车主带来更安全，更便捷的全新互联网驾驶体验。拥有目前主流的各种智能网联汽车与手机互联的解决方案，可以根据客户需求，提供多种互联解决方案Android Auto、Carplay、Carlife、SmartLink。' },
                    { type: 'bigTitle', value: '操作系统性能和稳定性优化' },
                    { type: 'textImg_left', src: require("../assets/img/industry/system.png"), value: '拥有Qualcomm、TI、NXP、Renesas、ST等各个平台主流芯片的驱动开发能力，并根据客户需要进行灵活的定制。通过对Android/Linux操作系统的BSP、Kernel和Framework进行优化和调整，能够为客户智能网联汽车系统提供更好的性能和稳定性。同时通过对HMI Framework和显示算法的优化和调整，能够为客户提供更好的UI/UX操作体验。' },
                    { type: 'bigTitle', value: 'CAN协议栈和应用' },
                    { type: 'textImg_left', src: require("../assets/img/industry/can.png"), value: '经过多年在CAN协议开发方面的经验，具有对市面上成熟的CAN协议栈的集成和定制能力。CAN协议开发涉及Application layer、Physical Layer、Communication layer、Diagnostic（UDS or KWP2000）、OSEK NM、AutoSar NM等，以及具备完整CAN模组测试方案。' },
                    { type: 'bigTitle', value: 'MCU/ECU开发' },
                    { type: 'textImg_left', src: require("../assets/img/industry/mcu.jpg"), value: '具有基于AUTOSAR标准环境开发的经验，拥有NXP、Renesas、TI、CYPRESS、STM32、FUJITSU等主流芯片开发能力，能够结合客户具体需求，对MCU/ECU芯片进行定制开发。同时基于实时操作系统μCOS、FreeRTOS等，进行物联网系统定制开发能力。' },
                    { type: 'bigTitle', value: '语音识别' },
                    { type: 'textImg_left', src: require("../assets/img/industry/voice1.jpg"), value: '基于科大讯飞、思必驰、Nuance、Google、亚马逊等语音识别引擎，针对智能车载应用场景为用户提供语音免唤醒及语音控制汽车车窗、天窗、空调、蓝牙电话、多媒体音源等语音助手解决方案，可根据车厂/OEM需求，快速定制，跨系统平台，支持多国语言输入、随时打断/唤醒等。' },
                ]
            }
        }, {
            pageName: "关于我们",
            dataId: "3-1-1",
            data: {
                routerList: ["公司信息", "关于我们"],
                topImg: require("../assets/img/service1/new_bg.webp"),
                topFont: [
                    { fontSize: 'normal', value: "公司介绍" },   // 新增这一行

                ],
                content: [
                    // { type: 'title', value: '公司简介' },
                    // 添加小标题1
                    { type: 'subtitle', value: '成为卓越的智能技术方案提供商' },
                    { type: 'text', value: '八比特科技有限公司创建于 2014 年，是一家专注于智能技术研发的创新型科技企业、国家高新技术企业、专精特新企业。目前旗下七家公司，分布于深圳、上海、大连、沈阳、重庆。公司基于“AI-Driven”智能驱动的战略导向，深耕智能汽车、智慧医疗、金融社保、智慧教育领域，为客户提供完整的智能技术解决方案和智能产品，涵盖企划、运营、研发、生产、评测、销售、维护各生态链环节。' },
                    // { type: 'text', value: '' },
                    { type: 'text', value: '产品与服务中，汽车智能座舱、汽车智能驾驶、汽车电源控制、无人机智能飞控、彩超图形图像、磁共振成像、血液细胞分析仪、社保信息管理系统、医院信息管理系统是主要产品，多年来各系统持续运转，实战中在精确度、高效能、可靠性、稳定性、可维护性等方面得到严格验证，持续赢得了客户满意与认同。' },
                    { type: 'text', value: '科技引领未来，创新点亮生活。公司以探索未来科技，创新智慧生活为愿景，以成为卓越的智能技术方案提供商为使命，持续产品迭代和优化，用匠心精神赋能科技发展，致力于与全球合作伙伴在汽车产业链、医疗产业链、政务服务产业链、教育产业链中协同发展共创未来。' },
                    // 添加小标题2
                    { type: 'subtitle', value: '八比特名字由来' },
                    { type: 'text', value: '八比特是计算机运算的最小存储单元，即一个字节，从一个字节开始存储了整个计算世界，取其求真、务实之意，寓意着科技发展始于基础，继而开创未来。' },
                    // 添加小标题3
                    { type: 'subtitle', value: '发展历程' },
                    { type: 'text', value: '• 2014 年，成立大连八比特科技有限公司' },
                    { type: 'text', value: '• 2014 年，成立深圳八比特信息技术有限公司' },
                    { type: 'text', value: '• 2015 年，成立重庆八比特科技有限公司' },
                    { type: 'text', value: '• 2016 年，成立上海八比信息技术有限公司' },
                    { type: 'text', value: '• 2020 年，成立八比智联（沈阳）科技有限公司' },
                    { type: 'text', value: '• 2020 年，成立八比智行（大连）科技有限公司' },
                    { type: 'text', value: '• 2025 年，成立深圳八比特科技有限公司' },
                    // { type: 'title', value: '产品优势' },
                    // { type: 'text', value: '自2014年，八比特基于积累多年的嵌入式操作系统优化技术、人机交互、机器视觉、以及语音和音频技术，为汽车提供从操作系统开发到应用定制，包括汽车信息娱乐系统、智能仪表盘、集成驾驶舱和音频产品在内的整体智能座舱软件解决方案和技术服务，为驾乘者提供丰富、先进的智能驾驶体验。八比特与Qualcomm、Renesas、TI、NXP、ST、QNX、Intel、Baidu、SONY等全球领先的汽车电子上游供应商紧密合作，为汽车OEM厂商和Tier1提供完整的解决方案、工具和服务。凭借在Android、Linux、QNX等操作系统上的丰富研发经验，可以有效减少客户开发、调试和验证工期，并加速提升智能网联汽车的品质及用户体验，同时大大缩短产品上市时间。' },

                ]
            }
        }, {
            pageName: "发展历程",
            dataId: "3-1-2old",
            data: {
                routerList: ["公司信息", "发展历程"],
                topImg: require("../assets/img/service1/new_bg.webp"),
                topFont: [
                    // { fontSize: 'normal', value: "发展历程" },
                    // { fontSize: 'small', value: "发展历程" },

                ],
                content: [
                    { type: 'title', value: '发展历程' },
                    { type: 'bigTitle', value: '2014年' },
                    { type: 'text', value: '03月 创建大连八比特科技有限公司\n05月 成立八比特科技沈阳分公司\n12月 成立深圳八比特信息技术有限公司' },
                    { type: 'bigTitle', value: '2015年' },
                    { type: 'text', value: '11月 成立重庆八比特科技有限公司' },
                    { type: 'bigTitle', value: '2016年' },
                    { type: 'text', value: '02月 成立上海八比信息技术有限公司' },
                    { type: 'bigTitle', value: '2017年' },
                    { type: 'text', value: '04月 车载业务与航盛电子开始深度合作，集中在智能座舱领域，产品面向国内市场' },
                    { type: 'bigTitle', value: '2018年' },
                    { type: 'text', value: '08月 八比特科技获得大连市第四届科技创业大赛二等奖\n10月 八比特科技造访杭州，深度考察阿里巴巴\n10月 八比特科技走进杭州\n11月 八比特公司参加中国创新创业大赛\n12月 大连市科技局领导莅临八比特\n12月 大连理工大学到八比特科技参观' },
                    { type: 'bigTitle', value: '2019年' },
                    { type: 'text', value: '01月 第四届大连市科技创新创业大赛圆满收官\n02月 五菱Almaz上市\n05月 日本AT Works株式会社东京本社造访八比特科技\n09月 电动名爵EZS泰国上市\n10月 2020款宝骏530成功上市\n10月 八比特科技阔别弘泰大厦，喜迁海事科技大厦' },
                    { type: 'bigTitle', value: '2020年' },
                    { type: 'text', value: '07月 2020年首届软件定义汽车高峰论坛圆满落幕\n07月 成立八比智联（沈阳）科技有限公司\n12月 成立八比智行（大连）科技有限公司' },
                    { type: 'bigTitle', value: '2021年' },
                    { type: 'text', value: '07月 八比特科技成功亮相2021中国国际数字和软件服务交易会' },
                    { type: 'bigTitle', value: '2022年' },
                    { type: 'text', value: '06月 助力智能汽车快速发展，华为代表团到访八比特科技调研\n06月 八比特科技出席“海聚高新 创新未来”系列活动之第三场活动' },
                    { type: 'bigTitle', value: '2023年' },
                    { type: 'text', value: '03月 八比特科技当选大连市车联网产业创新联盟第二届理事单位 \n04月 江西交通职业技术学院在八比特科技设立校外实训基地与就业实践基地\n11月 八比特科技车载项目获 “数字辽宁 智造强省” 专项资金支持\n12月 八比智联（沈阳）科技有限公司成功获得 “国家高新技术企业” 认定\n12月 八比特科技荣获2023年辽宁省 “专精特新” 中小企业称号' },
                    { type: 'bigTitle', value: '2024年' },
                    { type: 'text', value: '01月 八比智联、八比智行成功入选辽宁省“雏鹰企业”\n05月 八比特科技荣获2024年车联网成长企业称号\n11月 重庆八比特获评"国家高新技术企业"\n12月 八比特旗下大连八比特科技有限公司、八比智行（大连）科技有限公司再获国家高新技术企业认定\n12月 大连八比特科技有限公司成功当选为第三届理事会的副理事长单位 '},
                    { type: 'bigTitle', value: '2025年' },
                    { type: 'text', value: "01月 成立深圳八比特科技有限公司" },
                ]
            }
        }, {
            pageName: "主要合作企业及品牌",
            dataId: "old3-1-3",
            data: {
                routerList: ["合作与联系", "主要合作企业及品牌"],
                topImg: require("../assets/img/service1/new_bg.webp"),
                topFont: [
                    // { fontSize: 'normal', value: "合作客户" },
                    // { fontSize: 'small', value: "合作客户" },

                ],
                content: [
                    { type: 'title', value: '合作品牌' },
                    {
                        type: 'fourImage', count: 4,
                        srcList: [
                            { name: null, src: require("../assets/img/aboutUs/kh/kh1.jpg") },
                            { name: null, src: require("../assets/img/aboutUs/kh/kh2.jpg") },
                            { name: null, src: require("../assets/img/aboutUs/kh/kh3.jpg") },
                            { name: null, src: require("../assets/img/aboutUs/kh/kh4.jpg") },]

                    }, {
                        type: 'fourImage', count: 4,
                        srcList: [
                            { name: null, src: require("../assets/img/aboutUs/kh/kh5.jpg") },
                            { name: null, src: require("../assets/img/aboutUs/kh/kh6.jpg") },
                            { name: null, src: require("../assets/img/aboutUs/kh/kh7.jpg") },
                            { name: null, src: require("../assets/img/aboutUs/kh/kh8.jpg") },]

                    }, {
                        type: 'fourImage', count: 4,
                        srcList: [
                            { name: null, src: require("../assets/img/aboutUs/kh/kh9.jpg") },
                            { name: null, src: require("../assets/img/aboutUs/kh/kh10.jpg") },
                            { name: null, src: require("../assets/img/aboutUs/kh/kh11.jpg") },
                            { name: null, src: require("../assets/img/aboutUs/kh/kh12.jpg") },]
                    }, {
                        type: 'fourImage', count: 4,
                        srcList: [
                            { name: null, src: require("../assets/img/aboutUs/kh/kh13.jpg") },
                            { name: null, src: require("../assets/img/aboutUs/kh/kh14.jpg") },]
                    },
                    { type: 'bigTitle', value: '' },
                    { type: 'bigTitle', value: '' },
                    { type: 'title', value: '合作企业' },
                    {
                        type: 'fourImage', count: 4,
                        srcList: [
                            { name: null, src: require("../assets/img/aboutUs/hb/hb1.jpg") },
                            { name: null, src: require("../assets/img/aboutUs/hb/hb2.jpg") },
                            { name: null, src: require("../assets/img/aboutUs/hb/hb3.jpg") },
                            { name: null, src: require("../assets/img/aboutUs/hb/hb4.jpg") },]
                    }, {
                        type: 'fourImage', count: 4,
                        srcList: [
                            { name: null, src: require("../assets/img/aboutUs/hb/hb.jpg") },
                            { name: null, src: require("../assets/img/aboutUs/hb/hb6.jpg") },
                            { name: null, src: require("../assets/img/aboutUs/hb/hb7.png") },
                            { name: null, src: require("../assets/img/aboutUs/hb/hb8.jpg") },]

                    }, {
                        type: 'fourImage', count: 4,
                        srcList: [
                            { name: null, src: require("../assets/img/aboutUs/hb/hb9.jpg") },
                            { name: null, src: require("../assets/img/aboutUs/hb/hb10.jpg") },
                            { name: null, src: require("../assets/img/aboutUs/hb/hb11.jpg") },
                            { name: null, src: require("../assets/img/aboutUs/hb/hb12.jpg") },]
                    }, {
                        type: 'fourImage', count: 4,
                        srcList: [
                            { name: null, src: require("../assets/img/aboutUs/hb/hb13.jpg") },
                            { name: null, src: require("../assets/img/aboutUs/hb/hb14.jpg") },
                            { name: null, src: require("../assets/img/aboutUs/hb/hb15.jpg") },
                            { name: null, src: require("../assets/img/aboutUs/hb/hb16.jpg") },]
                    }, {
                        type: 'fourImage', count: 4,
                        srcList: [
                            { name: null, src: require("../assets/img/aboutUs/hb/hb17.jpg") },
                            { name: null, src: require("../assets/img/aboutUs/hb/hb18.jpg") },]
                    },
                ]
            }
        }, {
            pageName: "合作伙伴",
            dataId: "3-1-4",
            data: {
                routerList: ["合作与联系", "合作伙伴"],
                topImg: require("../assets/img/service1/new_bg.webp"),
                topFont: [
                    // { fontSize: 'normal', value: "合作伙伴" },
                    // { fontSize: 'small', value: "合作伙伴" },

                ],
                content: [
                    { type: 'title', value: '合作伙伴' },
                    {
                        type: 'fourImage', count: 4,
                        srcList: [
                            { name: null, src: require("../assets/img/aboutUs/hb/hb1.jpg") },
                            { name: null, src: require("../assets/img/aboutUs/hb/hb2.jpg") },
                            { name: null, src: require("../assets/img/aboutUs/hb/hb3.jpg") },
                            { name: null, src: require("../assets/img/aboutUs/hb/hb4.jpg") },]
                    }, {
                        type: 'fourImage', count: 4,
                        srcList: [
                            { name: null, src: require("../assets/img/aboutUs/hb/hb.jpg") },
                            { name: null, src: require("../assets/img/aboutUs/hb/hb6.jpg") },
                            { name: null, src: require("../assets/img/aboutUs/hb/hb7.png") },
                            { name: null, src: require("../assets/img/aboutUs/hb/hb8.jpg") },]

                    }, {
                        type: 'fourImage', count: 4,
                        srcList: [
                            { name: null, src: require("../assets/img/aboutUs/hb/hb9.jpg") },
                            { name: null, src: require("../assets/img/aboutUs/hb/hb10.jpg") },
                            { name: null, src: require("../assets/img/aboutUs/hb/hb11.jpg") },
                            { name: null, src: require("../assets/img/aboutUs/hb/hb12.jpg") },]
                    }, {
                        type: 'fourImage', count: 4,
                        srcList: [
                            { name: null, src: require("../assets/img/aboutUs/hb/hb13.jpg") },
                            { name: null, src: require("../assets/img/aboutUs/hb/hb14.jpg") },
                            { name: null, src: require("../assets/img/aboutUs/hb/hb15.jpg") },
                            { name: null, src: require("../assets/img/aboutUs/hb/hb16.jpg") },]
                    }, {
                        type: 'fourImage', count: 4,
                        srcList: [
                            { name: null, src: require("../assets/img/aboutUs/hb/hb17.jpg") },
                            { name: null, src: require("../assets/img/aboutUs/hb/hb18.jpg") },]
                    },
                ]
            }
        }, {
        pageName: "联系我们",
        dataId: "3-1-5",
        data: {
            routerList: ["合作与联系", "联系我们"],
            topImg: require("../assets/img/service1/new_bg.webp"),
            topFont: [],
            content: [
                { type: 'title', value: '官方邮箱' },
                { type: 'text', value: 'service@cn8bit.com' },

                { type: 'title', value: '联系电话', margin: '40px 0 15px 0' },
                { type: 'text', value: '0411-84573211\n0411-84457557' },

                { type: 'title', value: '官方微信', margin: '40px 0 15px 0' },
                { type: 'image', src: require("../assets/img/aboutUs/8bit_code_1.jpg"), width: '130px', name: '八比特科技' },

                { type: 'title', value: '地址', margin: '40px 0 15px 0' },
                { type: 'text', value: '深圳：南山区南海大道3003号阳光华艺大厦A座4层\n大连：高新园区黄浦路523号海事科技大厦A座21层\n上海：徐汇区虹漕路421号虹漕园62幢301室\n重庆：两江新区星光大道90号土星A2座13层\n沈阳：浑南区国际软件园E01座14层' },

                { type: 'title', value: '商务合作', margin: '40px 0 15px 0' },
                { type: 'image', src: require("../assets/img/aboutUs/code_2.jpg"), width: '130px', name: '备注：商务合作' },
            ]
        }
    }, {
            pageName: "加入我们",
            dataId: "3-1-6old",
            data: {
                routerList: ["公司简介", "加入我们"],
                topImg: require("../assets/img/service1/new_bg.webp"),
                topFont: [
                    // { fontSize: 'normal', value: "加入我们" },
                    // { fontSize: 'small', value: "加入我们" },
                ],
                content: [
                    { type: "firstTitle", value: "汇聚英才 共赴新程", layout: "center" },
                    { type: "Title", value: "我们坚信，独特的品质能将卓越个体凝聚。", layout: "center", margin: '0 0 100px 0' },
                    // {
                    //     type: 'spaceBetweenMore', value: '',layout:'flex-center', layout1: "flex-start", layout2: "flex-end",
                    //     width1: "60%",
                    //     children1: [
                    //         { type: 'image', src: require("../assets/img/aboutUs/workSpace/evn_five.jpg") }
                    //     ],
                    //     children2: [
                    //         { type: 'bigTitle', value: '汇聚英才 共赴新程' },
                    //         { type: 'text', value: '我们坚信，独特的品质能将卓越个体凝聚。' },
                    //     ],
                    // },
                    {
                        type: 'spaceBetweenMore', value: '', layout1: "flex-start", layout2: "flex-end",
                        width1: "60%", margin: '0 0 150px 0',
                        children1: [
                            { type: 'bigTitle', value: '勇于开拓 突破边界', margin: '0 0 20px 0' },
                            { type: 'text', value: '创新源于无畏的探索与细微的积累。我们怀揣对未知的热忱，不惧新想法带来的挑战，敢于踏入无人之境。在技术浪潮中，以开拓精神引领前行，用创新笔触描绘未来蓝图，力求以前沿科技重塑行业格局。' },

                        ],
                        children2: [
                            { type: 'image', src: require("../assets/img/aboutUs/aboutUs1.jpg") }
                        ],
                    },
                    {
                        type: 'spaceBetweenMore', value: '', layout1: "flex-start", layout2: "flex-end",
                        width1: "60%", margin: '0 0 150px 0',
                        children1: [
                            { type: 'image', src: require("../assets/img/aboutUs/aboutUs2.jpg") }
                        ],
                        children2: [
                            { type: 'bigTitle', value: '笃信科学 探求本真', margin: '0 0 20px 0' },
                            { type: 'text', value: '秉持科学精神，倡导自由且严谨的探索氛围。在知识的殿堂里，摒弃等级与偏见，以开放的姿态交流碰撞。我们不迷信权威，不依赖过往经验，只尊崇事实与真理，在科学的道路上不断深耕，挖掘事物本质，让真知驱动发展。' },
                        ],
                    },
                    {
                        type: 'spaceBetweenMore', value: '', layout1: "flex-start", layout2: "flex-end",
                        width1: "60%", margin: '0 0 150px 0',
                        children1: [
                            { type: 'bigTitle', value: '好学奋进 精进不休', margin: '0 0 20px 0' },
                            { type: 'text', value: '深知成功需汗水浇筑，天赋不过是锦上添花。我们以好学为帆，以勤奋为桨，在知识的海洋中持续远航。每一位伙伴都如孜孜不倦的求学者，在各自领域精研深耕，以专业实力铸就坚实阶梯，稳步迈向卓越。' },

                        ],
                        children2: [
                            { type: 'image', src: require("../assets/img/aboutUs/aboutUs3.jpg") }
                        ],
                    },
                    {
                        type: 'spaceBetweenMore', value: '', layout1: "flex-start", layout2: "flex-end",
                        width1: "60%", margin: '0 0 150px 0',
                        children1: [
                            { type: 'image', src: require("../assets/img/aboutUs/aboutUs4(1).jpg") }
                        ],
                        children2: [
                            { type: 'bigTitle', value: '携手共进 谦逊致远', margin: '0 0 20px 0' },
                            { type: 'text', value: '过往荣耀皆为序章，新的朝阳每天都在升起。我们珍视团队中每一份独特才华，明白个体的光芒汇聚才能照亮前行之路。秉持谦逊态度，相互学习、彼此支持，携手并肩在新征程上稳步迈进，共同书写更辉煌的篇章。' },
                        ],
                    },
                    // { type: 'bigTitle', value: 'UI设计岗应届实习生' },
                    // { type: 'text', value: '一、岗位内容：\n1. 负责独立设计各种类型的UI界面，包括但不限于Web、App、小程序、PC等界面的设计；\n2. 研究最新用户体验设计趋势和技术，持续推进产品设计优化，提升用户满意度；\n3. 制定企业视觉设计规范，并对现有设计进行改进和完善。\n\n二、任职要求：\n1. 学历不限，计算机软件/平面设计/交互设计/视觉传达等相关专业背景；\n2. 精通Sketch、Photoshop、Illustrator等设计软件，具有深厚的设计功底，熟悉最新的UI设计规范；\n3. 有较强的自我驱动力和学习意愿，关注国内外最新设计动态和流行趋势；\n4. 具备良好的沟通协调能力和团队协作精神，能够适应快速变化的环境。\n5.具有Java前端开发基础优先考虑\n\n三、实习时长\n实习期不可少于两个月，表现优异者，实习结束毕业后可申请转正。\n工作地点：大连高新园区' },
                ]
            }
        },{
        pageName: "愿景与使命",
        dataId: "3-1-2",
        data: {
            routerList: ["关于八比特", "了解我们", "愿景与使命"],
            topImg: require("../assets/img/service1/new_bg.webp"),
            topFont: [
                { fontSize: 'normal', value: "愿景与使命" },
            ],
            content: [
                { type: 'title', value: '愿景 Vision' },
                { type: 'text', value: '探索未来科技 创新智慧生活' },
                { type: 'title', value: '使命 Mission' },
                { type: 'text', value: '成为卓越的智能技术方案提供商' },
                { type: 'title', value: '价值观 Values' },
                { type: 'text', value: '成就客户 艰苦奋斗' },
                { type: 'text', value: '团队合作 拥抱变化' },
                { type: 'text', value: '热情谦逊 真诚守信' },
            ]
        }
    },{
        pageName: "资质认证",
        dataId: "3-1-3",
        data: {
            routerList: ["关于八比特", "了解我们", "资质认证"],
            topImg: require("../assets/img/service1/new_bg.webp"),
            topFont: [
                { fontSize: 'normal', value: "资质认证" },
            ],
            content: [
                { type: 'title', value: '公司资质与荣誉' },
                { type: 'text', value: '• 国家高新技术企业' },
                { type: 'text', value: '• 辽宁省专精特新中小企业' },
                { type: 'text', value: '• CMMI 3级认证' },
                { type: 'text', value: '• ISO9001质量管理体系认证' },
                { type: 'text', value: '• 大连市车联网产业创新联盟副理事长单位' },
                { type: 'text', value: '• 2024年车联网创新企业' },
                // 你可以根据公司实际资质继续添加
            ]
        }
    },{
        pageName: "社会招聘",
        dataId: "3-2-2",
        data: {
            routerList: ["公司信息", "工作机会", "社会招聘"],
            topImg: require("../assets/img/service1/new_bg.webp"),
            topFont: [
                { fontSize: 'normal', value: "社会招聘" },
            ],
            content: {
                pageTitle: "社会招聘",
                jobs: [
                    {
                        id: "job_1",
                        title: "项目经理",
                        workplace: "工作地点：大连、深圳、上海、重庆、沈阳",
                        responsibilities: "1.负责汽车电子嵌入式、无人机或SaaS系统相关项目的全生命周期管理，包括需求分析、计划制定、进度跟踪、风险控制与交付验收。\n2.协调研发、测试、销售等多部门资源，确保项目按时保质完成。\n3.与客户及内部干系人保持高效沟通，管理需求变更与预期。\n4.定期输出项目报告，推动流程优化与经验沉淀。",
                        requirements: "1.本科及以上学历，计算机、电子、自动化、通信等相关专业。\n2.3年以上项目管理经验，有嵌入式、无人机或SaaS类项目背景者优先。\n3.具备优秀的沟通、组织与抗压能力，能接受短期出差。"
                    },
                    {
                        id: "job_2",
                        title: "项目组长（技术方向）",
                        workplace: "工作地点：大连、深圳、上海、重庆、沈阳",
                        responsibilities: "1.带领5-10人技术团队完成嵌入式、无人机或SaaS系统的模块开发与交付。\n2.参与技术方案设计、代码评审、任务拆解与进度管理。\n3.解决项目中的关键技术难点，指导初中级开发人员成长。\n4.配合项目经理完成计划制定、风险识别与质量把控。",
                        requirements: "1.本科及以上学历，5年以上相关领域开发经验，1年以上团队管理或技术Leader经验。\n2.熟练掌握C/C++/Python/Java中的至少一种，有嵌入式RTOS、无人机飞控或云原生架构经验者优先。\n3.具备良好的任务分解与进度把控能力，熟悉Git、Jira等协作工具。\n4.积极主动，乐于分享，能适应多项目并行的工作节奏。"
                    },
                    {
                        id: "job_3",
                        title: "嵌入式软件开发工程师（汽车电子方向）",
                        workplace: "工作地点：大连、深圳、上海、重庆、沈阳",
                        responsibilities: "1.负责汽车电子相关产品（如ECU、域控制器、车载传感器等）的嵌入式软件设计与开发。\n2.参与底层驱动、中间件或应用层逻辑的实现与调试。\n3.配合硬件团队完成板级调试、问题定位与性能优化。\n4.编写相关技术文档，支持产品测试与量产维护。",
                        requirements: "1.本科及以上学历，电子、计算机、自动化、车辆工程等相关专业。\n2.2年以上嵌入式开发经验，熟悉ARM Cortex系列、RTOS（FreeRTOS、ThreadX等）。\n3.熟练掌握C/C++，了解CAN、LIN、以太网等车载通信协议。\n4.有Autosar、功能安全（ISO 26262）经验者优先。\n5.优秀应届生亦可。"
                    },
                    {
                        id: "job_4",
                        title: "无人机软件开发工程师",
                        workplace: "工作地点：大连、深圳、上海、重庆、沈阳",
                        responsibilities: "1.负责无人机飞行控制、导航、链路通信或地面站软件的开发与优化。\n2.参与飞控算法移植、传感器数据融合、失效保护逻辑等模块实现。\n3.配合测试团队完成整机联调、问题排查与性能迭代。\n4.跟进前沿技术，提升系统稳定性与智能化水平。",
                        requirements: "1.本科及以上学历，飞行器设计、自动化、计算机、通信等相关专业。\n2.熟悉PX4/ArduPilot等开源飞控框架，有实际产品开发经验。\n3.熟练掌握C/C++，了解ROS、MAVLink协议、惯性导航基础。\n4.有无人机竞赛、仿真或集群控制经验者优先。\n5.优秀应届生亦可。"
                    },
                    {
                        id: "job_5",
                        title: "SaaS系统开发工程师（全栈）",
                        workplace: "工作地点：大连、深圳、上海、重庆、沈阳",
                        responsibilities: "1.参与公司SaaS平台的核心业务模块设计、开发与维护（如订单、用户、数据可视化等）。\n2.负责RESTful API、数据库优化、微服务组件开发。\n3.与前端、产品协作完成功能迭代，保障系统高可用与可扩展性。\n4.参与技术选型、代码规范制定与文档编写。",
                        requirements: "1.本科及以上学历，计算机相关专业。\n2.2年以上后端开发经验，熟练使用Java/Go/Python中的至少一种，熟悉Spring Boot/Go-zero/FastAPI等框架。\n3.掌握MySQL、Redis、消息队列（Kafka/RabbitMQ），了解Docker/K8s。\n4.有SaaS产品、租户隔离、支付对接经验者优先。\n5.优秀应届生亦可。"
                    },
                    {
                        id: "job_6",
                        title: "销售经理 / 客户经理",
                        workplace: "工作地点：大连、深圳、上海、重庆、沈阳",
                        responsibilities: "1.负责公司业务（汽车电子嵌入式方案/无人机产品/SaaS系统）的客户开发与销售拓展。\n2.挖掘潜在客户需求，提供初步技术方案讲解与商务报价。\n3.维护现有客户关系，完成合同签订、回款及售后协调。\n4.收集市场竞品信息与行业动态，为产品改进提供建议。",
                        requirements: "1.大专及以上学历，3年以上软件、硬件或解决方案销售经验。\n2.对汽车电子、无人机或SaaS行业之一有较深理解，有相关客户资源者优先。\n3.具备良好的沟通、谈判与学习能力，能独立完成商务流程。\n4.适应短期出差，目标导向，抗压能力强。\n5.优秀应届生亦可。"
                    }
                ],
                contact: {
                    emailNote: "欢迎将简历发送至招聘邮箱（hr@cn8bit.com），邮件标题请注明“应聘岗位+姓名+期望城市”。",
                    wechatNote: "可添加公司HR微信投递简历（17604269139），添加微信请备注“应聘岗位+姓名+期望城市”。"
                }
            }
        }
    },{
        pageName: "校园招聘",
        dataId: "3-2-1",
        data: {
            routerList: ["关于八比特", "工作机会", "校园招聘"],
            topImg: require("../assets/img/service1/new_bg.webp"),
            topFont: [
                { fontSize: 'normal', value: "校园招聘" },
            ],
            content: {
                pageTitle: "校园招聘",
                jobs: [
                    {
                        id: "job_1",
                        title: "【2026届】C/C++ 嵌入式开发工程师",
                        workplace: "工作地点：大连、深圳、上海、重庆",
                        responsibilities: "1、进行车载嵌入式开发、车载驱动层开发、车载仪表开发。\n2、负责所属模块的代码编写、调试与维护。\n3、在开发中积极提出合理的产品改进意见和解决方案。\n4、优化程序结构，遵守代码流程和规范，保证产品质量。\n5、协助完成各类技术开发任务。",
                        requirements: "1、2026届毕业生，本科学历，计算机/通信/软件/网络/电子/信息/信计/数学等专业。\n2、热爱编程，熟悉C/C++ 编程语言。\n3、具有良好的问题判断和解决能力、口头和书面沟通能力、学习能力。\n4、熟悉操作系统、计算机网络、数据库、数据结构。"
                    },
                    {
                        id: "job_2",
                        title: "【2026届】JAVA开发工程师",
                        workplace: "工作地点：大连、深圳、上海、重庆",
                        responsibilities: "1、参与软件产品的设计、开发。\n2、负责所属模块的代码编写、调试与维护。\n3、协助完成各类技术开发任务。",
                        requirements: "1、2026届毕业生，本科及以上学历，计算机/通信/软件/网络/电子/信息/信计/数学等专业。\n2、热爱编程，熟悉Java编程语言。\n3、具有良好的问题判断和解决能力、口头和书面沟通能力、学习能力。\n4、熟悉数据库相关知识、SQL语言、数据结构。\n5、具有良好的抗压能力、适应能力，部分岗位需要出差。"
                    },
                    {
                        id: "job_3",
                        title: "【2026届】人工智能工程师",
                        workplace: "工作地点：大连、深圳",
                        responsibilities: "1、参与公司人工智能项目的研发工作，运用深度学习、AI技术构建、优化模型并解决实际问题，负责AI基础设施和通用平台的搭建，确保AI模型的高效训练和稳定部署，为各类应用场景提供可靠的技术支持。\n2、根据项目需求进行算法设计、优化与实现，编写高效的代码以确保项目顺利进行，并协作其它团队完成相关交付。\n3、负责AI技术在具体业务场景中的应用设计与开发，推动智能化解决方案落地。",
                        requirements: "1、2026届毕业生，本科及以上学历，计算机软件人工智能相关专业优先。\n2、熟悉深度学习原理，深入了解当前人工智能相关技术。\n3、具备扎实的编程基础，熟练掌握Python、Java、C++等至少一种编程语言，能够熟练运用常见的深度学习框架。\n4、熟悉主流AI技术及应用领域（如自然语言处理、计算机视觉、推荐系统等），熟悉常用机器学习算法，熟悉常用自然语言处理、大模型，知识图谱等算法。\n5、拥有良好的沟通能力和团队合作精神，工作细致、责任心强，有较强的沟通与执行能力。\n6、具备较强的英语阅读能力，能跟踪最新技术发展，对AI有浓厚兴趣、致力于往AI方向发展。"
                    },
                    {
                        id: "job_4",
                        title: "【实习】嵌入式软件开发工程师",
                        workplace: "工作地点：大连、重庆、沈阳",
                        responsibilities: "1、大学C、C++等编程语言课程考试得分优异。\n2、计算机科学与技术专业，本科以上学历。\n3、熟练掌握计算机网络TCP/IP协议者优先。\n4、熟悉操作系统进程管理调度者优先。\n5、熟悉单片机相关总线协议，如spi,can,ic,uart,eth等优先。\n6、熟悉单片机体系架构，掌握主流MCU，如AT,STM等优先。\n7、有C开发经验者优先。\n8、有较强的学习能力，逻辑思维能力及团队合作意识，抗压能力高接受实习期加班者优先。\n9、有ACM等高含金量竞赛经验者优先，得奖者优先。\n10、提供转正机会。",
                        requirements: "1、全日制在读学生，本科及以上学历，计算机相关专业。\n2、熟悉C编程语言。\n3、了解测试理论和测试流程。\n4、具有一定的语言表达能力、逻辑能力。\n5、学习能力强，主动性强，善于沟通。\n6、实习周期3个月以上。\n7、日语、英语优秀者优先。"
                    },
                    {
                        id: "job_5",
                        title: "【实习】测试工程师",
                        workplace: "工作地点：大连、重庆、沈阳",
                        responsibilities: "1、负责核心的业务测试工作，保障产品上线质量与用户体验。具体包括：参与需求分析并设计测试用例、搭建和维护测试环境、执行功能、性能、压力等专项测试。\n2、负责记录、跟踪、定位缺陷，协助开发团队解决问题。独立完成测试结果分析，并输出规范的测试报告。\n3、参与自动化测试的开发与维护。积极参与项目评审，评估质量风险，并与产品、开发团队紧密协作，持续改进产品质量。\n4、提供转正机会。",
                        requirements: "1、全日制本科及以上学历。计算机、软件工程、电子信息、通信工程、自动化等相关专业。\n2、了解软件测试理论、流程和测试用例设计方法。掌握接口测试逻辑，了解Postman、Jmeter、Fiddler、Charles等主流测试工具。\n3、掌握数电、模电、电路分析等基础理论。了解示波器、万用表等基础仪器的使用。\n4、至少熟悉一种编程或脚本语言，如 Python、Java、C/C++ 等，用于编写测试脚本或开发工。\n5、实习周期3个月以上，具备良好的逻辑思维和问题分析能力，做事注重细节有耐心。善于团队合作，有责任心，具备良好的抗压能力和学习能力。"
                    }
                ],
                contact: {
                    emailNote: "欢迎将简历发送至招聘邮箱（hr@cn8bit.com），邮件标题请注明“应聘岗位+姓名+期望城市”。",
                    wechatNote: "可添加公司HR微信投递简历（17604269139），添加微信请备注“应聘岗位+姓名+期望城市”。"
                }
            }
        }
    },{
        pageName: "公司地址",
        dataId: "3-3-1",
        data: {
            routerList: ["关于八比特", "联系我们", "公司地址"],
            topImg: require("../assets/img/service1/new_bg.webp"),
            topFont: [
                { fontSize: 'normal', value: "公司地址" },
            ],
            content: [
                { type: 'title', value: '公司地址' },
                { type: 'text', value: '深圳：南山区南海大道3003号阳光华艺大厦A座4层' },
                { type: 'text', value: '大连：高新园区黄浦路523号海事科技大厦A座21层' },
                { type: 'text', value: '上海：徐汇区虹漕路421号虹漕园62幢301室' },
                { type: 'text', value: '重庆：两江新区星光大道90号土星A2座13层' },
                { type: 'text', value: '沈阳：浑南区国际软件园E01座14层' },
            ]
        }
    },
        {
            pageName: "联系方式",
            dataId: "3-3-2",
            data: {
                routerList: ["关于八比特", "联系我们", "联系方式"],
                topImg: require("../assets/img/service1/new_bg.webp"),
                topFont: [
                    { fontSize: 'normal', value: "联系方式" },
                ],
                content: [
                    { type: 'title', value: '官方邮箱' },
                    { type: 'text', value: 'service@cn8bit.com' },
                    { type: 'title', value: '联系电话', margin: '40px 0 15px 0' },
                    { type: 'text', value: '0411-84573211\n0411-84457557' },
                    { type: 'title', value: '官方微信', margin: '40px 0 15px 0' },
                    { type: 'image', src: require("../assets/img/aboutUs/8bit_code_1.jpg"), width: '130px', name: '八比特科技' },
                    { type: 'title', value: '商务合作', margin: '40px 0 15px 0' },
                    { type: 'image', src: require("../assets/img/aboutUs/code_2.jpg"), width: '130px', name: '备注：商务合作' },
                ]
            }
        },{
            pageName: "工作环境",
            dataId: "d-3-1",
            data: {
                routerList: ["加入我们", "工作环境"],
                topImg: require("../assets/img/service1/new_bg.webp"),
                topFont: [
                    // { fontSize: 'normal', value: "工作环境" },
                    // { fontSize: 'small', value: "工作环境" },

                ],
                content: [
                    { type: 'title', value: '工作环境' },
                    {
                        type: 'threeImage', count: 3,
                        srcList: [
                            { name: null, src: require("../assets/img/aboutUs/workSpace/evn_one.jpg") },
                            { name: null, src: require("../assets/img/aboutUs/workSpace/evn_two.jpg") },
                            { name: null, src: require("../assets/img/aboutUs/workSpace/evn_three.jpg") },]
                    }, {
                        type: 'threeImage', count: 3,
                        srcList: [
                            { name: null, src: require("../assets/img/aboutUs/workSpace/evn_four.jpg") },
                            { name: null, src: require("../assets/img/aboutUs/workSpace/evn_five.jpg") },
                            { name: null, src: require("../assets/img/aboutUs/workSpace/evn_six.jpg") },]

                    }]
            }
        }, {
            pageName: "文化活动",
            dataId: "d-3-2",
            data: {
                routerList: ["加入我们", "文化活动"],
                topImg: require("../assets/img/service1/new_bg.webp"),
                topFont: [
                    // { fontSize: 'normal', value: "文化活动" },
                    // { fontSize: 'small', value: "文化活动" },

                ],
                content: [

                    { type: 'title', value: '文化活动' },
                    {
                        type: 'threeImage', count: 3,
                        srcList: [
                            { name: null, src: require("../assets/img/aboutUs/activity/activity_four.jpg") },
                            { name: null, src: require("../assets/img/aboutUs/activity/activity_one.jpg") },
                            { name: null, src: require("../assets/img/aboutUs/activity/activity_two.jpg") },]
                    },
                    {
                        type: 'threeImage', count: 3,
                        srcList: [
                            { name: null, src: require("../assets/img/aboutUs/activity/activity_five.jpg") },
                            { name: null, src: require("../assets/img/aboutUs/activity/activity_eight.jpg") },
                            { name: null, src: require("../assets/img/aboutUs/activity/activity_seven.jpg") },]
                    },
                    {
                        type: 'threeImage', count: 3,
                        srcList: [
                            { name: null, src: require("../assets/img/aboutUs/activity/activity_nine.jpg") },
                            { name: null, src: require("../assets/img/aboutUs/activity/activity_eleven.jpg") },]
                    }
                ]
            }
        }, {
            pageName: "专属福利",
            dataId: "d-3-3",
            data: {
                routerList: ["加入我们", "专属福利"],
                topImg: require("../assets/img/service1/new_bg.webp"),
                topFont: [
                    // { fontSize: 'normal', value: "专属福利" },
                    // { fontSize: 'small', value: "专属福利" },

                ],
                content: [
                    { type: 'title', value: '专属福利' },
                    {
                        type: 'text_flex',
                        children: [
                            { type: 'bigTitle', value: '衣食住行，无需烦忧' },
                            { type: 'bigTitle', value: '您的风险，由我防护' },
                        ]
                    },
                    {
                        type: 'text_flex',
                        children: [
                            { type: 'text', value: '公司周边、小吃齐全，加班报销车费并有加班费， 吃饱喝足才能干劲十足' },
                            { type: 'text', value: '五险一金，健全制度给你最大保障' },
                        ]
                    },
                    {
                        type: 'text_flex',
                        children: [
                            { type: 'bigTitle', value: '您的健康，由我守护' },
                            { type: 'bigTitle', value: '重要时刻，有我陪伴' },
                        ]
                    },
                    {
                        type: 'text_flex',
                        children: [
                            { type: 'text', value: '免费体检、样样齐全，为你的健康保驾护航' },
                            { type: 'text', value: '生日蛋糕、生日礼物，见证你的更多重要时刻' },
                        ]
                    },
                    {
                        type: 'text_flex',
                        children: [
                            { type: 'bigTitle', value: '游戏活动，丰富多彩' },
                            { type: 'bigTitle', value: '各类假期，应有尽有' },
                        ]
                    },
                    {
                        type: 'text_flex',
                        children: [
                            { type: 'text', value: '生活不只眼前的工作还有精彩的团建，来结识更多有趣的八比特人吧' },
                            { type: 'text', value: '法定假期、福利年假，让你劳逸结合，充分休息' },
                        ]
                    },
                ]
            }
        }, {
            pageName: "诚聘英才",
            dataId: "d-3-4feiqi",
            data: {
                routerList: ["加入我们", "诚聘英才"],
                topImg: require("../assets/img/service1/new_bg.webp"),
                topFont: [
                    // { fontSize: 'normal', value: "诚聘英才" },
                    // { fontSize: 'small', value: "诚聘英才" },

                ],
                content: [
                    { type: 'title', value: '诚聘英才' },
                    {
                        type: 'text_flex',
                        children: [
                            { type: 'bigTitle', value: '初级嵌入式软件开发工程师' },
                            { type: 'bigTitle', value: '嵌入式应届实习生' },
                        ]
                    },
                    {
                        type: 'text_flex',
                        children: [
                            { type: 'text', value: '一 、工作内容\n1、参与嵌入式软件的设计、开发与维护，确保项目按时交付。\n2、参与系统模块的测试，与团队协作确保软件质量。\n\n二、任职要求\n1、熟悉/精通C和C++，具备良好的编程习惯。\n2、不限专业，统招本科及以上学历应届毕业生。\n3、逻辑思维能力强，具有团队合作精神，学习能力强，有责任感，能够有效沟通并攻克技术难题。\n\n三、实习时长\n实习期不可少于两个月，表现优异者，实习结束毕业后可申请转正。\n工作地点：大连高新园区' },
                            { type: 'text', value: '一 、工作内容\n1、参与嵌入式软件的设计、开发与维护，确保项目按时交付。\n2、参与系统模块的测试，与团队协作确保软件质量。\n\n二、任职要求\n1、熟悉/精通C和C++，或其他编程语言，具备良好的编程习惯。\n2、计算机、通信、电气/自动化、机械等专业统招本科或以上学历。\n3、逻辑思维能力强，具有团队合作精神，学习能力强，有责任感，能够有效沟通并攻克技术难题。' },
                        ]
                    },
                ]
            }
        }, {
            pageName: "诚聘英才",
            dataId: "d-3-4",
            data: {
                routerList: ["加入我们", "诚聘英才"],
                topImg: require("../assets/img/service1/new_bg.webp"),
                topFont: [
                    // { fontSize: 'normal', value: "诚聘英才" },
                    // { fontSize: 'small', value: "诚聘英才" },

                ],
                content: [
                    { type: 'title', value: '诚聘英才' },
                    {
                        type: 'spaceBetweenMore', value: '',
                        children1: [
                            { type: 'bigTitle', value: '初级嵌入式软件开发工程师' },
                            {
                                type: 'text',
                                value:
                                    '一 、工作内容\n' +
                                    '1、参与嵌入式软件的设计、开发与维护，确保项目按时交付。\n' +
                                    '2、参与系统模块的测试，与团队协作确保软件质量。\n' +
                                    '3、逻辑思维能力强，具有团队合作精神，学习能力强，有责任感，能够有效沟通并攻克技术难题。\n\n' +
                                    '二、任职要求\n' +
                                    '1、熟悉/精通C和C++，或其他编程语言，具备良好的编程习惯。\n' +
                                    '2、计算机、通信、电气/自动化、机械等专业统招本科或以上学历。\n' +
                                    '3、逻辑思维能力强，具有团队合作精神，学习能力强，有责任感，能够有效沟通并攻克技术难题。\n\n'
                            },
                        ],
                        children2: [
                            { type: 'bigTitle', value: '嵌入式应届实习生 ' },
                            {
                                type: 'text', value:
                                    '一 、工作内容\n' +
                                    '1、参与嵌入式软件的设计、开发与维护，确保项目按时交付。\n' +
                                    '2、参与系统模块的测试，与团队协作确保软件质量。\n' +
                                    '3、逻辑思维能力强，具有团队合作精神，学习能力强，有责任感，能够有效沟通并攻克技术难题。\n\n' +
                                    '二、任职要求\n' +
                                    '1、熟悉/精通C和C++，或其他编程语言，具备良好的编程习惯。\n' +
                                    '2、不限专业，统招本科及以上学历应届毕业生。\n' +
                                    '3、逻辑思维能力强，具有团队合作精神，学习能力强，有责任感，能够有效沟通并攻克技术难题。\n' +
                                    '三、实习时长\n' +
                                    '实习期不可少于两个月，表现优异者，实习结束毕业后可申请转正。\n' +
                                    '工作地点：大连高新园区。\n'
                            },
                        ],
                    },
                ]
            }
        }, {
            pageName: "智慧医疗",
            dataId: "p-1-2",
            data: {
                routerList: ["作业领域", "智慧医疗"],
                topImg: require("../assets/img/home1/banner2-1.jpg"),
                topFont: [
                    { fontSize: 'normal', value: "智慧医疗" },
                    // { fontSize: 'small', value: "诚聘英才" },
                ],
                content: [
                    { type: 'title', value: '智慧医疗' },
                    { type: 'bigTitle', value: '信息管理智能化' },
                    { type: 'textImg_left', src: require("../assets/img/industry/xinxiguanli.jpg"), value: '搭建医院信息管理系统和临床信息管理系统，聚焦医院管理与诊疗环节信息化需求，结合新兴技术共同形成院内信息打通；搭建区域/公共卫生信息系统，聚焦医疗机构间的信息共享与交换，通过连接医疗机构、疾控、医保、药品等信息实现医疗卫生数据打通，形成院外信息交互；搭建医保信息管理系统，从国家级、省级、统筹区级三级进行医保信息管理平台建设，通过医保经办、异地结算、基金运行审计、宏观大数据决策等各类功能模块实现医保基金管理闭环；搭建药品信息管理系统，覆盖药品器械的监管追溯、药品的研发生产流通、药店管理等多个环节，提升药品的管理及生产经营效率。为患者、医务人员、医疗机构编织严密的信息网络，构建创新、协作、互联、可靠的智慧医疗新生态。' },
                    { type: 'bigTitle', value: '医疗器械智能化' },
                    { type: 'textImg_left', src: require("../assets/img/industry/yiliaoqixie.jpg"), value: '覆盖生命信息与支持、体外诊断以及医学影像三大领域，深耕智慧彩超成像机、磁共振成像系统、血液细胞分析仪等设备的智能化改造，将大数据、物联网、人工智能、深度学习等前沿科技融入医疗器械研发与改造，将电子信息技术、云计算与生物技术相结合，全力推动国产高端医疗装备的快速产业化，为医生的诊断铸造科技利器，打造更精密、更速度的诊疗闭环。' },
                ]
            }
        }, {
            pageName: "智慧金融",
            dataId: "p-1-3",
            data: {
                routerList: ["作业领域", "智慧金融"],
                topImg: require("../assets/img/home1/banner3-1.jpg"),
                topFont: [
                    { fontSize: 'normal', value: "智慧金融" },
                    // { fontSize: 'small', value: "诚聘英才" },
                ],
                content: [
                    { type: 'title', value: '智慧金融' },
                    { type: "text", value: "凭借多年技术沉淀，根据金融行业特点推出的智能运维解决方案，采用开放式平台架构和松耦合的模块化产品，实现覆盖全渠道的端到端立体化监控网络和基于业务指标的实时可视化管控。依托大数据、智能算法、云计算等科技手段，推出高效的解决方案，帮助券商完成业务智能化革新。覆盖领域从营销、投顾到投研量化和风控各环节，根据客户需求一事一例针对性设计业务场景，全方位赋能券商，帮助其实现业务增长并降低风险。​" },
                    { type: "image", src: require("../assets/img/industry/zhihuicelue.jpg") },
                    { type: 'bigTitle', value: '智慧策略' },
                    { type: 'textImg_left', src: require("../assets/img/industry/zhengquanone.jpg"), value: '基于C++底层架构优势，支持VBA和Python双语言编写策略进行选股和择时以及创建投资组合，提供安全的回测环境和可视化回测模型，让投研更高效。建设统一的数据平台，实现数据的系统化采集与处理，积累更全面的实时信息，满足金融公司对不同类型、不同业务管理方面的分析、预警、展示等个性化需求，提升决策高效性。' },
                    { type: 'bigTitle', value: '行情系统' },
                    { type: 'textImg_left', src: require("../assets/img/industry/zhengquantwo.jpg"), value: '灵活展示多市场、多品种、多周期行情，通过系统录入同期企业level-1行情快照为企业提供当日累计成交量、当日累计成交额、当日成交最高价、当日成交最低价等数据进行比对；同时针对客户推出的level-2的实时行情收费服务进行数据推演。为客户提高行情透明度，增强行情信息，提升竞争力。' },
                    { type: 'bigTitle', value: '量化交易' },
                    { type: 'textImg_left', src: require("../assets/img/industry/lianghuajiaoyi.jpg"), value: '利于智能算法和数学模型，自动分析历史数据、实时行情等信息，根据用户指定的策略场景来决定交易下单的时机。通过强化主动型交易策略，获得超过市场平均水平的收益，通过基本面和技术面的挖掘，提取有效指标进行投资，进而获得超额收益。帮助投资者在交易过程中避免收受到情绪波动的影响，实现最优投资。' },
                    { type: 'bigTitle', value: '智慧风控' },
                    { type: 'textImg_left', src: require("../assets/img/industry/zhengquan04.png"), value: '借助统一大数据分析平台，结合金融公司的业务场景，以风险数据平台+智慧风控为驱动，实现风险分析、风险预警、风险评级等各个方面的有效监控与管理。采用定性和定量相结合的方法，累计数据进行分析；深入各项业务，结合多维筛选方式迅速查看当日开户情况、额度使用情况、融券规模组成结构等关联信息；最后通过实时监控低风险、较低风险、中等风险、较高风险、高风险来源并给出科学性风险建议方案，从而最大程度降低非系统性风险。' },
                ]
            }
        }, {
            pageName: "智慧教育",
            dataId: "p-1-4",
            data: {
                routerList: ["作业领域", "智慧教育"],
                topImg: require("../assets/img/home1/banner4-1.jpg"),
                topFont: [
                    { fontSize: 'normal', value: "智慧教育" },
                    // { fontSize: 'small', value: "诚聘英才" },
                ],
                content: [
                    { type: 'title', value: '智慧教育' },
                    { type: "text", value: "在 5G 与 AI 技术交融的时代，智慧教育打破传统教室边界。课堂中，智能平板替代课本，学生轻点屏幕即可查阅 3D 动态知识图谱；教师借助 AI 学情分析系统，实时捕捉每位学生的专注度曲线，精准推送分层习题。校园走廊的智慧屏化身 “知识驿站”，通过人脸识别推送个性化学习资源，午休时的碎片时间也能沉浸于 AR 历史场景漫游。" },
                    { type: "text", value: "家校共育环节，智能手环同步学生运动心率与课堂表现，家长手机端可直观查看成长轨迹；云端作业系统自动批改主观题，红笔批注附上微课解析，错题本实现跨学期智能归档。更深远的是，偏远山区的孩子能通过全息投影与一线城市名师 “同框” 上课，教育公平在数据流动中悄然生长。" },
                    { type: "text", value: "智慧教育不仅是技术赋能，更是一场思维革命 —— 从 “千人一面” 的填鸭式教学，转向以学习者为中心的个性化成长生态，让每个求知的灵魂都能在数字沃土中找到绽放的路径。" },
                ]
            }
        }, {
            pageName: "内容管理平台",
            dataId: "p-1-5",
            data: {
                routerList: ["作业领域", "内容管理平台"],
                topImg: require("../assets/img/home1/banner5-1.jpg"),
                topFont: [
                    { fontSize: 'normal', value: "内容管理平台" },
                    // { fontSize: 'small', value: "诚聘英才" },
                ],
                content: [
                    { type: 'title', value: '高效管理，智创未来——XX内容管理平台，让内容创造无限可能！' },
                    { type: "bigTitle", value: "一站式内容管理解决方案，助力企业高效运营与增长" },
                    { type: "text", value: "在数字化时代，内容是企业增长的核心动力。无论您是品牌营销、新闻媒体、电子商务还是教育培训，XX内容管理平台都能为您提供强大、灵活且安全的内容管理体验，助您轻松驾驭海量内容，释放团队创造力！" },
                    { type: "bigTitle", value: "为什么选择XX内容管理平台？" },
                    { type: "text", value: "✅ 智能高效：直观的操作界面与强大的编辑工具，让内容创作、编辑、发布一气呵成，效率提升50%以上。\n✅ 多端协同：支持PC、移动端及第三方平台无缝对接，团队协作更流畅，随时随地管理内容。\n✅ 安全可靠：多层加密与权限管理，保障数据安全，审计追踪让每一步操作都有迹可循。\n✅ 灵活扩展：模块化设计，可根据业务需求自由定制功能，轻松应对未来挑战。\n✅ 数据分析：内置智能分析工具，实时追踪内容表现，优化策略，驱动业务增长。" },
                    { type: "bigTitle", value: "适用场景：" },
                    { type: "text", value: "1.企业官网与品牌内容管理\n2.电商产品与营销活动更新\n3.媒体机构多平台内容分发\n4.教育机构课程与资源管理\n" },
                ]
            }
        }, {
            pageName: "Saas平台",
            dataId: "p-1-6",
            data: {
                routerList: ["作业领域", "Saas平台"],
                topImg: require("../assets/img/home1/banner6-1.jpg"),
                topFont: [
                    // { fontSize: 'normal', value: "Saas平台" },
                    // { fontSize: 'small', value: "诚聘英才" },
                ],
                content: [
                    { type: 'title', value: 'Saas平台' },
                    { type: "text", value: "SaaS 即软件即服务，是一种基于云的软件交付模式。在这种模式下，软件托管在远程服务器上，由服务提供商维护和更新，并通过 Web 浏览器、移动应用程序和 API 提供给客户。用户无需在本地安装软件，只需通过互联网即可便捷使用。" },
                    { type: "text", value: "SaaS 平台的工作模式颇具特色。供应商在自家或第三方服务器和数据库托管应用程序与数据，并管理平台、操作系统和中间件。用户订阅后，凭借注册登录信息经 Web 浏览器获得应用程序访问权限。通常采用多租户模型，即单一版本软件供众多订阅用户使用，同时保障各用户数据相互隔离。" },
                    { type: "text", value: "其类型丰富多样，常见的涵盖会计 SaaS，像 Xero、QuickBooks 可自动化简化财务运营；内容管理系统（CMS），助力管理数字内容创建修改；客户关系管理（CRM），用于存储管理客户数据，如 Salesforce；企业资源规划（ERP），管理包括会计、风险管理等广泛业务流程；项目管理 SaaS，帮助组织计划、执行和监控项目；通信 SaaS，实现成员即时消息传递和文件共享；人力资源 SaaS（HR/HRM），具备招聘、绩效跟踪等人力资源管理功能；支付网关 SaaS，让企业能便捷接受付款 。" },
                    { type: 'text', value: 'SaaS 平台为企业带来了显著优势，成本可预测且开销降低，无需投入大量资金在基础架构与软件升级；能实现无摩擦升级与更新，供应商可实时更新软件；支持随时随地访问应用数据，数据存储在云端，设备故障也不担心数据丢失；具备快速可扩展性，用户可按需灵活调整使用层级 。' },
                ]
            }
        }, {
            pageName: "news1",
            dataId: "n-1-1",
            data: {
                routerList: ["新闻"],
                topImg: require("../assets/img/aboutUs/company1.png"),
                topFont: [
                    // { fontSize: 'normal', value: "Saas平台" },
                    // { fontSize: 'small', value: "诚聘英才" },
                ],
                content: [
                    { type: 'firstTitle', value: '资质|八比特科技顺利通过CMMl3级认证', layout: 'center', margin: '0 0 60px 0' },
                    // { type: 'image', src: require("../assets/img/news/news_1_1.png") },
                    {
                        type: 'spaceBetweenMore', value: '',
                        children1: [
                            { type: "text", textIndent: '2em', value: "2025年01月20日，大连八比特科技有限公司成功获取CMMI 3级认证，此资质彰显了八比特科技在软件研发实力、流程组织能力、服务实施交付效率及项目管理水平等方面均已达到业界前沿，再次印证了公司秉持匠心精神推动科技进步的坚定步伐。这一认证不仅为八比特科技进军国际市场奠定了坚实基础，更显著增强了公司的竞争优势，进一步稳固了其在行业中的领先地位。" },
                        ],
                        children2: [
                            { type: 'image', src: require("../assets/img/news/news_1_1.png"), name: "图|大连八比特科技通过 CMMI 3 级认证" },
                        ],
                    },
                    {
                        type: 'spaceBetweenMore', value: '',
                        children1: [
                            { type: "text", textIndent: '2em', value: "CMMI，全称为Capability Maturity Model Integration（能力成熟度模型集成），是一项在全球范围内推广应用的软件能力成熟度评估体系，旨在引导软件开发过程的持续优化，并对软件开发能力进行科学评估。其中，CMMI 3级认证标志着企业已构建起一套成熟完善的软件过程管理体系，展现出高度的规范性、稳定性和可重复性，能够稳定且持续地提供高质量的软件产品及服务。" },
                        ],
                        children2: [
                            { type: 'image', src: require("../assets/img/news/news_1_2.png") },
                        ],
                    },
                    {
                        type: 'spaceBetweenMore', value: '',
                        children1: [
                            { type: "text", textIndent: '2em', value: "近年来，八比特科技有限公司秉持“探索未来科技，创新智慧生活”的企业愿景，矢志成为“卓越的智能技术方案提供商”。公司深入聚焦软件开发的关键领域，精心打造量身定制的解决方案，并严格参照CMMI 3.0模型，主动开展现状评估与全面分析。" },
                        ],
                        children2: [
                            { type: 'image', src: require("../assets/img/news/news_1_3.png"), name: "图|大连八比特科技通过 CMMI 3 级认证" },
                        ],
                    },
                    {
                        type: 'spaceBetweenMore', value: '',
                        children1: [
                            { type: "text", textIndent: '2em', value: "在此基础上，公司依托数据驱动对软件开发流程进行优化改进，并量化评估改进成效，从而显著提升了软件研发的效率与质量。最终在各实践域达到并通过 CMMI 3级评估要求。" },
                        ],
                        children2: [
                            { type: 'image', src: require("../assets/img/news/news_1_4.png"), name: "图|大连八比特科技通过 CMMI 3 级认证" },
                        ],
                    },
                    // { type: 'image', src: require("../assets/img/news/news_1_4.png"), name: "图|大连八比特科技通过 CMMI 3 级认证" },

                    // { type: 'bigTitle', value: '关于八比特科技' },
                    // { type: "text", value: "八比特科技有限公司作为一家专注于智能技术研发的创新型科技企业、国家高新技术企业、专精特新企业、车联网企业、大连市车联网产业创新联盟成员，基于积累多年的嵌入式操作系统优化技术、人机交互、机器视觉、以及语音和音频技术，为汽车提供从操作系统开发到应用定制，包括汽车信息娱乐系统、智能仪表盘、集成驾驶舱和音频产品在内的整体智能座舱系统解决方案和技术服务，为驾乘者提供丰富、先进的智能驾驶体验。" },
                    // { type: "text", value: "展望未来，八比特科技有限公司将顺应企业成长趋势，由“成为卓越的智能技术方案提供商”这一愿景向深化自主产品研发领域聚焦，以汇聚力量、激发潜能。此番顺利荣获CMMI 3级认证，不仅是八比特科技长期坚持技术创新、高度重视研发管理体系建设的结晶，也是对公司实力与努力的权威认可。以此为契机，八比特科技将矢志不渝地优化研发流程，精进项目管理效能，致力于为客户提供更加卓越的产品与服务，从而在激烈的市场竞争中不断锤炼并提升自身的核心竞争力。" },
                ]
            }
        }, {
            pageName: "news2",
            dataId: "n-1-2",
            data: {
                routerList: ["新闻"],
                topImg: require("../assets/img/aboutUs/company1.png"),
                topFont: [
                    // { fontSize: 'normal', value: "Saas平台" },
                    // { fontSize: 'small', value: "诚聘英才" },
                ],
                content: [
                    { type: 'title', value: '秉初心 再奋进 励新程|八比特科技参加2025大连软件产业发展大会并荣获双奖', margin: '0 0 60px 0' },
                    {
                        type: 'spaceBetweenMore', value: '',
                        children1: [
                            { type: "text", textIndent: '2em', value: "2025年1月15日，2025大连软件产业发展大会于星海世博广场成功举办，大连八比特科技有限公司应邀参会，并获得“车联网创新企业”“优秀软件产品”两项荣誉。" },
                            { type: "text", textIndent: '2em', value: "大会遵循政府的指导方针，同时邀请了大连软件行业协会的各位领导及行业同仁进行主题演讲，共同探索产业发展的最新趋势，深切体会企业家们的奋斗与进取精神。会上共同探讨2024大连软件产业发展现状和机遇、大连车联网产业发展现状和机遇、中小企业数字化转型实施实践与体会的课题；同时宣布大连软件行业可信IT圈平台的发布，倡导业内同仁携手合作、团结互助，共同发掘产业的新机遇，探索互利共赢的合作可能。" },
                        ],
                        children2: [
                            { type: 'image', src: require("../assets/img/news/news_2_1.png") },
                        ],
                    },
                    {
                        type: 'spaceBetweenMore', value: '',
                        children1: [
                            { type: "text", textIndent: '2em', value: "大会同时对各企业表彰颁奖，大连八比特科技有限公司被评为2024年大连软件和信息技术服务业“车联网创新企业”，其开发的“ReallnsightV4.0车载开发框架”荣获2024年大连软件和信息技术服务优秀软件产品奖项。" },
                            { type: 'text', textIndent: '2em', value: '本次会议的圆满举行，极大地提振了大连软件企业团队的士气，并激发了大连软件产业创新活力的源泉。会上，八比特科技携手众多软件企业，深入探讨了大连软件产业的未来走向。展望未来，各方将携手并进，为产业的蓬勃发展和繁荣壮大贡献各自的力量。' },
                        ],
                        children2: [
                            { type: 'image', src: require("../assets/img/news/news_2_2.jpg"), name: "图|2025大连软件产业发展大会" },

                        ],
                    },

                    { type: 'firstTitle', value: '表彰颁奖', layout: "center" },
                    {
                        type: 'spaceBetweenMore', value: '',
                        children1: [
                            { type: 'allImage', src: require("../assets/img/news/news_2_3.jpg"), name: "图|大连八比特被评为2024年车联网创新企业" },
                        ],
                        children2: [
                            { type: 'allImage', src: require("../assets/img/news/news_2_4.jpg"), name: "图|“ReallnsightV4.0车载开发框架”荣获优秀软件产品奖项" },
                        ],
                    },
                    {
                        type: 'spaceBetweenMore', value: '',
                        children1: [
                            { type: 'allImage', src: require("../assets/img/news/news_2_5.jpg"), },
                        ],
                        children2: [
                            { type: 'allImage', src: require("../assets/img/news/news_2_6.jpg"), },
                        ],
                    },

                ]
            }
        }, {
            pageName: "news3",
            dataId: "n-1-3",
            data: {
                routerList: ["新闻"],
                topImg: require("../assets/img/aboutUs/company1.png"),
                topFont: [
                    // { fontSize: 'normal', value: "Saas平台" },
                    // { fontSize: 'small', value: "诚聘英才" },
                ],
                content: [
                    { type: 'title', value: '喜报|八比特旗下两家企业再获国家高新技术企业认定' },
                    {
                        type: 'spaceBetweenMore', value: '',
                        children1: [
                            { type: "text", textIndent: '2em', value: "2024年12月24日，全国高新技术企业认定管理工作领导小组办公室对大连市认定机构2024年认定报备的第一批高新技术企业进行备案公示。" },
                            { type: "text", textIndent: '2em', value: "其中，八比特科技旗下两家企业：大连八比特科技有限公司、八比智行（大连）科技有限公司荣获本次国家高新技术企业认定。大连八比特科技有限公司已经连续三次评定为国家高新技术企业，而八比智行（大连）科技有限公司是八比特旗下第四家高新技术企业。" },
                        ],
                        children2: [
                            { type: 'allImage', src: require("../assets/img/news/news_3_1.png"), name: "图|对大连市认定机构2024年认定报备的\n第一批高新技术企业进行备案的公示" },
                        ],
                    },
                    {
                        type: 'spaceBetweenMore', value: '',
                        children1: [
                            { type: "text", value: "高新技术企业是指在《国家重点扶持的高新技术领域》中，不断致力于研究开发活动与技术成果的有效转化，从而构建起企业自身的核心自主知识产权体系，并以此作为业务发展的基石。这类企业往往表现为知识与技术高度集中的经济实体，拥有出色的研发实力和技术先进性，其提供的产品、采用的技术或提供的服务均隶属于高新技术领域。" },

                        ],
                        children2: [
                            { type: 'allImage', src: require("../assets/img/news/news_3_2.png"), },
                            { type: 'allImage', src: require("../assets/img/news/news_3_3.png"), name: "图|八比特旗下两家企业认定公示" },
                        ],
                    },
                ]
            }
        }, {
            pageName: "news4",
            dataId: "n-1-4",
            data: {
                routerList: ["新闻"],
                topImg: require("../assets/img/aboutUs/company1.png"),
                topFont: [
                    // { fontSize: 'normal', value: "Saas平台" },
                    // { fontSize: 'small', value: "诚聘英才" },
                ],
                content: [
                    { type: 'title', value: '车联网协会|大连八比特任第三届副理事长单位' },
                    {
                        type: 'spaceBetweenMore', value: '',
                        children1: [
                            {
                                type: 'bigTitle', value: '大连软件行业协会车联网分会', margin: '0 0 20px 0'
                                // layout: 'center'
                            },
                            { type: 'smallTitle', value: '2024会员大会', margin: '0 0 10px 0', },
                            { type: 'smallTitle', value: '大连市车联网产业创新联盟', margin: '0 0 40px 0', },
                            { type: "text", margin: '0 0 0px 0', value: "2024年12月26日，大连软件行业协会车联网分会于高新区成功举办了2024会员大会，大连八比特科技有限公司受邀出席大会。" },
                            { type: "text", value: "会上，分会就项目对接、人才培养、合作交流、产业发展调研等核心工作进行了成果汇报，并发布了新一年的工作计划，同时进行了第三届理事会的选举工作。" },

                        ],
                        children2: [
                            { type: 'image80', src: require("../assets/img/news/news_4_1.png"), name: "图|大连软件行业协会车联网分会2024会员大会" },
                        ],
                    },

                    { type: "firstTitle", value: "大连八比特出任理事会副理事长单位" ,layout:'center'},
                    { type: 'smallTitle' ,layout:'center', value: "根据《大连软件行业协会车联网分会章程》，经选举投票，大连八比特科技有限公司成功当选为第三届理事会的副理事长单位。"},
                    // { type: 'image80', src: require("../assets/img/news/news_4_2.png") },
                    {
                        type: 'twoImage', count: 2,
                        srcList: [
                            { name: null, src: require("../assets/img/news/news_4_2.png") },
                            { name: null, src: require("../assets/img/news/news_4_4.png") },]
                    },
                    // {
                    //     type: 'spaceBetweenMore', value: '',
                    //     children1: [
                    //         { type: 'image', src: require("../assets/img/news/news_4_2.png") },
                    //     ],
                    //     children2: [
                    //         { type: 'image', src: require("../assets/img/news/news_4_4.png") },
                    //     ],
                    // },
                ]
            }
        }, {
            pageName: "企业数字化转型",
            dataId: "solution-1",
            data: {
                routerList: ["解决方案", "企业数字化转型"],
                topImg: require("../assets/img/banner2.jpg"),
                topFont: [
                    { fontSize: 'normal', value: "企业数字化转型" },
                ],
                content: [
                    { type: 'title', value: '企业数字化转型解决方案' },
                    { type: 'text', value: '企业数字化转型是指利用数字技术彻底改变企业的业务流程、组织结构、产品服务和商业模式，以提升企业的运营效率、创新能力和市场竞争力。我们的数字化转型解决方案帮助企业实现从传统运营模式向数字化、智能化运营模式的转变。' },
                    { type: 'bigTitle', value: '核心服务' },
                    { type: 'text', value: '(1)数字化战略规划：根据企业现状和目标，制定符合企业发展的数字化转型战略和实施路径。' },
                    { type: 'text', value: '(2)业务流程优化：梳理和优化现有业务流程，消除冗余环节，提升流程效率和质量。' },
                    { type: 'text', value: '(3)技术平台建设：搭建企业级数字化平台，包括云平台、数据平台、应用平台等基础设施。' },
                    { type: 'text', value: '(4)数据治理与分析：建立完善的数据治理体系，实现数据的采集、存储、分析和应用。' },
                    { type: 'text', value: '(5)组织能力提升：培养数字化人才，建立数字化组织文化和协作机制。' },
                    { type: 'text', value: '(6)安全保障体系：构建全方位的网络安全和数据安全防护体系。' },
                    { type: 'bigTitle', value: '应用场景' },
                    { type: 'text', value: '制造业、零售业、金融业、物流业、医疗健康、教育培训、政府机构' },
                ]
            }
        }, {
            pageName: "智慧园区解决方案",
            dataId: "cloud-2",
            data: {
                routerList: ["解决方案", "智慧园区解决方案"],
                topImg: require("../assets/img/banner3.webp"),
                topFont: [
                    { fontSize: 'normal', value: "智慧园区解决方案" },
                ],
                content: [
                    { type: 'title', value: '智慧园区解决方案' },
                    { type: 'text', value: '智慧园区解决方案利用物联网、大数据、人工智能等先进技术，将园区内的基础设施、公共服务、安全管理、能源管理等各个方面进行智能化升级，打造安全、高效、便捷、绿色的现代化园区。' },
                    { type: 'bigTitle', value: '核心功能' },
                    { type: 'text', value: '(1)智能安防：视频监控、人脸识别、入侵检测、智能巡检，全方位保障园区安全。' },
                    { type: 'text', value: '(2)智慧停车：智能车位引导、车牌识别、无感支付，提升停车体验和效率。' },
                    { type: 'text', value: '(3)能源管理：实时监测能耗，智能调节空调、照明等设备，实现节能减排。' },
                    { type: 'text', value: '(4)环境监测：监测空气质量、温湿度、噪音等环境指标，营造舒适环境。' },
                    { type: 'text', value: '(5)智能办公：会议室预订、访客管理、智能门禁，提升办公效率。' },
                    { type: 'text', value: '(6)应急指挥：统一调度、快速响应，提升突发事件处理能力。' },
                    { type: 'bigTitle', value: '应用场景' },
                    { type: 'text', value: '科技园区、产业园区、工业园区、商业园区、物流园区、校园园区' },
                ]
            }
        }, {
            pageName: "智慧校园解决方案",
            dataId: "solution-3",
            data: {
                routerList: ["解决方案", "智慧校园解决方案"],
                topImg: require("../assets/img/banner2.jpg"),
                topFont: [
                    { fontSize: 'normal', value: "智慧校园解决方案" },
                ],
                content: [
                    { type: 'title', value: '智慧校园解决方案' },
                    { type: 'text', value: '智慧校园解决方案通过信息技术与教育教学的深度融合，构建数字化、网络化、智能化的校园环境，提升教学质量和学习效率，优化校园管理和服务，为师生创造更加便捷、安全、舒适的学习生活环境。' },
                    { type: 'bigTitle', value: '核心功能' },
                    { type: 'text', value: '(1)智慧教学：多媒体教室、在线教学平台、互动教学工具，丰富教学手段。' },
                    { type: 'text', value: '(2)智慧管理：学生管理、教师管理、教务管理、资产管理，提升管理效率。' },
                    { type: 'text', value: '(3)智慧服务：一卡通、智能图书馆、智能食堂、智能快递，便捷校园生活。' },
                    { type: 'text', value: '(4)智慧安防：校园监控、门禁管理、访客管理、应急报警，保障校园安全。' },
                    { type: 'text', value: '(5)智慧环境：智能照明、智能空调、环境监测，营造舒适学习环境。' },
                    { type: 'text', value: '(6)家校互通：家校沟通平台、学生成长档案，促进家校协同育人。' },
                    { type: 'bigTitle', value: '应用场景' },
                    { type: 'text', value: '高等院校、中小学、职业院校、培训机构、幼儿园' },
                ]
            }
        }, {
            pageName: "汽车安全解决方案",
            dataId: "solution-4",
            data: {
                routerList: ["解决方案", "汽车安全解决方案"],
                topImg: require("../assets/img/banner3.webp"),
                topFont: [
                    { fontSize: 'normal', value: "汽车安全解决方案" },
                ],
                content: [
                    { type: 'title', value: '汽车安全解决方案' },
                    { type: 'text', value: '汽车安全解决方案涵盖主动安全、被动安全、信息安全等多个维度，通过先进的传感器技术、人工智能算法和网络安全防护，为驾乘人员提供全方位的安全保障，降低交通事故风险，提升行车安全水平。' },
                    { type: 'bigTitle', value: '核心功能' },
                    { type: 'text', value: '(1)主动安全：自适应巡航、自动紧急制动、车道保持、盲区监测，预防事故发生。' },
                    { type: 'text', value: '(2)被动安全：高强度车身结构、多安全气囊、预紧式安全带，减轻事故伤害。' },
                    { type: 'text', value: '(3)驾驶员监测：疲劳监测、分心监测、情绪识别，提醒驾驶员保持专注。' },
                    { type: 'text', value: '(4)环境感知：毫米波雷达、激光雷达、摄像头，实时感知周围环境。' },
                    { type: 'text', value: '(5)网络安全：入侵检测、数据加密、安全通信，防止网络攻击。' },
                    { type: 'text', value: '(6)应急救援：自动报警、事故记录、紧急呼叫，快速响应事故。' },
                    { type: 'bigTitle', value: '应用场景' },
                    { type: 'text', value: '乘用车、商用车、新能源汽车、自动驾驶车辆、特种车辆' },
                ]
            }
        }, {
            pageName: "智慧俱乐部",
            dataId: "enterprise-1",
            data: {
                routerList: ["企业应用", "智慧俱乐部"],
                topImg: require("../assets/img/banner2.jpg"),
                topFont: [
                    { fontSize: 'normal', value: "智慧俱乐部" },
                ],
                content: [
                    { type: 'title', value: '智慧俱乐部解决方案' },
                    { type: 'text', value: '智慧俱乐部解决方案利用物联网、大数据、人工智能等先进技术，将俱乐部的会员管理、场地预订、设备管理、活动组织等各个方面进行智能化升级，打造便捷、高效、智能的现代化俱乐部管理平台。' },
                    { type: 'bigTitle', value: '核心功能' },
                    { type: 'text', value: '(1)会员管理：会员注册、会员等级、积分管理、会员权益，提升会员粘性。' },
                    { type: 'text', value: '(2)场地预订：在线预订、实时查看、智能排期、自动结算，提升场地利用率。' },
                    { type: 'text', value: '(3)设备管理：设备预约、设备维护、设备监控、设备统计，延长设备寿命。' },
                    { type: 'text', value: '(4)活动组织：活动发布、活动报名、活动签到、活动评价，提升活动效果。' },
                    { type: 'text', value: '(5)数据分析：会员分析、场地分析、活动分析、收入分析，辅助决策。' },
                    { type: 'text', value: '(6)智能支付：在线支付、会员卡支付、二维码支付，便捷支付体验。' },
                    { type: 'bigTitle', value: '应用场景' },
                    { type: 'text', value: '健身俱乐部、羽毛球俱乐部、网球俱乐部、游泳俱乐部、高尔夫俱乐部、乒乓球俱乐部' },
                ]
            }
        }, {
            pageName: "智慧场馆",
            dataId: "enterprise-2",
            data: {
                routerList: ["企业应用", "智慧场馆"],
                topImg: require("../assets/img/banner3.webp"),
                topFont: [
                    { fontSize: 'normal', value: "智慧场馆" },
                ],
                content: [
                    { type: 'title', value: '智慧场馆解决方案' },
                    { type: 'text', value: '智慧场馆解决方案利用物联网、大数据、人工智能等先进技术，将场馆的票务管理、入场管理、场地管理、设备管理、安全管理等各个方面进行智能化升级，打造安全、高效、便捷、绿色的现代化场馆。' },
                    { type: 'bigTitle', value: '核心功能' },
                    { type: 'text', value: '(1)票务管理：在线购票、电子票、二维码验票、退改签，提升购票体验。' },
                    { type: 'text', value: '(2)入场管理：人脸识别、身份证验证、二维码扫描、智能闸机，快速入场。' },
                    { type: 'text', value: '(3)场地管理：场地预订、场地排期、场地监控、场地维护，提升场地利用率。' },
                    { type: 'text', value: '(4)设备管理：设备监控、设备维护、设备预警、设备统计，延长设备寿命。' },
                    { type: 'text', value: '(5)安全管理：视频监控、入侵检测、消防监测、应急指挥，保障场馆安全。' },
                    { type: 'text', value: '(6)数据分析：客流分析、收入分析、活动分析、设备分析，辅助决策。' },
                    { type: 'bigTitle', value: '应用场景' },
                    { type: 'text', value: '体育场馆、会展中心、剧院、音乐厅、展览馆、博物馆' },
                ]
            }
        },
        {
            pageName: "Autosar技术服务",
            dataId: "service-1-1",
            data: {
                routerList: ["服务", "软件技术服务", "Autosar技术服务"],
                topImg: require("../assets/img/banner3.webp"),
                topFont: [
                    { fontSize: 'normal', value: "Autosar技术服务" },
                ],
                content: [
                    { type: 'title', value: 'Autosar技术服务' },
                    { type: 'text', value: 'AUTOSAR（AUTomotive Open System ARchitecture）是全球汽车行业广泛采用的开放式标准化软件架构。我们提供完整的AUTOSAR开发服务，帮助客户构建符合国际标准的汽车电子软件系统，提升开发效率、降低开发成本、增强系统可靠性。' },
                    { type: 'bigTitle', value: '服务内容' },
                    { type: 'text', value: '(1)AUTOSAR CP（Classic Platform）开发：提供基于AUTOSAR CP架构的ECU软件开发服务，包括BSW（基础软件）、RTE（运行时环境）和应用层软件开发。' },
                    { type: 'text', value: '(2)AUTOSAR AP（Adaptive Platform）开发：提供基于AUTOSAR AP架构的高性能计算平台开发服务，支持面向服务的架构设计。' },
                    { type: 'text', value: '(3)工具链支持：支持Davinci、Vector、ETAS等主流AUTOSAR工具链，提供工具选型、配置和集成服务。' },
                    { type: 'text', value: '(4)国产化方案：适配普华ORIENTAIS AUTOSAR工具链，联合紫光国微、智芯科技打造RISC-V架构MCU解决方案，关键模块自主可控率100%。' },
                    { type: 'bigTitle', value: '核心优势' },
                    { type: 'text', value: '(1)全栈开发能力：从需求分析、架构设计到代码实现、测试验证，提供端到端开发服务。' },
                    { type: 'text', value: '(2)丰富项目经验：累计完成100+个AUTOSAR项目，涵盖车身控制、底盘控制、动力总成等多个领域。' },
                    { type: 'text', value: '(3)专业团队：拥有50+名AUTOSAR认证工程师，平均从业经验8年以上。' },
                    { type: 'text', value: '(4)快速交付：采用模块化开发模式，开发周期缩短30%以上。' },
                    { type: 'bigTitle', value: '应用场景' },
                    { type: 'text', value: '车身控制器、网关、动力总成、底盘控制、新能源管理、智能驾驶域控制器' },
                ]
            }
        },
        {
            pageName: "视觉识别技术服务",
            dataId: "service-1-2",
            data: {
                routerList: ["服务", "软件技术服务", "视觉识别技术服务"],
                topImg: require("../assets/img/banner3.webp"),
                topFont: [
                    { fontSize: 'normal', value: "视觉识别技术服务" },
                ],
                content: [
                    { type: 'title', value: '视觉识别技术服务' },
                    { type: 'text', value: '视觉识别技术是人工智能的重要分支，通过计算机视觉算法实现对图像和视频的智能分析。我们提供从算法设计、模型训练到工程落地的全流程视觉识别服务，帮助客户构建智能视觉系统。' },
                    { type: 'bigTitle', value: '服务内容' },
                    { type: 'text', value: '(1)目标检测：提供人脸检测、车辆检测、行人检测、物体检测等多种目标检测算法，支持实时检测和多目标追踪。' },
                    { type: 'text', value: '(2)图像分割：提供语义分割、实例分割、全景分割等服务，实现对图像像素级别的精细分类。' },
                    { type: 'text', value: '(3)行为识别：提供人体姿态估计、行为分析、异常行为检测等服务，适用于安防监控、智能驾驶等场景。' },
                    { type: 'text', value: '(4)OCR识别：提供文字检测、文字识别、票据识别等服务，支持中英文及多语言识别。' },
                    { type: 'bigTitle', value: '核心优势' },
                    { type: 'text', value: '(1)高精度算法：采用深度学习技术，识别准确率达到99%以上。' },
                    { type: 'text', value: '(2)实时性能：优化算法架构，支持1080P视频实时处理，延迟低于50ms。' },
                    { type: 'text', value: '(3)轻量化部署：提供模型压缩和量化服务，支持在嵌入式设备上高效运行。' },
                    { type: 'text', value: '(4)场景适配：针对不同应用场景进行算法优化，提升实际效果。' },
                    { type: 'bigTitle', value: '应用场景' },
                    { type: 'text', value: '智能安防、自动驾驶、工业质检、医疗影像、智能零售、智慧交通' },
                ]
            }
        },
        {
            pageName: "OTA技术服务",
            dataId: "service-1-3",
            data: {
                routerList: ["服务", "软件技术服务", "OTA技术服务"],
                topImg: require("../assets/img/banner3.webp"),
                topFont: [
                    { fontSize: 'normal', value: "OTA技术服务" },
                ],
                content: [
                    { type: 'title', value: 'OTA技术服务' },
                    { type: 'text', value: 'OTA（Over-The-Air）技术是智能终端远程升级的核心技术，通过无线网络实现固件和软件的远程更新。我们提供完整的OTA解决方案，帮助客户构建安全、高效、可靠的远程升级体系。' },
                    { type: 'bigTitle', value: '服务内容' },
                    { type: 'text', value: '(1)OTA平台搭建：提供基于云计算的OTA管理平台，支持设备管理、版本管理、升级策略配置等功能。' },
                    { type: 'text', value: '(2)差分升级技术：采用自研差分算法，升级包体积减少80%以上，大幅降低流量消耗和升级时间。' },
                    { type: 'text', value: '(3)安全防护体系：基于PKI/CA体系实现双向身份认证，支持国密算法（SM2/SM3/SM4），确保升级过程安全可靠。' },
                    { type: 'text', value: '(4)多平台支持：支持汽车、手机、平板、物联网设备等多种智能终端的OTA升级。' },
                    { type: 'bigTitle', value: '核心优势' },
                    { type: 'text', value: '(1)高并发能力：支持千万级设备接入，1W+设备并行下载，升级效率行业领先。' },
                    { type: 'text', value: '(2)高可靠性：具备断点续传、程序回滚、多分区升级等功能，升级成功率99.9%以上。' },
                    { type: 'text', value: '(3)灵活部署：支持公有云、私有云、混合云等多种部署方式，满足不同客户需求。' },
                    { type: 'text', value: '(4)完整合规：通过OMA-DM标准认证，满足车联网安全要求。' },
                    { type: 'bigTitle', value: '应用场景' },
                    { type: 'text', value: '整车OTA、ECU升级、车载系统升级、手机系统升级、物联网设备升级' },
                ]
            }
        },
        {
            pageName: "产品测试服务",
            dataId: "service-2-1",
            data: {
                routerList: ["服务", "专业测试服务", "产品测试服务"],
                topImg: require("../assets/img/banner3.webp"),
                topFont: [
                    { fontSize: 'normal', value: "产品测试服务" },
                ],
                content: [
                    { type: 'title', value: '产品测试服务' },
                    { type: 'text', value: '产品测试是保证产品质量的重要环节，我们提供全方位的测试服务，从功能测试、性能测试到安全测试，帮助客户发现并解决产品缺陷，提升产品质量和用户体验。' },
                    { type: 'bigTitle', value: '服务内容' },
                    { type: 'text', value: '(1)功能测试：提供完整的功能测试服务，包括单元测试、集成测试、系统测试、验收测试等，确保产品功能符合需求。' },
                    { type: 'text', value: '(2)性能测试：提供压力测试、负载测试、稳定性测试等服务，评估产品在高并发、大数据量场景下的表现。' },
                    { type: 'text', value: '(3)兼容性测试：提供多平台、多浏览器、多设备的兼容性测试服务，确保产品在不同环境下正常运行。' },
                    { type: 'text', value: '(4)安全测试：提供漏洞扫描、渗透测试、代码审计等服务，发现并修复安全隐患。' },
                    { type: 'bigTitle', value: '核心优势' },
                    { type: 'text', value: '(1)专业测试团队：拥有100+名测试工程师，平均从业经验5年以上，具备丰富的测试经验。' },
                    { type: 'text', value: '(2)完善测试流程：建立标准化的测试流程和质量管理体系，确保测试质量。' },
                    { type: 'text', value: '(3)自动化测试：采用自动化测试工具和框架，提高测试效率，缩短测试周期。' },
                    { type: 'text', value: '(4)快速响应：提供7x24小时测试服务，紧急需求24小时内响应。' },
                    { type: 'bigTitle', value: '应用场景' },
                    { type: 'text', value: '软件产品测试、硬件产品测试、系统集成测试、移动应用测试、Web应用测试' },
                ]
            }
        },
        {
            pageName: "应用系统服务",
            dataId: "service-2-2",
            data: {
                routerList: ["服务", "专业测试服务", "应用系统服务"],
                topImg: require("../assets/img/banner3.webp"),
                topFont: [
                    { fontSize: 'normal', value: "应用系统服务" },
                ],
                content: [
                    { type: 'title', value: '应用系统服务' },
                    { type: 'text', value: '应用系统是企业数字化转型的核心载体，我们提供从需求分析、系统设计、开发实施到运维支持的全生命周期服务，帮助客户构建高效、稳定、安全的应用系统。' },
                    { type: 'bigTitle', value: '服务内容' },
                    { type: 'text', value: '(1)企业应用开发：提供ERP、CRM、OA、HR等企业级应用系统的定制开发服务，满足企业个性化需求。' },
                    { type: 'text', value: '(2)移动应用开发：提供iOS、Android、小程序等移动应用开发服务，覆盖主流移动平台。' },
                    { type: 'text', value: '(3)Web应用开发：提供企业官网、电商平台、SaaS平台等Web应用开发服务，支持高并发访问。' },
                    { type: 'text', value: '(4)系统集成服务：提供多系统集成、数据迁移、接口开发等服务，打通信息孤岛。' },
                    { type: 'bigTitle', value: '核心优势' },
                    { type: 'text', value: '(1)技术实力雄厚：掌握Java、Python、Node.js、Go等多种开发技术，能够满足不同技术栈需求。' },
                    { type: 'text', value: '(2)丰富行业经验：在金融、医疗、教育、制造等多个行业拥有成功案例，深入了解行业特性。' },
                    { type: 'text', value: '(3)敏捷开发模式：采用Scrum敏捷开发方法，快速响应需求变化，缩短交付周期。' },
                    { type: 'text', value: '(4)完善售后支持：提供7x24小时技术支持，快速响应并解决客户问题。' },
                    { type: 'bigTitle', value: '应用场景' },
                    { type: 'text', value: '企业管理系统、业务系统、数据平台、移动应用、Web应用' },
                ]
            }
        },
        {
            pageName: "移动终端自动化测试平台",
            dataId: "service-2-3",
            data: {
                routerList: ["服务", "专业测试服务", "移动终端自动化测试平台"],
                topImg: require("../assets/img/banner3.webp"),
                topFont: [
                    { fontSize: 'normal', value: "移动终端自动化测试平台" },
                ],
                content: [
                    { type: 'title', value: '移动终端自动化测试平台' },
                    { type: 'text', value: '移动终端自动化测试平台是专为移动应用测试打造的智能化测试平台，通过自动化测试技术和云端设备管理，大幅提升测试效率，降低测试成本，保证移动应用质量。' },
                    { type: 'bigTitle', value: '平台功能' },
                    { type: 'text', value: '(1)设备管理：支持云端管理数百台真机设备，覆盖iOS、Android主流机型，支持设备预约、远程控制、设备监控等功能。' },
                    { type: 'text', value: '(2)自动化测试：提供UI自动化测试、接口测试、性能测试等多种自动化测试服务，支持脚本录制和回放。' },
                    { type: 'text', value: '(3)兼容性测试：一键发起多设备兼容性测试，自动生成测试报告，快速发现兼容性问题。' },
                    { type: 'text', value: '(4)性能监控：实时监控应用性能指标，包括启动时间、内存占用、CPU使用率、网络流量等。' },
                    { type: 'bigTitle', value: '核心优势' },
                    { type: 'text', value: '(1)高效便捷：支持7x24小时自动化测试，测试效率提升10倍以上。' },
                    { type: 'text', value: '(2)覆盖全面：设备库覆盖200+主流机型，覆盖率达95%以上。' },
                    { type: 'text', value: '(3)智能分析：AI驱动的测试分析引擎，自动识别异常，智能定位问题。' },
                    { type: 'text', value: '(4)灵活部署：支持公有云、私有云、本地部署等多种部署方式。' },
                    { type: 'bigTitle', value: '应用场景' },
                    { type: 'text', value: '移动应用测试、游戏测试、兼容性测试、性能测试、回归测试' },
                ]
            }
        },

    ])

//获取详情信息
export function getDetailData(dataId) {
    let data = detailDataList.value.find(item => item.dataId === dataId) || null;
    return data.data
}


//路由跳转
export function routerTo(path, data) {
    router.push({
        path: path,
        query: data
    }
    )
    return
}